// All Payment Section Info --------------------------------

import { EvpKDF } from "crypto-js";

var hasFullParams = false;
var IsAlreadyLoad = false;

var UserIDPayment;
var PaymentBookingID;

var CurrentIDVoucher = "";
var CurrentRefferral = "";

var StepNameCurrent = "";
var StepNamePrev = [];

window.TransactionID = "";
window.ContinueBookingRef = null;

// Data After GET POST ----------------------------

var UserDataPaymentForm = null;

window.HotelDetails = null;
window.FormPaymentHotelData = null;

window.RoomPingDataCheck = null;

window.PushbookingData = null;
window.VARequestData = null;
window.GetDirectTransferData = null;

window.CheckPaymentData = [];

window.WhichPaymentBankSelected = null;
window.WhichPaymentTypeSelected = null;

// Data After GET POST ----------------------------

var OriginalPriceCalculated;
var PayAtHotelDisc;
var PayAtHotelPriceCalculated;
var DiscountCutCalculated;
var DownPaymentPriceCalculated;
var FinalPriceCalculatedAfterVouc;

var BookForOthers = 'Me';
var OtherUserName = null;
var OtherCountryCode = null;
var OtherCountryName = null;
var OtherIDCard = null;

// Top Progress ----------------------------------

var Step1TopContainer;
var Step2TopContainer;
var Step3TopContainer;

// Main Container and Wrapper --------------------

var PaymentSectionMainWrapper;
var PaymentLeftSection;
var PaymentRightSection;
var FinalResultMainContainer;

// Left Panel -----------------------------------

var InputInfoPaymentContainer;
var SelectPaymentContainer;
var CountdownWaitPaymentContainer;
var BluInputPhoneContainer;
var CreditCardWaitingContainer;

// Other Items ----------------------------------

var MainHeaderTextPayment;
var CountDownPaymentText;
var CountDownCardPaymentText;
var VANumberPriceWaitingPayment;
var BluAccountNumberText;
var RefreshHyperlinkButton;
var RealBackArrowPayment;

// Basic Payment UI ----------------------------------------

var FirstNameContainer;
var FirstNameInput;
var FirstNameWarningText;

var LastNameContainer;
var LastNameInput;
var LastNameWarningText;

var EmailContainer;
var EmailInput;
var EmailWarningText;

var CountryCodeContainer;
var CountryCodeText;

var PhoneNumberContainer;
var PhoneNumberInput;
var PhoneNumberWarning;

var CountryDropDownContainer;
var CountryIcon;
var CountryText;
var CountryToggleArrow;
var CountryWarning;

var IDCardContainer;
var IDCardInput;
var IDCardWarning;

var BookingForSomeoneCheckBox; // Booking Others -----

var FullNameBookingOthersContainer;
var FullNameBookingOthersInput;
var FullNameBookingOthersWarning;

var CountryBookingOthersContainer;
var CountryBookingOthersIcon;
var CountryBookingOthersText;
var CountryBookingOthersToggleArrow;
var CountryBookingOthersWarning;

var IDCardBookingOthersContainer;
var IDCardBookingOthersInput;
var IDCardBookingOthersWarning;

var IsSmokingCheckBoxes; // Smoking -----
var IsSmokingChecked;

var BreakfastIncludeContainer;

var ReferralContainer;
var ReferralInput;
var ReferralWarningIcon;
var ReferralWarningText;
var ApplyReferralButton;

var VoucherContainer;
var VoucherInput;
var VoucherWarningIcon;
var VoucherWarningText;
var ApplyVoucherButton;

var NextChoosePaymentButton;

var PaymentAccountNumberText;

var PaymentChooseForm;
var PaymentMethodButton;

// Right section ------------------------------

var SummarizedOriginalPriceContainer;

var RoomQuotaDropDown;
var RoomTypeTextPaymentRight;
var ExperienceOptionRightDisplayText;
var RoomTypeWarningTextPaymentRight;

var PriceGreyLoading;
var TextToDisplayAfterCalc;
var DownPaymentPercText;

var OriginalPriceContainer;
var YouSavedContainer;

var HowManyNightText;
var OriginalPriceText;

var GuestNameText;
var GuestEmailText;
var GuestPhoneNumberText;

// Credit ------------------------------------

var WarningCreditCardError;
var WarningCreditCardErrorText;

var CreditCardInputFieldContainer;
var CreditCardInputField;
var CreditCardInputWarning;

var ExpirationDateInputContainer;
var ExpirationDateInputField;
var ExpirationDateInputWarning;

var SafetyCodeInputFieldContainer;
var SafetyCodeInputField;
var SafetyCodeWarningText;

var CardHolderNameInputFieldContainer;
var CardHolderNameInputField;
var CardHolderNameWarningText;

var ContinuePaymentCreditCardButton;

// Blu ----------------------------------------

// var BluPaymentCountryCode;
// var BluPaymentCountryCodeText;
var BluPaymentPhoneNumberContainer;
var BluPaymentPhoneNumber;
var BluPaymentPhoneNumberWarning;
var BluPaymentPhoneNumberWarningText;
var RequestBluPaymentButton;

var SmokePreferenceChoiceContainer;


window.PreparePaymentForm = function()
{
    // ------------------------- CHECK IF PARAM COMPLETE --------------------------------

    let CurrentUrl = new URL(window.location.href);
    let param = new URLSearchParams(CurrentUrl.search.slice(1));

    let hasBookingId = param.has('id_booking');
    if(hasBookingId == true)
        window.ContinueBookingRef = CurrentUrl.searchParams.get("id_booking");

    hasFullParams =
        param.has('id_hotel') &&
        param.has('search') &&
        param.has('id_hotel_room') &&
        param.has('room') &&
        param.has('slug');
    
    if(!hasBookingId && !hasFullParams)
    {
        window.location.href = "/";
        return;
    }

    if(param.has('expin'))
    {
        let StringifyExpInput = decodeURIComponent(CurrentUrl.searchParams.get("expin"));
        window.CurrentUserInputExperienceAddOns = window.StringToJSON(StringifyExpInput);
        console.log("window.CurrentUserInputExperienceAddOns", window.CurrentUserInputExperienceAddOns);
        // const jsonString = JSON.stringify(window.CurrentUserInputExperienceAddOns);
        // const encodedJSON = decodeURIComponent(jsonString);
    }

    // if((param.has('id_hotel') == false || param.has('search') == false || param.has('id_hotel_room') == false || param.has('room') == false || param.has('slug') == false))
    // {
    //     window.location.href = "/";
    //     return;
    // }

    // ------------------------- SET LANGUAGE UI --------------------------------

    if(document.getElementById("OrangeSignInMessageTop") != null)
    document.getElementById("OrangeSignInMessageTop").innerHTML = window["OrangeMessagePaymentDetailsTopTxt" + window.CurrentCountryID];

    document.getElementById("FirstNameHeaderTextPayment").innerHTML = window["FirstNameTxt" + window.CurrentCountryID];
    document.getElementById("LastNameHeaderTextPayment").innerHTML = window["LastNameTxt" + window.CurrentCountryID];
    document.getElementById("EmailHeaderTextPayment").innerHTML = window["EmailTxt" + window.CurrentCountryID];
    document.getElementById("PhoneNumberHeaderTextPayment").innerHTML = window["PhoneNumberHeaderTxt" + window.CurrentCountryID];
    document.getElementById("CountryHeaderTextPayment").innerHTML = window["CountryHeaderTxt" + window.CurrentCountryID];
    document.getElementById("IDCardHeaderTextPayment").innerHTML = window["IDCardHeaderTxt" + window.CurrentCountryID];

    document.getElementById("BookingForSomeoneElseHeaderText").innerHTML = window["BookingForSomeoneTxt" + window.CurrentCountryID];
    document.getElementById("OthersFullNameHeaderText").innerHTML = window["FullNameTxt" + window.CurrentCountryID];
    document.getElementById("OthersCountryHeaderText").innerHTML = window["CountryHeaderTxt" + window.CurrentCountryID];
    document.getElementById("OthersIDCardHeaderText").innerHTML = window["IDCardPassportTxt" + window.CurrentCountryID];

    document.getElementById("RoomPreferenceHeaderText").innerHTML = window["RoomsPreferenceTxt" + window.CurrentCountryID];
    document.getElementById("NonSmokingRoomChoiceText").innerHTML = window["NonSmokingRoomTxt" + window.CurrentCountryID];
    document.getElementById("SmokingRoomChoiceText").innerHTML = window["SmokingRoomTxt" + window.CurrentCountryID];

    document.getElementById("BreakfastIncludeMessageText").innerHTML = window["BreakfastIncludeTxt" + window.CurrentCountryID];

    document.getElementById("AddOnHeaderText").innerHTML = window["AddOnHeaderTxt" + window.CurrentCountryID];
    document.getElementById("AddOnTotalHeaderText").innerHTML = window["TotalTambahanTxt" + window.CurrentCountryID];

    document.getElementById("ReferralPaymentHeaderText").innerHTML = "<span class='InterBoldTextFont'>" + window["ReferralTxt" + window.CurrentCountryID] + "</span> (" + window["OptionalTxt" + window.CurrentCountryID] + ")";
    document.getElementById("ReferralPaymentMessageText").innerHTML = window["InputReferralCodeMesTxt" + window.CurrentCountryID];

    document.getElementById("DoYouHaveVoucherHeaderText").innerHTML = window["DoYouHaveVoucherTxt" + window.CurrentCountryID];
    document.getElementById("ApplyVoucherCodeToMessageText").innerHTML = window["ApplyVoucherMessageTxt" + window.CurrentCountryID];

    document.getElementById("QrisPaymentText").innerHTML = window["QRISTxt" + window.CurrentCountryID];
    document.getElementById("BluPaymentText").innerHTML = window["BLUTxt" + window.CurrentCountryID];
    document.getElementById("BankINAText").innerHTML = window["BankINATxt" + window.CurrentCountryID];
    document.getElementById("BankINADescText").innerHTML = window["BankINADescriptionTxt" + window.CurrentCountryID];

    let YourPingPoinHeaderText = document.querySelectorAll('.YourPingPoinHeaderText');
    YourPingPoinHeaderText.forEach(ThisText =>
    {
        ThisText.innerHTML = window["YourPingPoinTxt" + window.CurrentCountryID];
    });

    let UsePingPoinToPayButtonText = document.querySelectorAll('.UsePingPoinToPayButtonText');
    UsePingPoinToPayButtonText.forEach(ThisText =>
    {
        ThisText.innerHTML = window["UsePingPoinToPayTxt" + window.CurrentCountryID];
    });

    document.getElementById("ByProceedingMessageText").innerHTML = window["ByProceedingMessageTxt" + window.CurrentCountryID];

    let TotalTextPaymentSection = document.querySelectorAll('.TotalTextPaymentSection');
    TotalTextPaymentSection.forEach(ThisText =>
    {
        ThisText.innerHTML = window["TotalTxt2" + window.CurrentCountryID];
    });

    let TotalPaymentTextPaymentSection = document.querySelectorAll('.TotalPaymentTextPaymentSection');
    TotalPaymentTextPaymentSection.forEach(ThisText =>
    {
        ThisText.innerHTML = window["TotalPaymentTxt" + window.CurrentCountryID];
    });

    let AboutPaymentText = document.querySelectorAll('.AboutPaymentText');
    AboutPaymentText.forEach(ThisText =>
    {
        ThisText.innerHTML = window["AboutPaymentPaymentSecHeaderTxt" + window.CurrentCountryID];
    });

    let DownPaymentChargedMessageText = document.querySelectorAll('.DownPaymentChargedMessageText');
    DownPaymentChargedMessageText.forEach(ThisText =>
    {
        ThisText.innerHTML = window["DownPaymentAgreeMessageTxt" + window.CurrentCountryID];
    });

    document.getElementById("AnAdditionalHeaderMessageText").innerHTML = window["AnAdditionalWillBePaidTxt" + window.CurrentCountryID];

    document.getElementById("InstantPaymentHeaderText").innerHTML = window["InstantPaymentTxt" + window.CurrentCountryID];
    document.getElementById("DigitalPaymentHeaderText").innerHTML = window["DigitalPaymentTxt" + window.CurrentCountryID];
    document.getElementById("CreditCardHeaderText").innerHTML = window["CreditCardHeaderTxt" + window.CurrentCountryID];
    document.getElementById("DirectTransferHeaderText").innerHTML = window["DirectTransferTxt" + window.CurrentCountryID];
    document.getElementById("VirtualAccountHeaderText").innerHTML = window["VirtualAccountTxt" + window.CurrentCountryID];
    
    document.getElementById("ConfirmNPayButton").innerHTML = window["ConfirmNPayButtonTxt" + window.CurrentCountryID];

    let PleaseCompletePaymentWithinText = document.querySelectorAll('.PleaseCompletePaymentWithinText');
    PleaseCompletePaymentWithinText.forEach(ThisText =>
    {
        ThisText.innerHTML = window["PleaseCompletePayTxt" + window.CurrentCountryID];
    });

    document.getElementById("AccountNumberHeaderText").innerHTML = window["AccountNumberTxt" + window.CurrentCountryID];

    document.getElementById("BluAccountFinalHeaderText").innerHTML = window["bluAccountHeaderTxt" + window.CurrentCountryID];

    document.getElementById("VirtualAccountNumberFinalHeaderText").innerHTML = window["VirtualAccountNumberHeaderTxt" + window.CurrentCountryID];

    let TotalDPToBePaidFinalText = document.querySelectorAll('.TotalDPToBePaidFinalText');
    TotalDPToBePaidFinalText.forEach(ThisText =>
    {
        ThisText.innerHTML = window["TotalBookingToBePaidTxt" + window.CurrentCountryID];
    });

    document.getElementById("NoHandphoneTerdaftarBluHeaderText").innerHTML = window["NoHandphoneTerdaftarBluTxt" + window.CurrentCountryID];
    
    document.getElementById("StepTopText1").innerHTML = window["Step1PaymentTxt" + window.CurrentCountryID];
    document.getElementById("StepTopText2").innerHTML = window["Step2PaymentTxt" + window.CurrentCountryID];
    document.getElementById("StepTopText3").innerHTML = window["Step3PaymentTxt" + window.CurrentCountryID];

    // Credit Card --------------------------------------------------------

    document.getElementById("WarningWeProtectPrivacyCardPayment").innerHTML = window["WeProtectYourPrivacy2Txt" + window.CurrentCountryID];
    
    // document.getElementById("CreditCardNumberHeaderText").innerHTML = window["ExpiryDateTxt" + window.CurrentCountryID];
    // document.getElementById("CreditCardInputField").placeholder = window["ExampleCrefitCardInputTxt" + window.CurrentCountryID];

    // document.getElementById("ExpirationDateHeaderText").innerHTML = window["CardNumberTxt" + window.CurrentCountryID];

    // document.getElementById("SafetyCodeHeaderText").innerHTML = window["SafetyCodeHeaderTxt" + window.CurrentCountryID];

    // document.getElementById("CardHolderNameHeaderText").innerHTML = window["CardHolderNameTxt" + window.CurrentCountryID];
    // document.getElementById("CardHolderNameInputField").placeholder = window["CardHolderInputFieldTxt" + window.CurrentCountryID];

    document.getElementById("ContinuePaymentCreditCardButton").innerHTML = window["ContinuePaymentBtnTxt" + window.CurrentCountryID];

    // QRIS --------------------------------------------------------

    document.getElementById("ShowQRISButtonText").innerHTML = window["TampilkanQRISTxt" + window.CurrentCountryID];

    // Step And Rule Based on Payment Method ------------------------------

    let StepForDirect = document.getElementById("PaymentSteporRulesContainerDirectTransfer");
    StepForDirect.innerHTML = "";
    let WhichStepDirectList = window.StepRuleDirect[window.CurrentCountryID];
    WhichStepDirectList.forEach(ThisStep =>
    {
        let ThisStepLi = document.createElement("li");
        ThisStepLi.className = "DottedCounterLiBig";
        StepForDirect.append(ThisStepLi); 

        let ThisStepP = document.createElement("p");
        ThisStepP.className = "LabelGreyHeaderSmallerText2 InterRegularTextFont";
        ThisStepP.innerHTML = ThisStep;
        ThisStepLi.append(ThisStepP);
    });

    let StepForQRIS = document.getElementById("PaymentSteporRulesContainerQRIS");
    StepForQRIS.innerHTML = "";
    
    let QRISHeaderFirst = document.createElement("p");
    QRISHeaderFirst.className = "LabelGreyHeaderSmallerText2 InterRegularTextFont";
    QRISHeaderFirst.innerHTML = window["CaraBayarviaQRISTxt" + window.CurrentCountryID];
    StepForQRIS.append(QRISHeaderFirst);

    let WhichStepQRISList = window.StepRuleQRIS[window.CurrentCountryID];
    WhichStepQRISList.forEach(ThisStep =>
    {
        let ThisStepLi = document.createElement("li");
        ThisStepLi.className = "DottedCounterLiBig";
        StepForQRIS.append(ThisStepLi);

        let ThisStepP = document.createElement("p");
        ThisStepP.className = "LabelGreyHeaderSmallerText2 InterRegularTextFont";
        ThisStepP.innerHTML = ThisStep;
        ThisStepLi.append(ThisStepP);
    });

    let StepForBlu = document.getElementById("PaymentSteporRulesContainerBlu");
    StepForBlu.innerHTML = "";
    let WhichStepBluList = window.StepRuleBlu[window.CurrentCountryID];
    WhichStepBluList.forEach(ThisStep =>
    {
        let ThisStepLi = document.createElement("li");
        ThisStepLi.className = "DottedCounterLiBig";
        StepForBlu.append(ThisStepLi);

        let ThisStepP = document.createElement("p");
        ThisStepP.className = "LabelGreyHeaderSmallerText2 InterRegularTextFont";
        ThisStepP.innerHTML = ThisStep;
        ThisStepLi.append(ThisStepP);
    });

    // ------------------------- SET TOP SEARCH INFO --------------------------------

    if(hasFullParams == true)
    {
        window.SetUpTopDateQuotaSearch(false);
        window.SearchInfo = CurrentUrl.searchParams.get("search");
        window.HotelID = parseInt(CurrentUrl.searchParams.get("id_hotel"));
        window.HotelSlug = CurrentUrl.searchParams.get("slug");
        window.CurrentSelectedRoomID = parseInt(CurrentUrl.searchParams.get("id_hotel_room"));
        window.RoomQuotaNonTop = parseInt(CurrentUrl.searchParams.get("room"));
    }

    // ------------------------------------- TOP PROGRESS ----------------------------------------

    Step1TopContainer = document.getElementById("CurrentPaymentStep1");
    Step2TopContainer = document.getElementById("CurrentPaymentStep2");
    Step3TopContainer = document.getElementById("CurrentPaymentStep3");

    // ------------------------------------- TOP PROGRESS ----------------------------------------

    PaymentSectionMainWrapper = document.getElementById("PaymentSectionMainWrapper");
    PaymentLeftSection = document.getElementById("PaymentLeftSection");
    PaymentRightSection = document.getElementById("PaymentRightSection");

    // ------------------------------------- LEFT PAYMENT CONTAINER -------------------------------------

    InputInfoPaymentContainer = document.getElementById("PaymentLeftSection1");
    SelectPaymentContainer = document.getElementById("PaymentLeftSection2");
    CountdownWaitPaymentContainer = document.getElementById("PaymentLeftSection3");
    BluInputPhoneContainer = document.getElementById("PaymentLeftSection4");
    CreditCardWaitingContainer = document.getElementById("PaymentLeftSection5");

    // ------------------------------------- OTHER ITEM -------------------------------------

    MainHeaderTextPayment = document.getElementById("MainHeaderTextPayment");
    CountDownPaymentText = [...document.querySelectorAll('.CountDownPaymentText')];
    CountDownCardPaymentText = document.getElementById("CountDownCardPaymentText");
    VANumberPriceWaitingPayment = document.getElementById("VANumberPriceWaitingPayment");
    BluAccountNumberText = document.getElementById("BluAccountNumberText");
    RealBackArrowPayment = document.getElementById("RealBackArrowPayment");

    //--------------------------------------- PREPARE ALL PAYMENT FORM -----------------------------------

    FirstNameContainer = document.getElementById("FirstNamePaymentFormInputContainer");
    FirstNameInput = document.getElementById("FirstNamePaymentFormInput");
    FirstNameInput.placeholder = window["InputFirstNamePlaceholder" + window.CurrentCountryID];
    FirstNameWarningText = document.getElementById("FirstNamePaymentFormWarning");

    LastNameContainer = document.getElementById("LastNamePaymentFormInputContainer");
    LastNameInput = document.getElementById("LastNamePaymentFormInput");
    LastNameInput.placeholder = window["InputLastNamePlaceholder" + window.CurrentCountryID];
    LastNameWarningText = document.getElementById("LastNamePaymentFormWarning");

    EmailContainer = document.getElementById("EmailPaymentFormInputContainer");
    EmailInput = document.getElementById("EmailPaymentFormInput");
    EmailInput.placeholder = window["SampleEmailPlaceholder" + window.CurrentCountryID];
    EmailInput.setAttribute("previous-input", '');
    EmailInput.setAttribute("email-to-be-used", '');
    EmailWarningText = document.getElementById("EmailPaymentFormWarning");

    CountryCodeContainer = document.getElementById("PaymentFormCountryCode");
    CountryCodeText = document.getElementById("PaymentFormCountryCodeText");

    PhoneNumberContainer = document.getElementById("PhoneNumberPaymentFormInputContainer");
    PhoneNumberInput = document.getElementById("PhoneNumberPaymentFormInput");
    PhoneNumberInput.setAttribute("previous-input", '');
    PhoneNumberInput.setAttribute("phone-to-be-used", '');
    PhoneNumberWarning = document.getElementById("PhoneNumberPaymentFormWarning");

    CountryDropDownContainer = document.getElementById("CountryPaymentFormDropDownContainer");
    CountryIcon = document.getElementById("CountryFlagPaymentFormIcon");
    CountryText = document.getElementById("CountryPaymentFormText");
    CountryToggleArrow = document.getElementById("CountryPaymentFormToggleArrow");
    CountryWarning = document.getElementById("CountryPaymentFormWarning");

    IDCardContainer = document.getElementById("IDCardPaymentFormContainer");
    IDCardInput = document.getElementById("IDCardPaymentFormInput");
    IDCardInput.placeholder = window["IDCardInputPlaceholder" + window.CurrentCountryID];
    IDCardWarning = document.getElementById("IDCardPaymentFormWarning");

    // -------------------------------------- Booking for Someone --------------------------------------

    BookingForSomeoneCheckBox = document.getElementById("BookingForSomeoneCheckBox");

    FullNameBookingOthersContainer = document.getElementById("FullNameBookingForSomeoneContainer");
    FullNameBookingOthersInput = document.getElementById("FullNameBookingForSomeoneInput");
    FullNameBookingOthersInput.placeholder = window["InputFullNamePlaceholderTxt" + window.CurrentCountryID];
    FullNameBookingOthersWarning = document.getElementById("FullNameBookingOthersWarning");

    CountryBookingOthersContainer = document.getElementById("CountryDropDownBookingForOthers");
    CountryBookingOthersIcon = document.getElementById("CountryIconBookingForOthers");
    CountryBookingOthersText = document.getElementById("CountryTextBookingForOthers");
    CountryBookingOthersToggleArrow = document.getElementById("CountryToggleArrowBookingForOthers");
    CountryBookingOthersWarning = document.getElementById("CountryBookingOthersWarning");

    IDCardBookingOthersContainer = document.getElementById("IDCardContainerBookingForOthers");
    IDCardBookingOthersInput = document.getElementById("IDCardInputBookingForOthers");
    IDCardBookingOthersInput.placeholder = window["IDCardPassportInputPlaceholderTxt" + window.CurrentCountryID];
    IDCardBookingOthersWarning = document.getElementById("IDCardBookingOthersWarning");

    // ------------------------------------ Smoking Check Boxes ------------------------------------

    SmokePreferenceChoiceContainer = document.getElementById("SmokePreferenceChoiceContainer");
    IsSmokingCheckBoxes = document.querySelectorAll('[name="IsSmookingRoom"]');

    // ------------------------------------ Breakfast Include ------------------------------------

    BreakfastIncludeContainer = document.getElementById("BreakfastIncludeContainer");

    // ------------------------------------ Referral & Voucher ------------------------------------

    ReferralContainer = document.getElementById("ReferralPaymentFormContainer");
    ReferralInput = document.getElementById("ReferralPaymentFormInput");
    ReferralInput.placeholder = window["InputReferralCodePlaceholderTxt" + window.CurrentCountryID];
    ReferralWarningIcon = document.getElementById("InputReferralWarningIcon");
    ApplyReferralButton = document.getElementById("ApplyReferralButton");
    ApplyReferralButton.innerHTML = window["ApplyReferralBtnTxt" + window.CurrentCountryID];
    ReferralWarningText = document.getElementById("ReferralWarningText");

    VoucherContainer = document.getElementById("VoucherPaymentFormContainer");
    VoucherInput = document.getElementById("VoucherPaymentFormInput");
    VoucherInput.placeholder = window["InputVoucherCodePlaceholderTxt" + window.CurrentCountryID];
    VoucherWarningIcon = document.getElementById("InputVoucherWarningIcon");
    ApplyVoucherButton = document.getElementById("ApplyVoucherButton");
    ApplyVoucherButton.innerHTML = window["ApplyVoucherBtnTxt" + window.CurrentCountryID];
    VoucherWarningText = document.getElementById("VoucherWarningText");

    NextChoosePaymentButton = document.getElementById("NextChoosePaymentButton");
    NextChoosePaymentButton.innerHTML = window["NextChoosePaymentButtonTxt" + window.CurrentCountryID];

    PaymentAccountNumberText = document.getElementById("PaymentAccountNumberText");

    PaymentChooseForm = document.getElementById("PaymentChooseForm");
    PaymentMethodButton = document.querySelectorAll('.PaymentMethodButton');

    // RIGHT SECTION ==================================================================================

    SummarizedOriginalPriceContainer = document.querySelectorAll('.SummarizeOriginalPriceContainer');

    RoomQuotaDropDown = document.getElementById("RoomQuotaTypeDropDownContainer");
    RoomQuotaDropDown.setAttribute("room-quota", window.RoomQuotaNonTop);

    RoomTypeTextPaymentRight = document.getElementById("RoomTypePaymentFormRightText");
    ExperienceOptionRightDisplayText = document.getElementById("ExperienceOptionRightDisplayText");
    RoomTypeWarningTextPaymentRight = document.getElementById("RoomTypeWarningPaymentFormRightText");

    PriceGreyLoading = document.querySelectorAll('.PriceGreyLoading');
    TextToDisplayAfterCalc = document.querySelectorAll('.TextToDisplayAfterCalc');
    DownPaymentPercText = document.querySelectorAll('.DownPaymentPercText');

    OriginalPriceContainer = document.querySelectorAll('.OriginalPriceContainer');
    YouSavedContainer = document.querySelectorAll('.YouSavedContainer');

    HowManyNightText = document.querySelectorAll('.HowManyNightText');
    OriginalPriceText = document.querySelectorAll('.OriginalPriceText');

    //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    GuestNameText = document.getElementById("GuestNameText");
    GuestEmailText = document.getElementById("GuestEmailText");
    GuestPhoneNumberText = document.getElementById("GuestPhoneNumberText");

    // CREDIT CARD SECTION =========================================================================

    WarningCreditCardError = document.getElementById("WarningCreditCardError");
    WarningCreditCardErrorText = document.getElementById("WarningCreditCardErrorText");

    CreditCardInputFieldContainer = document.getElementById("CreditCardInputFieldContainer");
    CreditCardInputField = document.getElementById("CreditCardInputField");
    CreditCardInputWarning = document.getElementById("CreditCardInputWarning");

    ExpirationDateInputContainer = document.getElementById("ExpirationDateInputContainer");
    ExpirationDateInputField = document.getElementById("ExpirationDateInputField");
    ExpirationDateInputWarning = document.getElementById("ExpirationDateInputWarning");

    SafetyCodeInputFieldContainer = document.getElementById("SafetyCodeInputFieldContainer");
    SafetyCodeInputField = document.getElementById("SafetyCodeInputField");
    SafetyCodeWarningText = document.getElementById("SafetyCodeWarningText");

    CardHolderNameInputFieldContainer = document.getElementById("CardHolderNameInputFieldContainer");
    CardHolderNameInputField = document.getElementById("CardHolderNameInputField");
    CardHolderNameWarningText = document.getElementById("CardHolderNameWarningText");

    ContinuePaymentCreditCardButton = document.getElementById("ContinuePaymentCreditCardButton");
    
    // BLU SECTION ==================================================================================

    // BluPaymentCountryCode = document.getElementById("BluPaymentCountryCode");
    // BluPaymentCountryCodeText = document.getElementById("BluPaymentCountryCodeText");
    BluPaymentPhoneNumberContainer = document.getElementById("BluPaymentPhoneNumberContainer");
    BluPaymentPhoneNumber = document.getElementById("BluPaymentPhoneNumber");
    BluPaymentPhoneNumberWarning = document.getElementById("BluPaymentPhoneNumberWarning");
    BluPaymentPhoneNumberWarningText = document.getElementById("BluPaymentPhoneNumberWarningText");
    RequestBluPaymentButton = document.getElementById("RequestBluPaymentButton");
    RequestBluPaymentButton.innerHTML = window["RequestBluPaymentBtnTxt" + window.CurrentCountryID];

    // REMOVE UNWANTER PAYMENT ==================================================================================
    let RemoveUnfinished = document.querySelectorAll('.RemoveUnfinished');
    RemoveUnfinished.forEach(ThisText =>
    {
        ThisText.remove();
    });

    // window.AnimatePanelNextTransition(null, InputInfoPaymentContainer, false, null);
}

window.SetFunctionPayment = function(MainSession, loggedin)
{
    // Set Date and Room Function ------------------------------------------

    window.CheckInNonTopInput.onclick = function()
    {
        window.OpenDateChoiceContainer('CheckInDateHotelDetailsInput', 'CheckOutDateHotelDetailsInput', '', 'Start', '', 1, false, false, true, true, true, true, ()=>window.GetPaymentInfoFromDatabase(null, MainSession, loggedin));
    };

    window.CheckOutNonTopInput.onclick = function()
    {
        window.OpenDateChoiceContainer('CheckOutDateHotelDetailsInput', 'CheckInDateHotelDetailsInput', '', 'End', '', 1, false, false, true, false, true, true, ()=>window.GetPaymentInfoFromDatabase(null, MainSession, loggedin));
    };

    //  -------------------------------------------------------------------------

    FirstNameInput.onfocus = function(event) // First Name --------------
    {
        FirstNameContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        FirstNameWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
        // NextChoosePaymentButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop ButtonUnselectable";
        ChangeNextChoosePaymentButton(false, MainSession, loggedin);
    }
    FirstNameInput.addEventListener("focusout", (event) =>
    {
        CheckPaymentInfoInputted(true, MainSession, loggedin);
    });


    LastNameInput.onfocus = function(event) // Last Name --------------
    {
        LastNameContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        LastNameWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
        // NextChoosePaymentButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop ButtonUnselectable";
        ChangeNextChoosePaymentButton(false, MainSession, loggedin);
    }
    LastNameInput.addEventListener("focusout", (event) =>
    {
        CheckPaymentInfoInputted(true, MainSession, loggedin);
    });


    EmailInput.onfocus = function(event) // Email --------------
    {
        EmailContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        EmailWarningText.className = "RedWarningText InterMediumTextFont RedWarningHidden";
        // NextChoosePaymentButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop ButtonUnselectable";
        ChangeNextChoosePaymentButton(false, MainSession, loggedin);
    }
    EmailInput.addEventListener("focusout", (event) =>
    {
        if(EmailInput.getAttribute("previous-input") != EmailInput.value)
        {
            EmailInput.setAttribute("previous-input", EmailInput.value);
            EmailInput.setAttribute("email-to-be-used", '');
        }
        CheckPaymentInfoInputted(true, MainSession, loggedin);
    });


    CountryCodeContainer.onclick = function() // Country Code --------------
    {
        window.OpenCountryCode(CountryCodeContainer, CountryCodeText, "PaymentForm", ()=> CheckPaymentInfoInputted(true));
    }


    PhoneNumberInput.onfocus = function(event) // Phone Number --------------
    {
        PhoneNumberContainer.className = "SmallPanelDropDownContainer";
        PhoneNumberWarning.className = "RedWarningText InterMediumTextFont RedWarningHidden";
        // NextChoosePaymentButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop ButtonUnselectable";
        ChangeNextChoosePaymentButton(false, MainSession, loggedin);
    }
    PhoneNumberInput.addEventListener("focusout", (event) =>
    {
        if(PhoneNumberInput.getAttribute("previous-input") != PhoneNumberInput.value)
        {
            PhoneNumberInput.setAttribute("previous-input", PhoneNumberInput.value);
            PhoneNumberInput.setAttribute("phone-to-be-used", '');
        }
        CheckPaymentInfoInputted(true, MainSession, loggedin);
    });


    CountryDropDownContainer.onclick = function() // Country --------------
    {
        window.OpenCountryChoice(CountryDropDownContainer, CountryIcon, CountryText, "CountryPaymentFormToggleArrow", "PaymentForm", ()=> CheckPaymentInfoInputted(true));
    }


    IDCardInput.onfocus = function(event) // ID Card --------------
    {
        IDCardContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        IDCardWarning.className = "RedWarningText InterMediumTextFont RedWarningHidden";
        // NextChoosePaymentButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop ButtonUnselectable";
        ChangeNextChoosePaymentButton(false, MainSession, loggedin);
    }
    IDCardInput.addEventListener("focusout", (event) =>
    {
        CheckPaymentInfoInputted(true, MainSession, loggedin);
    });
    

    // ------------------------ Booking for Someone Section ------------------------
    BookingForSomeoneCheckBox.onchange = function()
    {
        CheckPaymentInfoInputted(true, MainSession, loggedin);
    }


    FullNameBookingOthersInput.onfocus = function(event) // Full Name --------------
    {
        FullNameBookingOthersContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        FullNameBookingOthersWarning.className = "RedWarningText InterMediumTextFont RedWarningHidden";
        // NextChoosePaymentButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop ButtonUnselectable";
        ChangeNextChoosePaymentButton(false, MainSession, loggedin);
    }
    FullNameBookingOthersInput.addEventListener("focusout", (event) =>
    {
        CheckPaymentInfoInputted(true, MainSession, loggedin);
    });

    CountryBookingOthersContainer.onclick = function() // Country --------------
    {
        window.OpenCountryChoice(CountryBookingOthersContainer, CountryBookingOthersIcon, CountryBookingOthersText, "CountryToggleArrowBookingForOthers", "PaymentFormBookingOthers", ()=> CheckPaymentInfoInputted(true));
    }

    IDCardBookingOthersInput.onfocus = function(event) // ID Card --------------
    {
        IDCardBookingOthersContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        IDCardBookingOthersWarning.className = "RedWarningText InterMediumTextFont RedWarningHidden";
        // NextChoosePaymentButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop ButtonUnselectable";
        ChangeNextChoosePaymentButton(false, MainSession, loggedin);
    }
    IDCardBookingOthersInput.addEventListener("focusout", (event) =>
    {
        CheckPaymentInfoInputted(true, MainSession, loggedin);
    });

    // ------------------------ Is Smoking or Not ------------------------
    IsSmokingCheckBoxes.forEach(CheckBox =>
    {
        CheckBox.onclick = function()
        {
            CheckPaymentInfoInputted(true, MainSession, loggedin);
        }
    });


    // ------------------------ Is Smoking or Not ------------------------
    ReferralInput.onfocus = function(event) // Referral --------------
    {
        ReferralContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
        ReferralWarningIcon.style.display = "none";
        ReferralWarningText.className = "RedWarningText InterMediumTextFont WarningTextMarginTop RedWarningHidden";
        // NextChoosePaymentButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop ButtonUnselectable";
        ChangeNextChoosePaymentButton(false, MainSession, loggedin);
    }
    ReferralInput.addEventListener("focusout", (event) =>
    {
        CheckPaymentInfoInputted(true, MainSession, loggedin);
    });

    ApplyReferralButton.onclick = function()
    {
        CheckReferralValidity(MainSession, loggedin);
    }

    VoucherInput.onfocus = function(event) // Voucher --------------
    {
        VoucherContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
        VoucherWarningIcon.style.display = "none";
        VoucherWarningText.className = "RedWarningText InterMediumTextFont WarningTextMarginTop RedWarningHidden";
        // NextChoosePaymentButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop ButtonUnselectable";
        ChangeNextChoosePaymentButton(false, MainSession, loggedin);
    }
    VoucherInput.addEventListener("focusout", (event) =>
    {
        CheckPaymentInfoInputted(true, MainSession, loggedin);
    });

    ApplyVoucherButton.onclick = function()
    {
        CheckVoucherValidity(MainSession, loggedin);
    }

    // ------------------------ Is Smoking or Not ------------------------

    // BluPaymentCountryCode.onclick = function() // Country Code --------------
    // {
    //     window.OpenCountryCode(BluPaymentCountryCode, BluPaymentCountryCodeText, "BluPayment", ()=> CheckPaymentInfoInputted(true));
    // }


    BluPaymentPhoneNumber.onfocus = function(event) // Phone Number --------------
    {
        BluPaymentPhoneNumberContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
        BluPaymentPhoneNumberWarning.style.display = "none";
        RequestBluPaymentButton.className = "BasicTextButton BasicBoxShadow BluButton SignInButtonTop ButtonUnselectable";
    }


    // Set Early Hotel Details Mobile Check In - Out ----------------------------------------------------

    let ExtraMobileCheckInOutDateContainer = document.querySelectorAll(".ExtraMobileCheckInOutDateContainer");
    if(ExtraMobileCheckInOutDateContainer != null && ExtraMobileCheckInOutDateContainer.length > 0)
    {
        ExtraMobileCheckInOutDateContainer.forEach(thiscontainer =>
        {
            let ThisCheckInOutMobileButton = thiscontainer.querySelector(".ExtraMobileCheckInOutDateButton");
            ThisCheckInOutMobileButton.onclick = function()
            {
                let isallowmorethanone = true;
                if(window.ThisRoomData != null && window.ThisRoomData.book_type == "per day")
                    isallowmorethanone = false;

                window.InstantiateDateChoiceMobilePanel(()=>
                {
                    let NewCheckInYear;
                    let NewCheckInMonth;
                    let NewCheckInDay;

                    let NewCheckOutYear;
                    let NewCheckOutMonth;
                    let NewCheckOutDay;

                    if(window.ThisRoomData.book_type == "per night")
                    {
                        let NewUpdateCheckInDateInfo = window.CurrentSelectedCheckIn;

                        NewCheckInYear = NewUpdateCheckInDateInfo.getFullYear();
                        NewCheckInMonth = (NewUpdateCheckInDateInfo.getMonth() + 1);
                        NewCheckInDay = NewUpdateCheckInDateInfo.getDate();

                        let NewUpdateCheckOutDateInfo = window.CurrentSelectedCheckOut;

                        NewCheckOutYear = NewUpdateCheckOutDateInfo.getFullYear();
                        NewCheckOutMonth = (NewUpdateCheckOutDateInfo.getMonth() + 1);
                        NewCheckOutDay = NewUpdateCheckOutDateInfo.getDate();
                    }
                    else
                    {
                        NewCheckInYear = window.CurrentSelectedYearEdit;
                        NewCheckInMonth = window.CurrentSelectedMonthEdit;
                        NewCheckInDay = window.CurrentSelectedDayEdit;

                        let CurrentCheckOutDate = new Date(NewCheckInYear, NewCheckInMonth-1, NewCheckInDay);
                        CurrentCheckOutDate.setDate(CurrentCheckOutDate.getDate() + 1);

                        NewCheckOutYear = CurrentCheckOutDate.getFullYear();
                        NewCheckOutMonth = (CurrentCheckOutDate.getMonth() + 1);
                        NewCheckOutDay = CurrentCheckOutDate.getDate();
                    }

                    window.CheckInDateNonTop = NewCheckInYear + "-" + NewCheckInMonth + "-" + NewCheckInDay;
                    window.CheckInNonTopInput.setAttribute("Date", NewCheckInDay);
                    window.CheckInNonTopInput.setAttribute("Month", NewCheckInMonth);
                    window.CheckInNonTopInput.setAttribute("Year", NewCheckInYear);

                    window.CheckOutDateNonTop = NewCheckOutYear + "-" + NewCheckOutMonth + "-" + NewCheckOutDay;
                    window.CheckOutNonTopInput.setAttribute("Date", NewCheckOutDay);
                    window.CheckOutNonTopInput.setAttribute("Month", NewCheckOutMonth);
                    window.CheckOutNonTopInput.setAttribute("Year", NewCheckOutYear);
                    
                    window.GetPaymentInfoFromDatabase(null, MainSession, loggedin);

                },
                ()=>
                {

                }, true, isallowmorethanone);
            }
        });
    }

    // ====================================== CALL FUNCTION =============================================

    if(hasFullParams == true)
    {
        window.CurrentSelectedAccFacilitiesType = window.SelectedHotelDetailsFilter; // Set Early Selected Type------

        window.GetPaymentInfoFromDatabase(null, MainSession, loggedin);
        window.ChangeToSectionPaymentForm("Input Form", false, null);
    }
    
    window.GetUserInfoPaymentForm(MainSession, loggedin);
}

// ===================================== REFRESH CHECK IN AND OUT =====================================

function RefreshCheckInOut()
{
    let CheckInDate = window.CheckInNonTopInput.getAttribute("date");
    let CheckInMonth = window.CheckInNonTopInput.getAttribute("month");
    let CheckInYear = window.CheckInNonTopInput.getAttribute("year");
    let ThisCheckInDateToDisplay = CheckInDate + " " + window["monthNames" + window.CurrentCountryID][parseInt(CheckInMonth)-1] + " " + CheckInYear;
    window.CheckInDateNonTop = CheckInYear + "-" + CheckInMonth.toString().padStart(2, '0') + "-" + CheckInDate.toString().padStart(2, '0');

    let CheckOutDate = window.CheckOutNonTopInput.getAttribute("date");
    let CheckOutMonth = window.CheckOutNonTopInput.getAttribute("month");
    let CheckOutYear = window.CheckOutNonTopInput.getAttribute("year");
    let ThisCheckOutDateToDisplay = CheckOutDate + " " + window["monthNames" + window.CurrentCountryID][parseInt(CheckOutMonth)-1] + " " + CheckOutYear;
    window.CheckOutDateNonTop = CheckOutYear + "-" + CheckOutMonth.toString().padStart(2, '0') + "-" + CheckOutDate.toString().padStart(2, '0');

    window.RoomQuotaNonTop = RoomQuotaDropDown.getAttribute("room-quota");

    window.DifferenceBetweenDays = window.GetDateDifferences(new Date(CheckInYear, CheckInMonth-1, CheckInDate), new Date(CheckOutYear, CheckOutMonth-1, CheckOutDate));
}


// ===================================== GET USER INFO =====================================

window.GetUserInfoPaymentForm = function(MainSession, loggedin)
{
    if(loggedin == true)
    {
        let LoadUserTopBlocker = window.InstantiateLoadingBlocker("LoadUserTopBlocker");

        if(document.getElementById("SignInNotifPaymentForm") != null)
        document.getElementById("SignInNotifPaymentForm").remove();

        let ProfileUserURL = "/v2/profile/" + MainSession.usd_PING_id + "?token=" + MainSession.usd_PING_tkn;
        //console.log(ProfileUserURL);

        window.CallApiAxios({
            method: "GET",
            url: ProfileUserURL,
        })
        .then(res =>
        {
            if(res.status == 200)
            {
                let UserDataPaymentForm = res.data.data;
                // console.log(UserDataPaymentForm);

                // -------------------------------------------------------------------------------------
                if(UserDataPaymentForm.first_name)
                {
                    FirstNameInput.value = UserDataPaymentForm.first_name;
                    FirstNameInput.readOnly = true;
                    FirstNameContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldContainerInvalid";

                    LastNameInput.readOnly = true;
                    LastNameContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldContainerInvalid";
                }

                if(UserDataPaymentForm.last_name)
                {
                    LastNameInput.value = UserDataPaymentForm.last_name;
                }

                if(UserDataPaymentForm.email)
                {
                    EmailInput.value = UserDataPaymentForm.email;
                    EmailInput.setAttribute("previous-input", EmailInput.value);
                    EmailInput.setAttribute("email-to-be-used", EmailInput.value);
                    EmailInput.readOnly = true;
                    EmailContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldContainerInvalid";
                }

                if(UserDataPaymentForm.ktp_passport)
                {
                    IDCardInput.value = UserDataPaymentForm.ktp_passport;
                    IDCardInput.readOnly = true;
                    IDCardContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldContainerInvalid";
                }

                //--------------------------------

                let SelectedCountryCode = UserDataPaymentForm.country_code;
                let SelectedOriginCountry = UserDataPaymentForm.country;

                if(SelectedCountryCode == "" || SelectedCountryCode == null || SelectedCountryCode == "+")
                {
                    SelectedCountryCode = 62;
                }

                if(SelectedCountryCode)
                {
                    CountryCodeText.value = "+" + SelectedCountryCode; // Country Code Phone Number

                    CountryDropDownContainer.className = "SmallPanelDropDownContainer InputFieldContainerInvalid"; // Current Selected Country
                    CountryDropDownContainer.onclick = function(){};

                    for(let i = 0; i < window.CountryListCode.length; i++)
                    {
                        if(SelectedCountryCode == window.CountryListCode[i].CountryCode)
                        {
                            CountryCodeContainer.setAttribute("country-code", window.CountryListCode[i].CountryCode);
                            CountryCodeText.innerHTML = "+" + window.CountryListCode[i].CountryCode;
                        }

                        if(SelectedOriginCountry == window.CountryListCode[i].CountryName)
                        {
                            CountryIcon.src = window.CountryListCode[i].FlagIcon;
                            CountryText.innerHTML = window.CountryListCode[i].CountryName;
                            CountryDropDownContainer.setAttribute("country-selected", window.CountryListCode[i].CountryName);
                        }
                    }
                }

                if(UserDataPaymentForm.phone_number)
                {
                    PhoneNumberInput.value = UserDataPaymentForm.phone_number;
                    PhoneNumberInput.setAttribute("previous-input", UserDataPaymentForm.phone_number);
                    PhoneNumberInput.setAttribute("phone-to-be-used", UserDataPaymentForm.phone_number);
                    PhoneNumberInput.readOnly = true;
                    PhoneNumberContainer.className = "SmallPanelDropDownContainer InputFieldContainerInvalid";
                    CountryCodeContainer.onclick = function(){};
                }

                if(!UserDataPaymentForm.id_user || !UserDataPaymentForm.email || !UserDataPaymentForm.country_code || UserDataPaymentForm.country_code == "+" || !UserDataPaymentForm.phone_number || !UserDataPaymentForm.gender || !UserDataPaymentForm.first_name || !UserDataPaymentForm.last_name || !UserDataPaymentForm.ktp_passport)
                {
                    //!!!!!!!!!!!!!!!
                    InstantiateCompleteYourProfile(UserDataPaymentForm, MainSession.usd_PING_id, MainSession.usd_PING_tkn)
                }

                //console.log("This One Load From USERR");
                //window.LoadAccommodationFormData(null, MainSession, loggedin);
            }

            LoadUserTopBlocker.remove();
        })
        .catch(err =>
        {
            console.error(err);
            LoadUserTopBlocker.remove();
        });
    }
    else
    {
        window.LoadAccommodationFormData(null, MainSession, loggedin);
    }
}


// ===================================== GET PAYMENT INFO =====================================

window.GetPaymentInfoFromDatabase = function(callback, MainSession, loggedin)
{
    if(window.IsPanelAnimating == false)
    {
        window.IsPanelAnimating = true;

        ChangeNextChoosePaymentButton(false, MainSession, loggedin);

        // Refresh Check In and Out and Room Quota -------------------------------------------------------------------

        RefreshCheckInOut();

        // ----------------------------------------------- INSTANTIATE LOADING ----------------------------------------------------

        InstantiateLoadingPanel();

        console.log("window.ThisCurrentQuotaInput", window.ThisCurrentQuotaInput);
        console.log("window.RoomQuotaNonTop", window.RoomQuotaNonTop);

        // ------------------------------------------------------------------------------------------------------------------------
        window.LoadAccommodationDetails(null, ()=>
        {
            if(window.HotelDetails.id_hotel)
            {
                // ============================= LOAD ACCOMMODATION IMAGE =========================

                if(window.HotelPhotoList.length == 0)
                {
                    let UrlHotelPhoto = "/v2/hotels/" + window.HotelID + "/photos?page=1&limit=3";
                    let HotelImagePaymentInfoContainer = document.getElementById("HotelImagePaymentInfoContainer");

                    window.CallApiAxios({
                        method: "GET",
                        url: UrlHotelPhoto,
                    })
                    .then(res =>
                    {
                        console.log(UrlHotelPhoto);
                        console.log(res);

                        if(res.status == 200)
                        {
                            window.HotelPhotoList = res.data.data;
                            console.log(window.HotelPhotoList);

                            // Asign All Photo Into One -----------------------------------------

                            let SortAllFotoIntoOne = [];
                            for(let i = 0; i < window.HotelPhotoList.length; i++)
                            {
                                SortAllFotoIntoOne.push(window.HotelPhotoList[i].hotel_photo);
                            }

                            // Instantiate Loading And Image ------------------------------------

                            HotelImagePaymentInfoContainer.innerHTML = "";

                            let LoadingImageGrey = document.createElement("div");
                            LoadingImageGrey.className = "loading_grey ImageFullCover";
                            HotelImagePaymentInfoContainer.append(LoadingImageGrey);

                            let FunctionToCallAfterLoaded = function()
                            {
                                LoadingImageGrey.remove();
                            }

                            window.CheckAllImageRemoveEmptyAndWaitLoadCallFunc(SortAllFotoIntoOne, null, "/Assets/images/NoHotelImage.jpg", HotelImagePaymentInfoContainer, { quality: 70}, HotelImagePaymentInfoContainer, ()=>FunctionToCallAfterLoaded());
                        }
                    })
                    .catch(err =>
                    {
                        console.log(err);
                    });
                }

                // ============================= DISPLAY BASIC INFO ================================

                InstantiateBasicInformation(MainSession, loggedin);

                //============================== CALCULATE PAYMENT ================================

                console.log("This One Load From EARLY PAYMENT ====================");
                window.LoadAccommodationFormData(callback, MainSession, loggedin);
            }
            else
            {
                // window.location.href = "/";
                return;
            }
        },()=>{
            // window.location.href = "/";
            return;
        }, null);
    }
}

window.IsAddOnAvailable = [];

window.LoadAccommodationFormData = function(callback, MainSession, loggedin)
{
    let IDUserToSend = null;
    
    if(loggedin == true)
    {
        if(window.CurrentUserID != null)
        {
            IDUserToSend = window.CurrentUserID;
        }
        else
        {
            IDUserToSend = MainSession.usd_PING_id;
            window.CurrentUserID = MainSession.usd_PING_id;
        }
    }


    if(window.CheckInDateNonTop != null && window.CheckOutDateNonTop != null && window.RoomQuotaNonTop != null && window.CurrentSelectedRoomID != null)
    {
        let URLPaymentForm = "/v2/bookings/form/hotel-room";
        if(window.CurrentSelectedAccFacilitiesType == "Experiences")
            URLPaymentForm = "/v2/bookings/form/hotel-exp";

        window.CheckInDateNonTop = window.ConvertArrayedDateString(window.CheckInDateNonTop);
        window.CheckOutDateNonTop = window.ConvertArrayedDateString(window.CheckOutDateNonTop);
        
        let CheckOutToSend = window.CheckOutDateNonTop;
        if(window.CurrentSelectedRoomExpBookType == "per day")
           CheckOutToSend = null;
        

        let AddOnJSONData = SetAddOnJSON();
        let matchedRoom = window.IsAddOnAvailable.find(thisvar => thisvar.id_hotel_room === window.CurrentSelectedRoomID);

        if(window.IsAddOnAvailable.length === 0 || !matchedRoom) 
        {
            let DataToPush =
            {
                'id_hotel_room': window.CurrentSelectedRoomID,
                'add_on_available': true
            }

            window.IsAddOnAvailable.push(DataToPush);
        }
        else 
        {
            if(matchedRoom.add_on_available == false)
            {
                AddOnJSONData = [];
            }
        }


        let JSONLoadFormData = {};

        if(window.CurrentSelectedAccFacilitiesType == "Rooms") // For Rooms ----------------
        {
            JSONLoadFormData = 
            {
                "checkin": window.CheckInDateNonTop,
                "checkout": CheckOutToSend,
                "id_hotel_room": window.CurrentSelectedRoomID,
                "rooms": window.RoomQuotaNonTop,
                "voucher_code": CurrentIDVoucher,
                "referral_code": CurrentRefferral,
                "id_user": IDUserToSend,
                "add_ons": AddOnJSONData
            }
        }
        else // For Experience ------------------------------------------------------------
        {
            let ExperienceInput = window.CurrentUserInputExperienceAddOns.data_input;

            JSONLoadFormData = 
            {
                "date_visit": window.CheckInDateNonTop,
                "date_until": CheckOutToSend,
                "id_hotel_experience": window.CurrentSelectedRoomID,
                "voucher_code": CurrentIDVoucher,
                "referral_code": CurrentRefferral,
                "id_user": IDUserToSend,
                "add_ons": AddOnJSONData
            }

            if(Array.isArray(ExperienceInput)) // If with Options -----------------------
            {
                let FinalInputOptions = [];
                for(let i = 0; i < ExperienceInput.length; i++)
                {
                    if(ExperienceInput[i].quantity != 0 && ExperienceInput[i].quantity > 0)
                    {
                        FinalInputOptions.push
                        (
                            {
                                "id_hotel_experience_option":ExperienceInput[i].id,
                                "qty":ExperienceInput[i].quantity,
                            }
                        )
                    }

                }
                JSONLoadFormData.options = FinalInputOptions
            }
            else // If Without --------------------
            {
                JSONLoadFormData.quantity = ExperienceInput;
            }
        }

        window.CallApiAxios(
        {
            method: "POST",
            url: URLPaymentForm,
            data: JSONLoadFormData,
        })
        .then(res =>
        {
            console.log(URLPaymentForm);
            console.log(JSONLoadFormData);

            window.IsPanelAnimating = false;

            if(res.status == 200)
            {
                window.FormPaymentHotelData = res.data.data;
                console.log(window.FormPaymentHotelData);

                // Calculate Total Based On Room Ping -------------------------------
                CalculatePaymentFormSection(MainSession, loggedin);

                // Call Function -------------------------------------------------
                if(callback != null)
                    callback();

                // Get Add On Data -------------------------------------------------
                GetAddOnDataForm(MainSession, loggedin, JSONLoadFormData);
            }
        })
        .catch(err =>
        {
            console.log(URLPaymentForm);
            console.log(JSONLoadFormData);
            console.error(err);

            window.IsPanelAnimating = false;

            let matchedRoom = window.IsAddOnAvailable.find(thisvar => thisvar.id_hotel_room === window.CurrentSelectedRoomID);
            if(matchedRoom.add_on_available == true)
            {
                matchedRoom.add_on_available = false;
                window.LoadAccommodationFormData(callback, MainSession, loggedin);
            }
        });
    }
    else if(window.ContinueBookingRef != null)
    {
        window.IsPanelAnimating = false;
        ContinueBookingPrepare(MainSession, loggedin, IDUserToSend);
    }
    else
    {
        window.location.href = "/";
    }
}


// ===================================== SET ADD ON JSON ==================================

function SetAddOnJSON()
{
    let ThisAddOnData = AccRoomAddOnFormData.data_to_push;
    let AddOnJSONData = []

    if(ThisAddOnData.length > 0)
    {
        for(let i = 0; i < ThisAddOnData.length; i++)
        {
            if(ThisAddOnData[i].qty > 0)
            {
                let ThisAddOnToPush =
                {
                    "id_add_on": parseInt(ThisAddOnData[i].id_add_on),
                    "qty": parseInt(ThisAddOnData[i].qty)
                }
                AddOnJSONData.push(ThisAddOnToPush);
            }
        }
    }

    return AddOnJSONData;
}

// ===================================== GET ADD ON DATA ===================================

var AccRoomAddOnFormData =
{
    "id_room":null,
    "add_on_data":null,
    "data_to_push":[],
    "date_this_data":null
}

function GetAddOnDataForm(MainSession, loggedin, JSONLoadFormData)
{
    let CheckOutToSend = window.CheckOutDateNonTop;
    // if(window.ThisRoomData != null && window.ThisRoomData.book_type == "per day")
    //     CheckOutToSend = window.CheckInDateNonTop; 

    let ThisDateToCheck = window.CheckInDateNonTop + " " + CheckOutToSend;

    if(AccRoomAddOnFormData.id_room == null || AccRoomAddOnFormData.id_room != window.CurrentSelectedRoomID || ThisDateToCheck != AccRoomAddOnFormData.date_this_data)
    {
        let LoadUserTopBlocker = window.InstantiateLoadingBlocker("LoadUserTopBlocker");

        AccRoomAddOnFormData.id_room = window.CurrentSelectedRoomID;
        AccRoomAddOnFormData.date_this_data = ThisDateToCheck;

        let AddOnMainContainer = document.getElementById("AddOnMainContainer");
        AddOnMainContainer.style.display = "none";

        let GetAddOnURL = "/v2/rooms/" + window.CurrentSelectedRoomID + "/add-ons";
        if(window.CurrentSelectedAccFacilitiesType == "Experiences")
            GetAddOnURL = "/v2/hotel-experiences/" + window.CurrentSelectedRoomID + "/add-ons";


        window.CallApiAxios({
            method: "POST",
            url: GetAddOnURL,
            data: JSONLoadFormData,
        })
        .then(res =>
        {
            console.log(GetAddOnURL);
            console.log("JSONLoadFormData", JSONLoadFormData);

            if(res.status == 200)
            {
                let ThisAddOnData = res.data.data;
                console.log(ThisAddOnData);
                
                if(ThisAddOnData.length > 0)
                {
                    AddOnMainContainer.style.display = "";
                    AccRoomAddOnFormData.add_on_data = ThisAddOnData;
                    AccRoomAddOnFormData.data_to_push = [];

                    InstantiateAndRemoveAddOn(MainSession, loggedin);
                }
            }
            else
            {
                console.log(res);
            }
            LoadUserTopBlocker.remove();
        })
        .catch(err =>
        {
            console.log(GetAddOnURL);
            console.log("JSONLoadFormData", JSONLoadFormData);
            console.error(err);
            LoadUserTopBlocker.remove();
        });
    }
}


function InstantiateAndRemoveAddOn(MainSession, loggedin)
{
    let AddOnPanelContainer = document.getElementById("AddOnPanelContainer");
    AddOnPanelContainer.innerHTML = "";

    let ThisAddOnData = AccRoomAddOnFormData.add_on_data;
    console.log("ThisAddOnData", ThisAddOnData);

    if(ThisAddOnData != null)
    {
        for(let i = 0; i < ThisAddOnData.length; i++)
        {
            if(ThisAddOnData[i].is_fully_available == true)
            {
                // Declare First -------------------------
                let TotalPriceText;
                let AddAddOnButton;
                let AddedForNotForcedAddOnCheckBox;
                
                let DataForThisAddOn = ThisAddOnData[i].add_on.dates;
                let HowManyMax = 999;
                for(let j = 0; j < DataForThisAddOn.length; j++)
                {
                    if(DataForThisAddOn[j].stock_available != null && HowManyMax > DataForThisAddOn[j].stock_available)
                    {
                        HowManyMax = DataForThisAddOn[j].stock_available;
                    }
                }
                let AmountRequiredThisData = ThisAddOnData[i].is_required;
                let HowManyStart = 0;
                if(parseInt(AmountRequiredThisData) > 0) // Set Default Value if Must Add Least Not 0 ------------------
                    HowManyStart = parseInt(AmountRequiredThisData);

                /* ---------------------- Wrapper -------------------------------- */
                let TicketWrapper = document.createElement("div");
                TicketWrapper.className = "SearchTopNonIndexSection InputFieldMargin2";
                TicketWrapper.style.backgroundColor = "white";
                TicketWrapper.style.cursor = "auto";
                AddOnPanelContainer.append(TicketWrapper);

                let InnerWrapper = document.createElement("div");
                InnerWrapper.className = "SearchInputFieldTopBottomTextWrapper";
                TicketWrapper.append(InnerWrapper);


                /* ---------------------- Header -------------------------------- */
                let FacilityContainer = document.createElement("div");
                FacilityContainer.className = "FaciltyChildrenContainer InputFieldMargin3";
                InnerWrapper.append(FacilityContainer);

                let FacilityIcon = document.createElement("img");
                FacilityIcon.className = "FacilityIcon";
                FacilityIcon.src = ThisAddOnData[i].add_on.image_link;
                FacilityContainer.append(FacilityIcon);

                let FacilityText = document.createElement("p");
                FacilityText.className = "LabelGreyHeaderSmallerText2 InterBoldTextFont";
                FacilityText.style.margin = "auto 0";
                FacilityContainer.append(FacilityText);

                let AddOnName = ThisAddOnData[i].add_on["name_" + window.CurrentCountryID];
                if(AmountRequiredThisData != "0")
                    AddOnName = AddOnName + ' <span style="color: #c10000">*</span>';

                FacilityText.innerHTML = AddOnName;


                /* ---------------------- Description -------------------------------- */

                if(ThisAddOnData[i].add_on["desc_" + window.CurrentCountryID] != null  && ThisAddOnData[i].add_on["desc_" + window.CurrentCountryID].replace(/ /g, "") != "")
                {
                    let DescriptionBox = document.createElement("div");
                    DescriptionBox.className = "OrangeWarningContainer BasicRadius InputFieldMargin2";
                    DescriptionBox.style.display = "flex";
                    DescriptionBox.style.flexDirection = "row";
                    InnerWrapper.append(DescriptionBox);

                    let DescriptionText = document.createElement("p");
                    DescriptionText.className = "LabelGreyHeaderSmallerText InterRegularTextFont";
                    DescriptionText.style.margin = "auto 0";
                    DescriptionText.style.color = "#344054";
                    DescriptionText.innerHTML = ThisAddOnData[i].add_on["desc_" + window.CurrentCountryID];
                    DescriptionBox.append(DescriptionText);
                }

                /* ------------------------- Input Content ------------------------- */

                let InputSection = document.createElement("div");
                InputSection.className = "InputFieldMargin2";
                InputSection.style.flex = "1";
                InputSection.style.height = "fit-content";
                InputSection.style.flexDirection = "column";
                InnerWrapper.append(InputSection);

                let InputLabel = document.createElement("p"); // Header ------------------------------------
                InputLabel.className = "InputFieldHeaderText InterMediumTextFont InputFieldMargin4";
                if(ThisAddOnData[i].add_on.name_en == "Entrance Ticket")
                {
                    InputLabel.innerHTML = window["JumlahTamuTxt" + window.CurrentCountryID];
                }
                else
                {
                    InputLabel.innerHTML = window["TotalTxt" + window.CurrentCountryID] + ' ' + AddOnName;
                }
                InputSection.append(InputLabel);

                let RowContainer = document.createElement("div"); // Drop Down and Input ------------------------------------
                RowContainer.className = "RoomLocationContainerInsidePanel InputFieldMargin4";
                RowContainer.style.overflow = "visible";
                RowContainer.style.marginTop = 0;
                InputSection.append(RowContainer);

                let DropContainer = document.createElement("div");
                DropContainer.className = "SmallPanelDropDownContainer SmallWidthInputDropDownContainer";
                DropContainer.style.minWidth = "0";
                RowContainer.append(DropContainer);

                let DropWrapper = document.createElement("div");
                DropWrapper.className = "SmallPanelDropDownInputWrapper Selectable3 BasicInputFieldContainer InterMediumTextFont";
                DropWrapper.style.padding = "0";
                DropContainer.append(DropWrapper);

                let DropInput = document.createElement("input");
                DropInput.type = "number";
                DropInput.className = "InputFieldSelectable InputFieldInsideSmallPanel InterMediumTextFont";
                DropInput.placeholder = 0;
                DropInput.style.outline = 0;
                DropInput.style.paddingRight = 0;
                DropInput.value = HowManyStart;
                DropWrapper.append(DropInput);

                let ChevronInsideInputMargin = document.createElement("div");
                ChevronInsideInputMargin.className = "ChevronInsideInputMargin";
                DropWrapper.append(ChevronInsideInputMargin);

                let DropChevron = document.createElement("img");
                DropChevron.className = "ChevronInsideInput ToggleArrow Selectable2";
                DropChevron.src = "/Assets/images/ButtonIcon/chevron.svg";
                DropChevron.id = "AddOn" + i + "DropChevron";
                DropChevron.style.rotate = "0deg";
                ChevronInsideInputMargin.append(DropChevron);


                let MultiplyText = document.createElement("p"); // Price Each Info ------------------------------------
                MultiplyText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                MultiplyText.style.marginTop = "auto";
                MultiplyText.style.marginBottom = "auto";
                MultiplyText.innerHTML = "x";
                RowContainer.append(MultiplyText);

                let PriceWrapper = document.createElement("div");
                PriceWrapper.className = "Price1stWrapper";
                PriceWrapper.style.marginTop = "auto";
                PriceWrapper.style.marginBottom = "auto";
                RowContainer.append(PriceWrapper);

                if(ThisAddOnData[i].add_on.name_en == "Entrance Ticket")
                {
                    let PriceDesc = document.createElement("p");
                    PriceDesc.className = "SmallerRoomDescriptionText InterBoldTextFont";
                    PriceDesc.style.color = "#344054";
                    PriceDesc.innerHTML = window["HargaTiketMasukOrangDewasaTxt" + window.CurrentCountryID];
                    PriceWrapper.append(PriceDesc);
                }

                let PriceText = document.createElement("p");
                PriceText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                PriceText.innerHTML = window.ConvertTextToRP(ThisAddOnData[i].add_on.price, 1, false, false) + window.TypeItemTextDisplayer(ThisAddOnData[i].add_on.pricing_type);
                PriceWrapper.append(PriceText);

                /* ------------------------- Add Button ------------------------- */

                if(AmountRequiredThisData == "0")
                {
                    AddedForNotForcedAddOnCheckBox = document.createElement("input");
                    AddedForNotForcedAddOnCheckBox.type = "checkbox";
                    AddedForNotForcedAddOnCheckBox.style.display = "none";
                    AddedForNotForcedAddOnCheckBox.id = "AddOnCheckBox" + i;
                    RowContainer.append(AddedForNotForcedAddOnCheckBox);

                    AddAddOnButton = document.createElement("label");
                    AddAddOnButton.className = "BasicTextButton BasicBoxShadow SignInButtonTop Selectable ListingMitraButtons";
                    AddAddOnButton.htmlFor = "AddOnCheckBox" + i;
                    AddAddOnButton.style.background = "#039855";
                    RowContainer.append(AddAddOnButton);

                    let BtnInner = document.createElement("div");
                    BtnInner.style.width = "fit-content";
                    BtnInner.style.height = "fit-content";
                    BtnInner.style.display = "flex";
                    BtnInner.style.margin = "auto";
                    AddAddOnButton.append(BtnInner);

                    let AddOnButtonIcon = document.createElement("img");
                    AddOnButtonIcon.className = "BasicIconInsideButton";
                    AddOnButtonIcon.src = "/Assets/images/ButtonIcon/circle-plus-add-white.svg";
                    AddOnButtonIcon.style.marginLeft = "0px";
                    BtnInner.append(AddOnButtonIcon);

                    let AddOnButtonText = document.createElement("p");
                    AddOnButtonText.id = "ListYourAccBtnTxt";
                    AddOnButtonText.style.marginTop = "auto";
                    AddOnButtonText.style.marginBottom = "auto";
                    AddOnButtonText.style.color = "white";
                    AddOnButtonText.innerHTML = window["TambahkanTxt" + window.CurrentCountryID];
                    BtnInner.append(AddOnButtonText);

                    AddedForNotForcedAddOnCheckBox.onchange = function()
                    {
                        // Check If Input 0 then unchecked Again ----------------------------------------------------------------------------
                        if(DropInput.value <= 0)
                        {
                            AddedForNotForcedAddOnCheckBox.checked = false;
                            window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["CannotAddAddOnDueToAmountInputTxt" + window.CurrentCountryID]);
                        }

                        // Change The Button ------------------------------------------------------------------------------------------------
                        if(AddedForNotForcedAddOnCheckBox.checked == true)
                        {
                            AddOnButtonIcon.src = "/Assets/images/ButtonIcon/circle-check-white.svg";
                            AddOnButtonText.innerHTML = window["DitambahkanTxt" + window.CurrentCountryID];
                        }
                        else
                        {
                            AddOnButtonIcon.src = "/Assets/images/ButtonIcon/circle-plus-add-white.svg";
                            AddOnButtonText.innerHTML = window["TambahkanTxt" + window.CurrentCountryID];
                        }

                        CalculateAndUpdateAddOnData(true, MainSession, loggedin, ThisAddOnData[i], DropInput, AddedForNotForcedAddOnCheckBox, TotalPriceText);
                    }
                }

                /* ------------------------- Gratis For Children (Entry Ticket) ------------------------- */

                // if(ThisAddOnData[i].add_on.name_en == "Entrance Ticket")
                // {
                //     let GratisUntukUmurDibawahTahunText = document.createElement("p");
                //     GratisUntukUmurDibawahTahunText.className = "SmallerRoomDescriptionText InterRegularTextFont";
                //     GratisUntukUmurDibawahTahunText.style.color = "#667085";
                //     GratisUntukUmurDibawahTahunText.innerHTML = window["TicketFreeFor5YearsTxt" + window.CurrentCountryID];
                //     InputSection.append(GratisUntukUmurDibawahTahunText);
                // }
                if(ThisAddOnData[i].add_on["notes_" + window.CurrentCountryID] != null && ThisAddOnData[i].add_on["notes_" + window.CurrentCountryID].replace(/ /g, "") != "")
                {
                    let GratisUntukUmurDibawahTahunText = document.createElement("p");
                    GratisUntukUmurDibawahTahunText.className = "SmallerRoomDescriptionText InterRegularTextFont";
                    GratisUntukUmurDibawahTahunText.style.color = "#667085";
                    GratisUntukUmurDibawahTahunText.innerHTML = ThisAddOnData[i].add_on["notes_" + window.CurrentCountryID];
                    InputSection.append(GratisUntukUmurDibawahTahunText);
                }
                
                /* ------------------------- Total ------------------------- */

                let TotalWrapper = document.createElement("div");
                TotalWrapper.className = "PriceMainTextWrapper";
                InnerWrapper.append(TotalWrapper);

                let TotalLeft = document.createElement("div");
                TotalLeft.className = "Price1stWrapper";
                TotalWrapper.append(TotalLeft);

                let TotalLabel = document.createElement("p");
                TotalLabel.className = "LabelGreyHeaderSmallerText InterMediumTextFont TotalTextPaymentSection";
                TotalLabel.innerHTML = window["TotalHargaTxt" + window.CurrentCountryID] + " " + ThisAddOnData[i].add_on["name_" + window.CurrentCountryID];
                TotalLeft.append(TotalLabel);

                let TotalRight = document.createElement("div");
                TotalRight.className = "Price2ndWrapper";
                TotalWrapper.append(TotalRight);

                TotalPriceText = document.createElement("p");
                TotalPriceText.className = "LabelGreyHeaderSmallerText2 InterExBoldTextFont";
                TotalPriceText.style.color = "#ED7C42";
                TotalPriceText.setAttribute("rp-type", "1");
                TotalPriceText.setAttribute("final-zero", "true");
                TotalPriceText.innerHTML = "Rp 000.000,00";
                TotalRight.append(TotalPriceText);

                // --------------------- ADD FUNCTION -------------------------------

                let functiontocall = function()
                {
                    CalculateAndUpdateAddOnData(true, MainSession, loggedin, ThisAddOnData[i], DropInput, AddedForNotForcedAddOnCheckBox, TotalPriceText);
                }

                // Drop Down Chevron ------------------------------------
                DropChevron.onclick = function(event)
                {
                    // let Howm
                    window.InstantiateQuantityDropDown(event, DropContainer, "AddOn" + i + "DropChevron", HowManyStart, HowManyMax, DropInput, ()=>functiontocall());
                }

                // Input Field ------------------------------------
                DropInput.addEventListener("input", function ()
                {
                    this.value = this.value.replace(/[^0-9]/g, "");
                });
                DropInput.onfocus = function(event)
                {
                    ChangeNextChoosePaymentButton(false, MainSession, loggedin);
                }
                DropInput.addEventListener("focusout", (event) =>
                {
                    if(HowManyStart > DropInput.value || DropInput.value < 0)
                    {
                        DropInput.value = HowManyStart;
                        window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window.AddOnCanOnlyMinimum(HowManyStart));
                    }
                    else if(HowManyMax < DropInput.value)
                    {
                        DropInput.value = HowManyMax;
                        window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window.AddOnCanOnlyMaximum(HowManyMax));
                    }

                    functiontocall();
                });

                // Lastly Call Function ------------------------------------
                if(i == (ThisAddOnData.length-1))
                {
                    CalculateAndUpdateAddOnData(true, MainSession, loggedin, ThisAddOnData[i], DropInput, AddedForNotForcedAddOnCheckBox, TotalPriceText);
                }
                else
                {
                    CalculateAndUpdateAddOnData(false, MainSession, loggedin, ThisAddOnData[i], DropInput, AddedForNotForcedAddOnCheckBox, TotalPriceText);
                }
            }
        }
    }
}


function CalculateAndUpdateAddOnData(isallowcallfunction, MainSession, loggedin, thisaddon, DropInput, AddedForNotForcedAddOnCheckBox, TotalPriceText)
{
    let HowManyNight = 1; // Get How Many Nights -------------------------

    if(window.FormPaymentHotelData != null && window.FormPaymentHotelData.dates != null)
    {
        console.log("window.FormPaymentHotelData", window.FormPaymentHotelData);
        HowManyNight = window.FormPaymentHotelData.dates.length;
    }
    else
    {
        if(window.CurrentSelectedRoomExpBookType == "per night")
        {
            let CheckInFullDate = window.ConvertDateStringToDateFormat(window.CheckInDateNonTop);
            let CheckOutFullDate = null;
            if(window.CheckOutDateNonTop == null)
            {
                CheckOutFullDate = new Date(CheckInFullDate);
                CheckOutFullDate.setDate(CheckOutFullDate.getDate() + 1);
            }
            else
            {
                CheckOutFullDate = window.ConvertDateStringToDateFormat(window.CheckOutDateNonTop);
            }
            HowManyNight = window.GetDateDifferences(CheckOutFullDate, CheckInFullDate);
        }
    }

    let HowManyToMultiply = DropInput.value; // Get Total To Multiply ---------
    if(thisaddon.add_on.pricing_type == "night")
        HowManyToMultiply = HowManyToMultiply * HowManyNight;

    let HowManyTotalPrice = parseInt(thisaddon.add_on.price) * HowManyToMultiply; // Get Final Total Price --------
    TotalPriceText.innerHTML = window.ConvertTextToRP(HowManyTotalPrice, 1, true, false);

    let WhatToInput = DropInput.value;

    if(AddedForNotForcedAddOnCheckBox != null && AddedForNotForcedAddOnCheckBox.checked == false)
    {
        HowManyToMultiply = 0;
        WhatToInput = 0;
        HowManyTotalPrice = 0;
    }
        
    // Check Is Data Exist --------------------------------------------------------
    let IsExist = false;
    for(let i = 0; i < AccRoomAddOnFormData.data_to_push.length; i++)
    {
        if(AccRoomAddOnFormData.data_to_push[i].id_add_on == thisaddon.id_add_on)
        {
            IsExist = true;
            AccRoomAddOnFormData.data_to_push[i].qty = WhatToInput;
            AccRoomAddOnFormData.data_to_push[i].total_price = HowManyTotalPrice;
        }
    }
    // If Not Exist --------------------------------------------------------
    if(IsExist == false)
    {
        let DataToPush =
        {
            "id_add_on":thisaddon.id_add_on,
            "qty":WhatToInput,
            "total_price":HowManyTotalPrice,
            "price":thisaddon.add_on.price,
        };
        AccRoomAddOnFormData.data_to_push.push(DataToPush);
    }

    // Calculate The Total ------------------------------------------------
    let TotalToDisplay = 0;

    for(let i = 0; i < AccRoomAddOnFormData.data_to_push.length; i++)
    {
        let ThisPrice = AccRoomAddOnFormData.data_to_push[i].total_price;
        TotalToDisplay = TotalToDisplay + ThisPrice;
    }
    document.getElementById("TotalAddOnPriceText").innerHTML = window.ConvertTextToRP(TotalToDisplay, 1, true, false);

    // If Allow Call the Form Function Then Call it --------------------------
    if(isallowcallfunction == true)
        window.LoadAccommodationFormData(null, MainSession, loggedin);
}

// ==================================== INSTANTIATE BASIC PAYMENT =======================================

function InstantiateLoadingPanel()
{
        for(let i = 0; i < OriginalPriceContainer.length; i++) // Original Price ---------------
        {
            InstantiateLoadingPricePanel(OriginalPriceContainer[i], window.DifferenceBetweenDays, true);
        }

        for(let i = 0; i < YouSavedContainer.length; i++) // You Saved ---------------
        {
            let HowManyToInstantiate = window.DifferenceBetweenDays;
            if(YouSavedContainer[i].getAttribute("is-one") == "true")
            HowManyToInstantiate = 1;

            if(CurrentIDVoucher != "")
            HowManyToInstantiate++;

            InstantiateLoadingPricePanel(YouSavedContainer[i], HowManyToInstantiate, true);
        }

        // ----------------------------------------------- LOADING ------------------------------------------

        PriceGreyLoading.forEach(ThisLoading =>
        {
            ThisLoading.style.display = "";
        });

        TextToDisplayAfterCalc.forEach(ThisText =>
        {
            ThisText.style.display = "none";
        });

        DownPaymentPercText.forEach(ThisText =>
        {
            ThisText.style.display = "none";
        });

}


function InstantiateBasicInformation(MainSession, loggedin)
{
    if(IsAlreadyLoad == false)
    {
        IsAlreadyLoad = true;

        // // Max Discount -----------------------------------
        // let MaxDiscountContainer = document.getElementById("MaxDiscountContainer");
        // MaxDiscountContainer.className = "RedBorderMaxDiscount";

        // if(window.HotelDetails.max_discount != null && window.HotelDetails.max_discount > 0)
        // {
        //     let MaxDiscountTextValue = document.getElementById("MaxDiscountTextValue");
        //     MaxDiscountTextValue.style.opacity = 1;
        //     MaxDiscountTextValue.innerHTML = parseFloat(window.HotelDetails.max_discount) + "% Discount";
        // }
        // else
        // {
        //     MaxDiscountContainer.style.display = "none";
        // }

        // Discount Percentage -----------------------------------

        let MaxDiscountWrapper = document.getElementById("MaxDiscountWrapper");
        let MaxDiscountContainer = document.getElementById("MaxDiscountContainer");
        MaxDiscountContainer.className = "RedBorderMaxDiscount";

        if(window.HotelDetails.max_discount != null && window.HotelDetails.max_discount > 0)
        {
            let MaxDiscountTextValue = document.getElementById("MaxDiscountTextValue");
            MaxDiscountTextValue.style.opacity = 1;
            MaxDiscountTextValue.innerHTML = window["DiscountTxt" + window.CurrentCountryID](parseFloat(window.FormPaymentHotelData.max_discount));
        }
        else
        {
            MaxDiscountWrapper.style.display = "none";
            MaxDiscountContainer.style.display = "none";
        }

        // Hotel Name -----------------------------------
        let LoadingHotelNamePayment = document.getElementById("LoadingHotelNamePayment");
        LoadingHotelNamePayment.remove();

        let HotelNameTextRightSection = document.getElementById("HotelNameTextRightSection");
        HotelNameTextRightSection.innerHTML = window.HotelDetails.hotel_name;
        HotelNameTextRightSection.style.display = "";

        let HotelNameAnAdditional = document.getElementById("HotelNameAnAdditional");
        HotelNameAnAdditional.innerHTML = window.HotelDetails.hotel_name;

        // Location -----------------------------------
        let LocationTextRightWrapper = document.getElementById("LocationTextRightWrapper");
        LocationTextRightWrapper.style.display = "";

        let LocationTextRightSection = document.getElementById("LocationTextRightSection");
        LocationTextRightSection.innerHTML = window.HotelDetails.location + " - ";
        LocationTextRightSection.style.whiteSpace = "normal";

        let LocationURLSeeMap = document.createElement("a");
        LocationURLSeeMap.className = "SeeMapTextInsidePanel InterBoldTextFont HyperlinkUnderlineText";
        LocationURLSeeMap.innerHTML = window["SeeMapTxt" + window.CurrentCountryID];
        LocationURLSeeMap.target = "_blank";
        LocationURLSeeMap.rel = "noopener noreferrer";
        LocationURLSeeMap.href = window.HotelDetails.link_gmaps;
        LocationTextRightSection.append(LocationURLSeeMap);

        let LoadingLocationTextWrapper = document.getElementById("LoadingLocationTextWrapper");
        LoadingLocationTextWrapper.remove();

        // Room Quota -----------------------------------

        let ChangeButtonText = document.querySelectorAll(".ChangeButtonText");
        ChangeButtonText.forEach(thistext =>
        {
            thistext.innerHTML = window["ChangeButtonTxt" + window.CurrentCountryID];
        });

        let FunctionToCallEditRoomExp = function() // Set Edit Room Experience Function -----------------
        {
            let PrevData = window.CreateHotelDetailsSnapshot();

            window.InstantiateEditRoomOrExperiencePaymentPageDesktop(()=>
            {
                console.log("Update All Mobile");
                console.log("window.ThisRoomData", window.ThisRoomData);

                // window.ThisRoomData = window.MobilePotentialRoomDataToChange;

                let NewUpdateCheckInDateInfo;
                let NewUpdateCheckOutDateInfo;

                if(window.ThisRoomData.book_type == "per night")
                {
                    NewUpdateCheckInDateInfo = window.CheckInDateNonTop;
                    NewUpdateCheckOutDateInfo = window.CheckOutDateNonTop;

                    if(NewUpdateCheckInDateInfo != null && typeof NewUpdateCheckInDateInfo === 'string')
                    {
                        NewUpdateCheckInDateInfo = window.ConvertDateStringToDateFormat(NewUpdateCheckInDateInfo);
                    }

                    if(NewUpdateCheckOutDateInfo != null && typeof NewUpdateCheckOutDateInfo === 'string')
                    {
                        NewUpdateCheckOutDateInfo = window.ConvertDateStringToDateFormat(NewUpdateCheckOutDateInfo);
                    }

                    console.log("NewUpdateCheckInDateInfo", NewUpdateCheckInDateInfo);
                    console.log("NewUpdateCheckOutDateInfo", NewUpdateCheckOutDateInfo);
                }
                else
                {
                    console.log("window.CurrentSelectedYearEdit", window.CurrentSelectedYearEdit);
                    console.log("window.CurrentSelectedYearEdit", window.CurrentSelectedMonthEdit);
                    console.log("window.CurrentSelectedYearEdit", window.CurrentSelectedDayEdit);

                    let GetFinalSelectedCheckInDate = new Date(window.CurrentSelectedYearEdit, parseInt(window.CurrentSelectedMonthEdit) - 1, window.CurrentSelectedDayEdit);
                    let GetFinalSelectedCheckOutDate = new Date(window.CurrentSelectedYearEdit, parseInt(window.CurrentSelectedMonthEdit) - 1, window.CurrentSelectedDayEdit);
                    GetFinalSelectedCheckOutDate.setDate(GetFinalSelectedCheckOutDate.getDate() + 1);

                    NewUpdateCheckInDateInfo = GetFinalSelectedCheckInDate;
                    NewUpdateCheckOutDateInfo = GetFinalSelectedCheckOutDate;
                }

                let NewCheckInYear = NewUpdateCheckInDateInfo.getFullYear();
                let NewCheckInMonth = (NewUpdateCheckInDateInfo.getMonth() + 1);
                let NewCheckInDay = NewUpdateCheckInDateInfo.getDate();

                window.CheckInDateNonTop = NewCheckInYear + "-" + NewCheckInMonth + "-" + NewCheckInDay;
                window.CheckInNonTopInput.setAttribute("Date", NewCheckInDay);
                window.CheckInNonTopInput.setAttribute("Month", NewCheckInMonth);
                window.CheckInNonTopInput.setAttribute("Year", NewCheckInYear);


                let NewCheckOutYear = NewUpdateCheckOutDateInfo.getFullYear();
                let NewCheckOutMonth = (NewUpdateCheckOutDateInfo.getMonth() + 1);
                let NewCheckOutDay = NewUpdateCheckOutDateInfo.getDate();

                window.CheckOutDateNonTop = NewCheckOutYear + "-" + NewCheckOutMonth + "-" + NewCheckOutDay;
                window.CheckOutNonTopInput.setAttribute("Date", NewCheckOutDay);
                window.CheckOutNonTopInput.setAttribute("Month", NewCheckOutMonth);
                window.CheckOutNonTopInput.setAttribute("Year", NewCheckOutYear);

                document.getElementById("RoomQuotaTypeDropDownContainer").setAttribute("room-quota", window.ThisCurrentQuotaInput);

                window.GetPaymentInfoFromDatabase(null, MainSession, loggedin);
            },
            ()=>
            {
                window.RestoreHotelDetailsSnapshot(PrevData);
                window.GetPaymentInfoFromDatabase(null, MainSession, loggedin);

            }, true);
        }

        let ExperienceEditButton = document.getElementById("ExperienceEditButton");
        ExperienceEditButton.onclick = function (event)
        {
            event.preventDefault();
            event.stopPropagation();

            FunctionToCallEditRoomExp();

            // window.InstantiateRoomQuotaAndTypePanel(event, RoomQuotaDropDown, false, "PaymentForm", () => window.GetPaymentInfoFromDatabase(null, MainSession, loggedin));
        };

        let RoomQuotaTypeDropDownButton = document.getElementById("RoomQuotaTypeDropDownButton");
        RoomQuotaTypeDropDownButton.onclick = function (event)
        {
            event.preventDefault();
            event.stopPropagation();

            FunctionToCallEditRoomExp();

            // window.InstantiateRoomQuotaAndTypePanel(event, RoomQuotaDropDown, false, "PaymentForm", () => window.GetPaymentInfoFromDatabase(null, MainSession, loggedin));
        };

        
        let RoomQuotaTypeMobileDropDownButton = document.getElementById("RoomQuotaTypeMobileDropDownButton");
        RoomQuotaTypeMobileDropDownButton.onclick = function (event)
        {
            event.preventDefault();
            event.stopPropagation();

            let PrevData = window.CreateHotelDetailsSnapshot();

            window.InstantiateMobileRoomExperienceTypeScrollChoice(
            ()=>
            {
                window.InstantiateEditHotelDetailsMobileMenu(()=>
                {
                    console.log("Update All Mobile");
                    console.log("window.ThisRoomData", window.ThisRoomData);

                    // window.ThisRoomData = window.MobilePotentialRoomDataToChange;

                    let NewUpdateCheckInDateInfo;
                    let NewUpdateCheckOutDateInfo;

                    if(window.ThisRoomData.book_type == "per night")
                    {
                        NewUpdateCheckInDateInfo = window.CheckInDateNonTop;
                        NewUpdateCheckOutDateInfo = window.CheckOutDateNonTop;

                        if(NewUpdateCheckInDateInfo != null && typeof NewUpdateCheckInDateInfo === 'string')
                        {
                            NewUpdateCheckInDateInfo = window.ConvertDateStringToDateFormat(NewUpdateCheckInDateInfo);
                        }

                        if(NewUpdateCheckOutDateInfo != null && typeof NewUpdateCheckOutDateInfo === 'string')
                        {
                            NewUpdateCheckOutDateInfo = window.ConvertDateStringToDateFormat(NewUpdateCheckOutDateInfo);
                        }

                        console.log("NewUpdateCheckInDateInfo", NewUpdateCheckInDateInfo);
                        console.log("NewUpdateCheckOutDateInfo", NewUpdateCheckOutDateInfo);
                    }
                    else
                    {
                        console.log("window.CurrentSelectedYearEdit", window.CurrentSelectedYearEdit);
                        console.log("window.CurrentSelectedYearEdit", window.CurrentSelectedMonthEdit);
                        console.log("window.CurrentSelectedYearEdit", window.CurrentSelectedDayEdit);

                        let GetFinalSelectedCheckInDate = new Date(window.CurrentSelectedYearEdit, parseInt(window.CurrentSelectedMonthEdit) - 1, window.CurrentSelectedDayEdit);
                        let GetFinalSelectedCheckOutDate = new Date(window.CurrentSelectedYearEdit, parseInt(window.CurrentSelectedMonthEdit) - 1, window.CurrentSelectedDayEdit);
                        GetFinalSelectedCheckOutDate.setDate(GetFinalSelectedCheckOutDate.getDate() + 1);

                        NewUpdateCheckInDateInfo = GetFinalSelectedCheckInDate;
                        NewUpdateCheckOutDateInfo = GetFinalSelectedCheckOutDate;
                    }

                    let NewCheckInYear = NewUpdateCheckInDateInfo.getFullYear();
                    let NewCheckInMonth = (NewUpdateCheckInDateInfo.getMonth() + 1);
                    let NewCheckInDay = NewUpdateCheckInDateInfo.getDate();

                    window.CheckInDateNonTop = NewCheckInYear + "-" + NewCheckInMonth + "-" + NewCheckInDay;
                    window.CheckInNonTopInput.setAttribute("Date", NewCheckInDay);
                    window.CheckInNonTopInput.setAttribute("Month", NewCheckInMonth);
                    window.CheckInNonTopInput.setAttribute("Year", NewCheckInYear);


                    let NewCheckOutYear = NewUpdateCheckOutDateInfo.getFullYear();
                    let NewCheckOutMonth = (NewUpdateCheckOutDateInfo.getMonth() + 1);
                    let NewCheckOutDay = NewUpdateCheckOutDateInfo.getDate();

                    window.CheckOutDateNonTop = NewCheckOutYear + "-" + NewCheckOutMonth + "-" + NewCheckOutDay;
                    window.CheckOutNonTopInput.setAttribute("Date", NewCheckOutDay);
                    window.CheckOutNonTopInput.setAttribute("Month", NewCheckOutMonth);
                    window.CheckOutNonTopInput.setAttribute("Year", NewCheckOutYear);

                    document.getElementById("RoomQuotaTypeDropDownContainer").setAttribute("room-quota", window.ThisCurrentQuotaInput);

                    window.GetPaymentInfoFromDatabase(null, MainSession, loggedin);
                },
                ()=>
                {
                    window.RestoreHotelDetailsSnapshot(PrevData);
                    window.GetPaymentInfoFromDatabase(null, MainSession, loggedin);

                }, true, false, true);
            },
            ()=>
            {
                window.RestoreHotelDetailsSnapshot(PrevData);
                window.GetPaymentInfoFromDatabase(null, MainSession, loggedin);

            }, true)


        };
    }


    // Display the Room Name and Quota Text ----------------------------------------------

    ExperienceOptionRightDisplayText.style.display = "none";

    if(window.BookingDetailsData == null) // For New Booking --------------------------
    {
        RefreshPaymentRightSectionInfo(MainSession, loggedin);
    }
    else // For Continue Booking --------------------------
    {
        RoomTypeTextPaymentRight.innerHTML = "<span class='InterBoldTextFont'>" + window.BookingDetailsData.total_room + " x </span>" + window.BookingDetailsData.booking_details[0].room_ping.hotel_room.room_name;
        RefreshPaymentOtherUI(MainSession, loggedin);
    }
}


// ==================================== REFRESH RIGHT SECTION ====================================================

function RefreshPaymentRightSectionInfo(MainSession, loggedin)
{
    if(window.CurrentSelectedAccFacilitiesType == null)
        window.CurrentSelectedAccFacilitiesType = "Rooms";
        
    window.CheckIfAllRoomExperienceDataAlreadyLoaded(()=>
    {
        let ThisRoomOrExperienceData = window.AllChoicesBasedOnCurrentSelectedRoomAccType;
        let ThisChoiceGet = window.ListOfChoicesThisAccommodation;

        //console.log("ThisRoomOrExperienceData", ThisRoomOrExperienceData);
        //console.log("ThisChoiceGet", ThisChoiceGet);
        //console.log("window.CurrentSelectedRoomID", window.CurrentSelectedRoomID);
        //console.log("window.CurrentSelectedAccFacilitiesType", window.CurrentSelectedAccFacilitiesType);

        for(let i = 0; i < ThisRoomOrExperienceData.length; i++)
        {
            let ThisExpRoomID = ThisRoomOrExperienceData[i]?.id_hotel_room ?? ThisRoomOrExperienceData[i]?.id;
            let ThisRoomPingData = ThisRoomOrExperienceData[i]?.room_pings?.[0]?.dates ?? ThisRoomOrExperienceData[i]?.dates;
            let RoomExperienceNameText = ThisRoomOrExperienceData[i].room_name || ThisRoomOrExperienceData[i]["name_" + window.CurrentCountryID];

            
            let WhichType = "Rooms";
            if(ThisRoomOrExperienceData[i].id_hotel_room == null)
                WhichType = "Experiences";
            
            if(window.CurrentSelectedRoomID == ThisExpRoomID && window.CurrentSelectedAccFacilitiesType == WhichType)
            {
                (async () =>
                {
                    console.log("ThisRoomOrExperienceData[i]", ThisRoomOrExperienceData[i]);
                    window.ThisRoomData = ThisRoomOrExperienceData[i];
                    window.CurrentSelectedRoomExpBookType = window.ThisRoomData.book_type;

                    window.RoomPingDataCheck = await window.CheckRoomExpDataAvaliablePrice(WhichType, ThisRoomPingData, ThisRoomOrExperienceData[i], true); // Get Room Price Status Data ------------------
                    
                    if(window.CurrentSelectedAccFacilitiesType == "Experiences")
                    {
                        let ExperienceInput = window.CurrentUserInputExperienceAddOns.data_input;
                        console.log("ExperienceInput", ExperienceInput);

                        if(Array.isArray(ExperienceInput))
                        {
                            // RoomTypeTextPaymentRight.innerHTML = RoomExperienceNameText;
                            // ExperienceOptionRightDisplayText.style.display = "";

                            let NameAndQuotaInputted = [];
                            let ToDisplayOnRight = "";

                            for(let j = 0; j < ThisChoiceGet.length; j++) // Push Add On Option Name and Quota --------------------
                            {
                                let CurrentChoiceData = ThisChoiceGet[j].data;

                                for(let x = 0; x < ExperienceInput.length; x++)
                                {
                                    if(CurrentChoiceData.id == ExperienceInput[x].id)
                                    {
                                        let HowManyInputtedThisOption = ExperienceInput[x].quantity;

                                        if(HowManyInputtedThisOption > 0)
                                        {
                                            let DataToPush =
                                            {
                                                "name":ThisChoiceGet[j]["name_" + window.CurrentCountryID],
                                                "quantity": HowManyInputtedThisOption
                                            }
                                            NameAndQuotaInputted.push(DataToPush);
                                        }
                                    }
                                }
                            }

                            if(NameAndQuotaInputted.length > 0) // If At Least One Option Selected -----------------------
                            {
                                for(let j = 0; j < NameAndQuotaInputted.length; j++)
                                {
                                    ToDisplayOnRight = ToDisplayOnRight +  NameAndQuotaInputted[j].quantity + "x " + NameAndQuotaInputted[j].name;

                                    if(j < NameAndQuotaInputted.length - 1)
                                    {
                                        ToDisplayOnRight = ToDisplayOnRight + "<br/>";
                                    }
                                }

                                if(ExperienceOptionRightDisplayText != null)
                                {
                                    ExperienceOptionRightDisplayText.style.display = "";
                                    ExperienceOptionRightDisplayText.innerHTML = ToDisplayOnRight;
                                }
                            }

                            RoomTypeTextPaymentRight.innerHTML = RoomExperienceNameText;
                        }
                        else
                        {
                            RoomTypeTextPaymentRight.innerHTML = "<span class='InterBoldTextFont'>" + ExperienceInput + " x </span>" + RoomExperienceNameText;
                        }
                    }
                    else
                    {
                        RoomTypeTextPaymentRight.innerHTML = "<span class='InterBoldTextFont'>" + window.RoomQuotaNonTop + " x </span>" + RoomExperienceNameText;
                    }
                    

                    if(window.RoomPingDataCheck.room_status == false)
                    {
                        RoomTypeWarningTextPaymentRight.style.display = "";
                        RoomTypeWarningTextPaymentRight.innerHTML = window.RoomPingDataCheck.unavailable_text;
                    }
                    else
                    {
                        RoomTypeWarningTextPaymentRight.style.display = "none";
                    }

                    RefreshPaymentOtherUI(MainSession, loggedin);
                })();
            }
        }
    });
}

function RefreshPaymentOtherUI(MainSession, loggedin) // Change Check In Out or Type Header
{
    // APPLY CHANGES BASED ON SELECTED ROOM TYPE =======================================================

    if(window.ThisRoomData != null)
    {
        let CheckInHeaderText = document.getElementById("CheckInHeaderText");
        let MobileCheckInOutHeaderText = document.getElementById("MobileCheckInOutHeaderText");
        let SmokePreferenceChoiceContainer = document.getElementById("SmokePreferenceChoiceContainer");

        if(window.ThisRoomData.book_type == "per night") // Can Range of Date (Check In and Out)
        {
            window.CheckOutNonTopInput.style.display = "";

            if(CheckInHeaderText != null)
                CheckInHeaderText.innerHTML = window["CheckInTxt" + window.CurrentCountryID];

            if(MobileCheckInOutHeaderText != null)
                MobileCheckInOutHeaderText.innerHTML = window["CheckInTxt" + window.CurrentCountryID];

            if(SmokePreferenceChoiceContainer != null)
                SmokePreferenceChoiceContainer.style.display = "";
        }
        else if(window.ThisRoomData.book_type == "per day") // Select Date Only one day at a time
        {
            window.CheckOutNonTopInput.style.display = "none";
            
            if(CheckInHeaderText != null)
                CheckInHeaderText.innerHTML = window["DateOfVisitTxt" + window.CurrentCountryID];

            if(MobileCheckInOutHeaderText != null)
                MobileCheckInOutHeaderText.innerHTML = window["DateOfVisitTxt" + window.CurrentCountryID];

            if(SmokePreferenceChoiceContainer != null)
                SmokePreferenceChoiceContainer.style.display = "none";
        }
    }

    let ExtraMobileCheckInOutDateContainer = document.querySelectorAll(".ExtraMobileCheckInOutDateContainer");
    let MobileCheckInOutHeaderText = document.getElementById("MobileCheckInOutHeaderText");

    if(ExtraMobileCheckInOutDateContainer != null && ExtraMobileCheckInOutDateContainer.length > 0)
    {
        let CurrentCheckInArray = window.CheckInDateNonTop.split("-");
        let CurrentCheckOutArray = window.CheckOutDateNonTop.split("-");

        let ThisCheckInDateToDisplay = CurrentCheckInArray[2] + " " + window["monthNames" + window.CurrentCountryID][parseInt(CurrentCheckInArray[1])-1] + " " + CurrentCheckInArray[0];
        let ThisCheckOutDateToDisplay = CurrentCheckOutArray[2] + " " + window["monthNames" + window.CurrentCountryID][parseInt(CurrentCheckOutArray[1])-1] + " " + CurrentCheckOutArray[0];

        window.CheckInNonTopInputText.innerHTML = ThisCheckInDateToDisplay;
        window.CheckOutNonTopInputText.innerHTML = ThisCheckOutDateToDisplay;

        console.log("window.ThisRoomData", window.ThisRoomData);

        ExtraMobileCheckInOutDateContainer.forEach(thiscontainer =>
        {
            let ThisCheckInOutMobileText = thiscontainer.querySelector(".ExtraMobileCheckInOutDateText");
            
            if(window.ThisRoomData.book_type == "per day")
            {
                ThisCheckInOutMobileText.innerHTML = ThisCheckInDateToDisplay;

                if(MobileCheckInOutHeaderText != null)
                    MobileCheckInOutHeaderText.innerHTML = window["DateOfVisitTxt" + window.CurrentCountryID];
            }
            else
            {
                ThisCheckInOutMobileText.innerHTML = ThisCheckInDateToDisplay + " - " + ThisCheckOutDateToDisplay;

                if(MobileCheckInOutHeaderText != null)
                    MobileCheckInOutHeaderText.innerHTML = window["CheckInTxt" + window.CurrentCountryID];
            }
        });
    }


    // Tipe Room or Experience Header or Price Display Change ------------------------------------------------------

    let RoomTypeHeaderText = document.getElementById("RoomTypeHeaderText");
    let TipeExperienceRightTextIconContainer = document.getElementById("TipeExperienceRightTextIconContainer");
    let SeeOrHideDetailsButtonPayment = document.querySelectorAll(".SeeOrHideDetailsButtonPayment");

    if(window.CurrentSelectedAccFacilitiesType == "Rooms")
    {
        if(RoomTypeHeaderText != null) // Make ROOM header Visible -----------------------
            RoomTypeHeaderText.style.display = "";

        if(TipeExperienceRightTextIconContainer != null) // Make EXPERIENCE header Hidden -----------------------
            TipeExperienceRightTextIconContainer.style.display = "none";

        SeeOrHideDetailsButtonPayment.forEach(thisbutton =>  // Make SEE DETAILS and HIDE DETAILS Visible -----------------------
        {
            thisbutton.style.display = "";
        });

        RoomQuotaDropDown.className = "HoverableContentInsideInputField Unselectable"; // Change Class For UBAH button Quota or Type --------------------
    }
    else
    {
        if(RoomTypeHeaderText != null) // Make ROOM header Hidden -----------------------
            RoomTypeHeaderText.style.display = "none";

        if(TipeExperienceRightTextIconContainer != null) // Make EXPERIENCE header Visible -----------------------
            TipeExperienceRightTextIconContainer.style.display = "flex";


        SeeOrHideDetailsButtonPayment.forEach(thisbutton => // Make SEE DETAILS and HIDE DETAILS Hidden -----------------------
        {
            thisbutton.style.display = "none";
        });

        window.HideandDisplayPaymentDetails(false); // Automatically Display The Detailed Pricing --------------------------

        RoomQuotaDropDown.className = "HoverableContentInsideInputField Unselectable PaymentExperienceContainer"; // Change Class For UBAH button Quota or Type --------------------
    }

    // Remove Name --------------------------------------------------------------------------

    RoomTypeTextPaymentRight.style.display = "";
    
    let RoomTypePaymentFormLoadingGrey = document.getElementById("RoomTypePaymentFormLoadingGrey");
    if(RoomTypePaymentFormLoadingGrey != null)
        RoomTypePaymentFormLoadingGrey.style.display = "none";

    CheckPaymentInfoInputted(false, MainSession, loggedin);
}


// ==================================== INSTANTIATING THE PRICE PANEL ========================================

function InstantiateLoadingPricePanel(wheretoinstantiate, howmanyinst, earlyremovecontent)
{
    if(earlyremovecontent == true)
    {
        wheretoinstantiate.innerHTML = "";
    }

    for(let i = 0; i < howmanyinst; i++)
    {
        let PriceSavedTextWrapper = document.createElement("div");
        PriceSavedTextWrapper.className = "PriceMainTextWrapper";
        wheretoinstantiate.append(PriceSavedTextWrapper);

        let GreyLoadingLeft = document.createElement("div");
        GreyLoadingLeft.className = "RoomSmallInfo loading_grey";
        PriceSavedTextWrapper.append(GreyLoadingLeft);

        let Price2ndWrapper = document.createElement("div");
        Price2ndWrapper.className = "Price2ndWrapper";
        PriceSavedTextWrapper.append(Price2ndWrapper);

        let GreyLoadingRight = document.createElement("div");
        GreyLoadingRight.className = "RoomSmallInfo loading_grey";
        GreyLoadingRight.style.marginLeft = "auto";
        Price2ndWrapper.append(GreyLoadingRight);
    }
}

function CalculatePaymentFormSection(MainSession, loggedin)
{
    console.log("Calculate ======================");
    console.log("window.FormPaymentHotelData", window.FormPaymentHotelData);


    // IMMEDIATELY ASSIGN DATA BASED ON FORM DATA ==========================================================
    
    let FinalCalculationFromFormData = window.FormPaymentHotelData.summary;
    console.log("FinalCalculationFromFormData", FinalCalculationFromFormData);

    OriginalPriceCalculated = FinalCalculationFromFormData.total_price_original ?? FinalCalculationFromFormData.experience_original_price;
    PayAtHotelDisc = FinalCalculationFromFormData.pay_at_hotel.percentage;
    PayAtHotelPriceCalculated = FinalCalculationFromFormData.pay_at_hotel.pay_at_hotel_price;
    DownPaymentPriceCalculated = FinalCalculationFromFormData.dp.down_payment_price;
    FinalPriceCalculatedAfterVouc = FinalCalculationFromFormData.total_after_discount ?? FinalCalculationFromFormData.subtotal_hotel_payment ?? FinalCalculationFromFormData.subtotal_experience_payment ?? FinalCalculationFromFormData.experience_price_after_discount;
    DiscountCutCalculated = FinalCalculationFromFormData.total_disc_room ?? FinalCalculationFromFormData.total_disc_experience ?? FinalCalculationFromFormData.experience_discount ?? (OriginalPriceCalculated - FinalCalculationFromFormData.total_price_after_disc);

    ReinstantiatePriceTables(MainSession, loggedin)
}


function ReinstantiatePriceTables(MainSession, loggedin)
{
    let FormDataDates = window.FormPaymentHotelData.dates;
    console.log("This All Important Data!! ===============");
    console.log("Current Room Data --------------");
    console.log(window.ThisRoomData);
    console.log("Form Payment Data --------------");
    console.log(window.FormPaymentHotelData);
    console.log("Form Payment Dates Data --------------");
    console.log(FormDataDates);
    console.log("Room Ping Data From Checking --------------");
    console.log(window.RoomPingDataCheck);
    console.log("Add On Data --------------");
    console.log(window.FormPaymentHotelData.addons);

    // ORIGINAL PRICE ==================================================================================

    for(let i = 0; i < OriginalPriceContainer.length; i++)
    {
        OriginalPriceContainer[i].innerHTML = "";
    }

    if(FormDataDates != null)
    {
        for(let i = 0; i < FormDataDates.length; i++)
        {
            // ----------------------------- PRICE -----------------------------
            let ThisOriginalPrice = Math.round(FormDataDates[i].price * window.RoomQuotaNonTop);

            // ----------------------------- DATE -----------------------------
            let CurrentDateArray = FormDataDates[i].date.split("-");
            let CurrentDay = parseInt(CurrentDateArray[2]);
            let CurrentMonth = parseInt(CurrentDateArray[1]);
            let CurrentYear = parseInt(CurrentDateArray[0]);

            // Night and Price ------------------------------------------------------------
            for(let j = 0; j < OriginalPriceContainer.length; j++)
            {
                let PriceSavedTextWrapper = document.createElement("div");
                PriceSavedTextWrapper.className = "PriceMainTextWrapper";
                OriginalPriceContainer[j].append(PriceSavedTextWrapper);

                let Price1stWrapper = document.createElement("div");
                Price1stWrapper.className = "Price1stWrapper";
                PriceSavedTextWrapper.append(Price1stWrapper);

                let LabelGreyHeaderSmallerText = document.createElement("p");
                LabelGreyHeaderSmallerText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                LabelGreyHeaderSmallerText.innerHTML = CurrentDay.toString().padStart(2, '0') + " " + window["monthNames" + window.CurrentCountryID][CurrentMonth - 1] + " " + CurrentYear;
                Price1stWrapper.append(LabelGreyHeaderSmallerText);


                let Price2ndWrapper = document.createElement("div");
                Price2ndWrapper.className = "Price2ndWrapper";
                PriceSavedTextWrapper.append(Price2ndWrapper);


                let DiscountValueText = document.createElement("p");
                DiscountValueText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                DiscountValueText.innerHTML = window.ConvertTextToRP(ThisOriginalPrice, 1, true, false);
                Price2ndWrapper.append(DiscountValueText);
            }
        }
    }
    else if(window.FormPaymentHotelData.items != null) // Experience -------------------------------------------------------
    {
        let ThisData = window.FormPaymentHotelData.items;
        let ThisExperienceInfo = window.FormPaymentHotelData.experience;

        console.log("window.FormPaymentHotelData", window.FormPaymentHotelData);

        for(let i = 0; i < ThisData.length; i++)
        {
            // ----------------------------- Experiences Dates ------------------------
            let ThisDatesData = ThisData[i].dates;

            for(let j = 0; j < ThisDatesData.length; j++)
            {
                // ----------------------------- PRICE -----------------------------
                let ThisOriginalPrice = ThisDatesData[j].total_price;

                // ----------------------------- DATE -----------------------------
                let CurrentDateArray = ThisDatesData[j].date.split("-");
                let CurrentDay = parseInt(CurrentDateArray[2]);
                let CurrentMonth = parseInt(CurrentDateArray[1]);
                let CurrentYear = parseInt(CurrentDateArray[0]);

                for(let x = 0; x < OriginalPriceContainer.length; x++)
                {
                    let PriceSavedTextWrapper = document.createElement("div");
                    PriceSavedTextWrapper.className = "PriceMainTextWrapper";
                    OriginalPriceContainer[x].append(PriceSavedTextWrapper);

                    let Price1stWrapper = document.createElement("div");
                    Price1stWrapper.className = "Price1stWrapper";
                    PriceSavedTextWrapper.append(Price1stWrapper);

                    let LabelGreyHeaderSmallerText = document.createElement("p");
                    LabelGreyHeaderSmallerText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                    LabelGreyHeaderSmallerText.innerHTML = ThisData[i].qty + " x " + ThisData[i]["option_name_" + window.CurrentCountryID];
                    Price1stWrapper.append(LabelGreyHeaderSmallerText);

                    if(ThisExperienceInfo != null && ThisExperienceInfo.book_type != "per day")
                    {
                        let CurrentDateText = document.createElement("p");
                        CurrentDateText.className = "SmallerRoomDescriptionText InterRegularTextFont";
                        CurrentDateText.style.color = "#252525";
                        CurrentDateText.innerHTML = CurrentDay.toString().padStart(2, '0') + " " + window["monthNames" + window.CurrentCountryID][CurrentMonth - 1] + " " + CurrentYear;
                        Price1stWrapper.append(CurrentDateText);
                    }

                    let Price2ndWrapper = document.createElement("div");
                    Price2ndWrapper.className = "Price2ndWrapper";
                    PriceSavedTextWrapper.append(Price2ndWrapper);

                    let DiscountValueText = document.createElement("p");
                    DiscountValueText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                    DiscountValueText.innerHTML = window.ConvertTextToRP(ThisOriginalPrice, 1, true, false);
                    Price2ndWrapper.append(DiscountValueText);
                }
            }
        }
    }
    else // Without Date -------------------------------------------------------
    {
        // ----------------------------- PRICE -----------------------------
        let ThisOriginalPrice = window.FormPaymentHotelData.summary.total_price_original;

        // ----------------------------- DATE -----------------------------
        let CurrentDateArray = window.CheckInDateNonTop.split("-");
        let CurrentDay = parseInt(CurrentDateArray[2]);
        let CurrentMonth = parseInt(CurrentDateArray[1]);
        let CurrentYear = parseInt(CurrentDateArray[0]);

        let PriceSavedTextWrapper = document.createElement("div");
        PriceSavedTextWrapper.className = "PriceMainTextWrapper";
        OriginalPriceContainer[j].append(PriceSavedTextWrapper);

        let Price1stWrapper = document.createElement("div");
        Price1stWrapper.className = "Price1stWrapper";
        PriceSavedTextWrapper.append(Price1stWrapper);

        let LabelGreyHeaderSmallerText = document.createElement("p");
        LabelGreyHeaderSmallerText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
        LabelGreyHeaderSmallerText.innerHTML = CurrentDay.toString().padStart(2, '0') + " " + window["monthNames" + window.CurrentCountryID][CurrentMonth - 1] + " " + CurrentYear;
        Price1stWrapper.append(LabelGreyHeaderSmallerText);

        let Price2ndWrapper = document.createElement("div");
        Price2ndWrapper.className = "Price2ndWrapper";
        PriceSavedTextWrapper.append(Price2ndWrapper);

        let DiscountValueText = document.createElement("p");
        DiscountValueText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
        DiscountValueText.innerHTML = window.ConvertTextToRP(ThisOriginalPrice, 1, true, false);
        Price2ndWrapper.append(DiscountValueText);
    }


    // ADD ONS ==================================================================================

    let AddOnsData = window.FormPaymentHotelData.addons;
    let ThisAddOnWrapper = document.querySelectorAll('.ThisAddOnWrapper');
    ThisAddOnWrapper.forEach(ThisAddOnContainer =>
    {
        ThisAddOnContainer.remove();
    });

    if(AddOnsData != null)
    {
        for(let i = 0; i < AddOnsData.length; i++)
        {
            // Prepare the Name To Display --------------------------------
            let NameToDisplay = AddOnsData[i]["add_on_name_" + window.CurrentCountryID];
            if(AddOnsData[i].is_required != "0")
            {
                NameToDisplay = NameToDisplay + "<span style=\"color: #c10000\">*</span>";
            }
            if(AddOnsData[i].pricing_type == "night")
            {
                NameToDisplay = NameToDisplay + " x" + (AddOnsData[i].qty * AddOnsData[i].total_nights) + " <span class='InterMediumItalicTextFont'>(" + AddOnsData[i].qty + "x" + window.NightTextDisplayer(AddOnsData[i].total_nights) + ")</span>";
            }
            else
            {
                NameToDisplay = NameToDisplay + " x" + AddOnsData[i].qty;
            }

            // Instantiate to Not Summarized Panel ------------------------------------------------------------
            for(let j = 0; j < OriginalPriceContainer.length; j++)
            {
                // Instantiate --------------------------------
                let PriceSavedTextWrapper = document.createElement("div");
                PriceSavedTextWrapper.className = "PriceMainTextWrapper";
                OriginalPriceContainer[j].append(PriceSavedTextWrapper);

                let Price1stWrapper = document.createElement("div");
                Price1stWrapper.className = "Price1stWrapper";
                PriceSavedTextWrapper.append(Price1stWrapper);

                let LabelGreyHeaderSmallerText = document.createElement("p");
                LabelGreyHeaderSmallerText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                LabelGreyHeaderSmallerText.innerHTML = NameToDisplay;
                Price1stWrapper.append(LabelGreyHeaderSmallerText);


                let Price2ndWrapper = document.createElement("div");
                Price2ndWrapper.className = "Price2ndWrapper";
                PriceSavedTextWrapper.append(Price2ndWrapper);


                let DiscountValueText = document.createElement("p");
                DiscountValueText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                DiscountValueText.innerHTML = window.ConvertTextToRP(AddOnsData[i].total_price, 1, true, false);
                Price2ndWrapper.append(DiscountValueText);
            }


            // Instantiate to Summarized Panel ------------------------------------------------------------
            for(let j = 0; j < SummarizedOriginalPriceContainer.length; j++)
            {
                // Instantiate --------------------------------
                let PriceSavedTextWrapper = document.createElement("div");
                PriceSavedTextWrapper.className = "PriceMainTextWrapper ThisAddOnWrapper";
                SummarizedOriginalPriceContainer[j].append(PriceSavedTextWrapper);

                let Price1stWrapper = document.createElement("div");
                Price1stWrapper.className = "Price1stWrapper";
                PriceSavedTextWrapper.append(Price1stWrapper);

                let LabelGreyHeaderSmallerText = document.createElement("p");
                LabelGreyHeaderSmallerText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                LabelGreyHeaderSmallerText.innerHTML = NameToDisplay;
                Price1stWrapper.append(LabelGreyHeaderSmallerText);

                let Price2ndWrapper = document.createElement("div");
                Price2ndWrapper.className = "Price2ndWrapper";
                PriceSavedTextWrapper.append(Price2ndWrapper);

                let DiscountValueText = document.createElement("p");
                DiscountValueText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                DiscountValueText.innerHTML = window.ConvertTextToRP(AddOnsData[i].total_price, 1, true, false);
                Price2ndWrapper.append(DiscountValueText);
            }
        }
    }


    // YOU SAVED ==================================================================================

    for(let i = 0; i < YouSavedContainer.length; i++)
    {
        YouSavedContainer[i].innerHTML = "";
    }

    // VOUCHER -----------------------------

    if(CurrentIDVoucher != "")
    {
        // Voucher Discount ----------------------------------------------------------------------------------------
        let DiscountVoucherGet = parseFloat(window.FormPaymentHotelData.voucher.discount);
        let MaxVoucherDiscount = window.FormPaymentHotelData.voucher.max_discount;
        let TotalVoucherDiscount = Math.round(window.RoomPingDataCheck.price_basic * DiscountVoucherGet * window.RoomQuotaNonTop / 100);
        if(MaxVoucherDiscount != null && TotalVoucherDiscount > MaxVoucherDiscount)
        {
            TotalVoucherDiscount = Math.round(MaxVoucherDiscount);
        }
        // DownPaymentPriceCalculated =  DownPaymentPriceCalculated - TotalVoucherDiscount;
        // FinalPriceCalculatedAfterVouc = DownPaymentPriceCalculated + PayAtHotelPriceCalculated;

        // Max Discount Text --------------------------------------------------------------------------
        let TotalVoucherDiscountText = window["DiscountTxt2" + window.CurrentCountryID](DiscountVoucherGet);
        console.log("MaxVoucherDiscount = " + MaxVoucherDiscount);
        if(MaxVoucherDiscount != 0)
        {
            TotalVoucherDiscountText = TotalVoucherDiscountText + " " + window["MaxHeaderTxt" + window.CurrentCountryID] + " " +  window.ConvertTextToRP(Math.round(MaxVoucherDiscount), 3, false, false);
        }

        for(let i = 0; i < YouSavedContainer.length; i++)
        {
            let VoucherWrapper = document.createElement("div");
            VoucherWrapper.className = "PriceMainTextWrapper BlueContainerPrice BasicRadius";
            YouSavedContainer[i].append(VoucherWrapper);

            let Price1stWrapper = document.createElement("div");
            Price1stWrapper.className = "Price1stWrapper";
            VoucherWrapper.append(Price1stWrapper);

            let LabelGreyHeaderSmallerText = document.createElement("p");
            LabelGreyHeaderSmallerText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
            LabelGreyHeaderSmallerText.innerHTML = window["VoucherVoucherAppliedTxt" + window.CurrentCountryID];
            Price1stWrapper.append(LabelGreyHeaderSmallerText);

            let VoucherAppliedTextWrapper = document.createElement("div");
            VoucherAppliedTextWrapper.className = "PoinWithIconWrapper";
            VoucherAppliedTextWrapper.style.marginLeft = 0;
            Price1stWrapper.append(VoucherAppliedTextWrapper);

            let VoucherAppliedText = document.createElement("p");
            VoucherAppliedText.className = "SmallerRoomDescriptionText InterRegularTextFont";
            VoucherAppliedText.style.color = "#252525";
            VoucherAppliedText.innerHTML = TotalVoucherDiscountText;
            VoucherAppliedTextWrapper.append(VoucherAppliedText);

            let Price2ndWrapper = document.createElement("div");
            Price2ndWrapper.className = "Price2ndWrapper";
            VoucherWrapper.append(Price2ndWrapper);

            let VoucherTotalText = document.createElement("p");
            VoucherTotalText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
            VoucherTotalText.innerHTML = window.ConvertTextToRP(TotalVoucherDiscount, 1, true, true);
            Price2ndWrapper.append(VoucherTotalText);
        }
    }

    // if(window.FormPaymentHotelData.voucher.id_voucher != null)
    // {
    //     let VoucherWrapper = document.createElement("div");
    //     VoucherWrapper.className = "PriceMainTextWrapper BlueContainerPrice BasicRadius";
    //     YouSavedPriceContainer.append(VoucherWrapper);

    //     let Price1stWrapper = document.createElement("div");
    //     Price1stWrapper.className = "Price1stWrapper";
    //     VoucherWrapper.append(Price1stWrapper);

    //     let LabelGreyHeaderSmallerText = document.createElement("p");
    //     LabelGreyHeaderSmallerText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
    //     LabelGreyHeaderSmallerText.innerHTML = "Voucher <span class='OrangeButton VoucherAppliedText'>Voucher Applied</span>";
    //     Price1stWrapper.append(LabelGreyHeaderSmallerText);

    //     let PoinWithIconWrapper = document.createElement("div");
    //     PoinWithIconWrapper.className = "PoinWithIconWrapper";
    //     PoinWithIconWrapper.style.marginLeft = 0;
    //     Price1stWrapper.append(PoinWithIconWrapper);

    //     let PoinIconIMG = document.createElement("img");
    //     PoinIconIMG.src="/Assets/images/ButtonIcon/coin-icon.svg";
    //     PoinIconIMG.style="margin-left: 0;"
    //     PoinWithIconWrapper.append(PoinIconIMG);

    //     let PingPoinText = document.createElement("p");
    //     PingPoinText.className = "SmallerRoomDescriptionText InterRegularTextFont";
    //     PingPoinText.style.color = "#252525";
    //     PingPoinText.innerHTML = "1 Poin = 100 Rp";
    //     PoinWithIconWrapper.append(PingPoinText);

    //     let Price2ndWrapper = document.createElement("div");
    //     Price2ndWrapper.className = "Price2ndWrapper";
    //     VoucherWrapper.append(Price2ndWrapper);

    //     let VoucherTotalText = document.createElement("p");
    //     VoucherTotalText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
    //     VoucherTotalText.innerHTML = "Rp ";
    //     Price2ndWrapper.append(VoucherTotalText);
    // }

    // SAVED PRICE -----------------------------

    let DiscountPercentageFix = 0;
    let MaxDiscountFix = 0;

    if(FormDataDates != null)
    {
        for(let i = 0; i < FormDataDates.length; i++)
        {
            // ----------------------------- PRICE -----------------------------
            // let ThisOriginalPrice = parseInt(FormDataDates[i].price);
            // let PriceAfterDiscount = parseInt(FormDataDates[i].price_after_disc);
            // let DiscountPercentage = parseFloat(FormDataDates[i].disc_now.discount_pingingo) + parseFloat(FormDataDates[i].disc_now.discount_mitra);
            // let DiscountedPrice = (ThisOriginalPrice - PriceAfterDiscount) * window.RoomQuotaNonTop;

            let DiscountPercentage = parseInt(FormDataDates[i].disc_now.total_discount);
            let DiscountedPrice = parseInt(FormDataDates[i].disc_now.total_nominal_disc);

            if(i == 0)
            {
                DiscountPercentageFix = DiscountPercentage;
                MaxDiscountFix = parseInt(FormDataDates[i].disc_now.max_price_disc_mitra ?? 0) + parseInt(FormDataDates[i].disc_now.max_price_disc_pingingo ?? 0);
            }

            // ----------------------------- DATE -----------------------------
            let CurrentDateArray = FormDataDates[i].date.split("-");
            let CurrentDay = parseInt(CurrentDateArray[2]);
            let CurrentMonth = parseInt(CurrentDateArray[1]);
            let CurrentYear = parseInt(CurrentDateArray[0]);

            for(let j = 0; j < YouSavedContainer.length; j++)
            {
                if(YouSavedContainer[j].getAttribute("is-one") == "false")
                {
                    let PriceSavedTextWrapper = document.createElement("div");
                    PriceSavedTextWrapper.className = "PriceMainTextWrapper";
                    YouSavedContainer[j].append(PriceSavedTextWrapper);

                    let Price1stWrapper = document.createElement("div");
                    Price1stWrapper.className = "Price1stWrapper";
                    PriceSavedTextWrapper.append(Price1stWrapper);

                    let LabelGreyHeaderSmallerText = document.createElement("p");
                    LabelGreyHeaderSmallerText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                    LabelGreyHeaderSmallerText.innerHTML = CurrentDay.toString().padStart(2, '0') + " " + window["monthNames" + window.CurrentCountryID][CurrentMonth - 1] + " " + CurrentYear;
                    Price1stWrapper.append(LabelGreyHeaderSmallerText);

                    let DiscountText = document.createElement("p");
                    DiscountText.className = "SmallerRoomDescriptionText InterRegularTextFont";
                    DiscountText.style.color = "#252525";
                    DiscountText.innerHTML = window["DiscountTxt2" + window.CurrentCountryID](DiscountPercentage) + " " + window["MaxHeaderTxt" + window.CurrentCountryID] + " " + window.ConvertTextToRP(MaxDiscountFix, 3, true, false);
                    Price1stWrapper.append(DiscountText);

                    let Price2ndWrapper = document.createElement("div");
                    Price2ndWrapper.className = "Price2ndWrapper";
                    PriceSavedTextWrapper.append(Price2ndWrapper);

                    let DiscountValueText = document.createElement("p");
                    DiscountValueText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                    DiscountValueText.innerHTML = window.ConvertTextToRP(DiscountedPrice, 1, true, true);
                    Price2ndWrapper.append(DiscountValueText);
                }
            }
        }
    }
    else if(window.FormPaymentHotelData.items != null) // Experience -------------------------------------------------------
    {
        let ThisData = window.FormPaymentHotelData.items;

        let DiscountDataByDate = [];

        // Get Discount Data --------------------------------------------------------

        ThisData.forEach(ThisItem =>
        {
            ThisItem.dates.forEach(ThisDateData =>
            {
                let ThisDate = ThisDateData.date;

                // Find existing data with the same date
                let ExistingDiscountData = DiscountDataByDate.find(ThisData =>
                    ThisData.date == ThisDate
                );

                if(ExistingDiscountData == null)
                {
                    let MaxPingingo = parseFloat(ThisDateData.disc_now?.max_price_disc_pingingo ?? 0);
                    let MaxMitra = parseFloat(ThisDateData.disc_now?.max_price_disc_mitra ?? 0);

                    ExistingDiscountData =
                    {
                        date: ThisDate,
                        total_nominal_disc: 0,
                        total_discount: parseFloat(ThisDateData.disc_now?.total_discount ?? 0),
                        max_discount: MaxPingingo + MaxMitra
                    };

                    DiscountDataByDate.push(ExistingDiscountData);
                }

                // ONLY total_nominal_disc is accumulated
                ExistingDiscountData.total_nominal_disc +=
                    parseFloat(ThisDateData.disc_now?.total_nominal_disc ?? 0);
            });
        });

        for(let i = 0; i < DiscountDataByDate.length; i++)
        {
            // ----------------------------- PRICE -----------------------------

            let DiscountPercentage = parseInt(DiscountDataByDate[i].total_discount);
            let DiscountedPrice = parseInt(DiscountDataByDate[i].total_nominal_disc);

            if(i == 0)
            {
                DiscountPercentageFix = DiscountPercentage;
                MaxDiscountFix = parseInt(DiscountDataByDate[i].max_discount);
            }

            // ----------------------------- DATE -----------------------------
            let CurrentDateArray = DiscountDataByDate[i].date.split("-");
            let CurrentDay = parseInt(CurrentDateArray[2]);
            let CurrentMonth = parseInt(CurrentDateArray[1]);
            let CurrentYear = parseInt(CurrentDateArray[0]);

            for(let j = 0; j < YouSavedContainer.length; j++)
            {
                if(YouSavedContainer[j].getAttribute("is-one") == "false")
                {
                    let PriceSavedTextWrapper = document.createElement("div");
                    PriceSavedTextWrapper.className = "PriceMainTextWrapper";
                    YouSavedContainer[j].append(PriceSavedTextWrapper);

                    let Price1stWrapper = document.createElement("div");
                    Price1stWrapper.className = "Price1stWrapper";
                    PriceSavedTextWrapper.append(Price1stWrapper);

                    let LabelGreyHeaderSmallerText = document.createElement("p");
                    LabelGreyHeaderSmallerText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                    LabelGreyHeaderSmallerText.innerHTML = CurrentDay.toString().padStart(2, '0') + " " + window["monthNames" + window.CurrentCountryID][CurrentMonth - 1] + " " + CurrentYear;
                    Price1stWrapper.append(LabelGreyHeaderSmallerText);

                    let DiscountText = document.createElement("p");
                    DiscountText.className = "SmallerRoomDescriptionText InterRegularTextFont";
                    DiscountText.style.color = "#252525";
                    DiscountText.innerHTML = window["DiscountTxt2" + window.CurrentCountryID](DiscountPercentage) + " " + window["MaxHeaderTxt" + window.CurrentCountryID] + " " + window.ConvertTextToRP(MaxDiscountFix, 3, true, false);
                    Price1stWrapper.append(DiscountText);

                    let Price2ndWrapper = document.createElement("div");
                    Price2ndWrapper.className = "Price2ndWrapper";
                    PriceSavedTextWrapper.append(Price2ndWrapper);

                    let DiscountValueText = document.createElement("p");
                    DiscountValueText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                    DiscountValueText.innerHTML = window.ConvertTextToRP(DiscountedPrice, 1, true, true);
                    Price2ndWrapper.append(DiscountValueText);
                }
            }
        }
    }
    else // Without Date -------------------------------------------------------
    {
        let DiscountPercentage = parseInt(FormDataDates[i].disc_now.total_discount);
        let DiscountedPrice = window.FormPaymentHotelData.summary.total_disc_experience;

        // if(i == 0)
        // {
        //     DiscountPercentageFix = DiscountPercentage;
        //     MaxDiscountFix = parseInt(FormDataDates[i].disc_now.max_price_disc_mitra ?? 0) + parseInt(FormDataDates[i].disc_now.max_price_disc_pingingo ?? 0);
        // }
        // ----------------------------- PRICE -----------------------------
        let ThisOriginalPrice = window.FormPaymentHotelData.summary.total_price_original;

        // ----------------------------- DATE -----------------------------
        let CurrentDateArray = window.CheckInDateNonTop.split("-");
        let CurrentDay = parseInt(CurrentDateArray[2]);
        let CurrentMonth = parseInt(CurrentDateArray[1]);
        let CurrentYear = parseInt(CurrentDateArray[0]);

        for(let j = 0; j < YouSavedContainer.length; j++)
        {
            if(YouSavedContainer[j].getAttribute("is-one") == "false")
            {
                let PriceSavedTextWrapper = document.createElement("div");
                PriceSavedTextWrapper.className = "PriceMainTextWrapper";
                YouSavedContainer[j].append(PriceSavedTextWrapper);

                let Price1stWrapper = document.createElement("div");
                Price1stWrapper.className = "Price1stWrapper";
                PriceSavedTextWrapper.append(Price1stWrapper);

                let LabelGreyHeaderSmallerText = document.createElement("p");
                LabelGreyHeaderSmallerText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                LabelGreyHeaderSmallerText.innerHTML = CurrentDay.toString().padStart(2, '0') + " " + window["monthNames" + window.CurrentCountryID][CurrentMonth - 1] + " " + CurrentYear;
                Price1stWrapper.append(LabelGreyHeaderSmallerText);

                let DiscountText = document.createElement("p");
                DiscountText.className = "SmallerRoomDescriptionText InterRegularTextFont";
                DiscountText.style.color = "#252525";
                DiscountText.innerHTML = window["DiscountTxt2" + window.CurrentCountryID](DiscountPercentage) + " " + window["MaxHeaderTxt" + window.CurrentCountryID] + " " + window.ConvertTextToRP(MaxDiscountFix, 3, true, false);
                Price1stWrapper.append(DiscountText);

                let Price2ndWrapper = document.createElement("div");
                Price2ndWrapper.className = "Price2ndWrapper";
                PriceSavedTextWrapper.append(Price2ndWrapper);

                let DiscountValueText = document.createElement("p");
                DiscountValueText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                DiscountValueText.innerHTML = window.ConvertTextToRP(DiscountedPrice, 1, true, true);
                Price2ndWrapper.append(DiscountValueText);
            }
        }
    }

    for(let i = 0; i < YouSavedContainer.length; i++)
    {
        if(YouSavedContainer[i].getAttribute("is-one") == "true")
        {
            let PriceSavedTextWrapper = document.createElement("div");
            PriceSavedTextWrapper.className = "PriceMainTextWrapper";
            YouSavedContainer[i].append(PriceSavedTextWrapper);

            let Price1stWrapper = document.createElement("div");
            Price1stWrapper.className = "Price1stWrapper";
            PriceSavedTextWrapper.append(Price1stWrapper);

            let LabelGreyHeaderSmallerText = document.createElement("p");
            LabelGreyHeaderSmallerText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
            LabelGreyHeaderSmallerText.innerHTML = window["DiscountTxt2" + window.CurrentCountryID](DiscountPercentageFix);
            Price1stWrapper.append(LabelGreyHeaderSmallerText);

            let DiscountText = document.createElement("p");
            DiscountText.className = "SmallerRoomDescriptionText InterRegularTextFont";
            DiscountText.style.color = "#252525";
            if(MaxDiscountFix == 0)
            {
                DiscountText.innerHTML = window["MaxHeaderTxt" + window.CurrentCountryID] + " --";
            }
            else
            {
                DiscountText.innerHTML = window["MaxHeaderTxt" + window.CurrentCountryID] + " " + window.ConvertTextToRP(MaxDiscountFix, 3, true, false);
            }
            Price1stWrapper.append(DiscountText);


            let Price2ndWrapper = document.createElement("div");
            Price2ndWrapper.className = "Price2ndWrapper";
            PriceSavedTextWrapper.append(Price2ndWrapper);


            let DiscountValueText = document.createElement("p");
            DiscountValueText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
            DiscountValueText.innerHTML = window.ConvertTextToRP(DiscountCutCalculated, 1, true, true);
            Price2ndWrapper.append(DiscountValueText);
        }
    }

    // NIGHTS TEXT ==================================================================================

    let HowManyDays = 1;
    if(FormDataDates != null)
    {
        HowManyDays = FormDataDates.length;
    }
    let HowManyDaysText = window.NightTextDisplayer(HowManyDays);
    
    HowManyNightText.forEach(ThisText =>
    {
        ThisText.innerHTML = HowManyDaysText;
    });

    // DOWN PAYMENT TEXT ==================================================================================

    DownPaymentPercText.forEach(ThisText => // Percentage
    {
        ThisText.innerHTML = window["DownPaymentTxt" + window.CurrentCountryID] + " (" + parseFloat(window.FormPaymentHotelData.summary.dp.percentage) +"%)";
    });

    let ArrayCalculated =
    {
        "OriginalPriceCalculated":OriginalPriceCalculated,
        "PayAtHotelDisc":PayAtHotelDisc,
        "PayAtHotelPriceCalculated":PayAtHotelPriceCalculated,
        "DiscountCutCalculated":DiscountCutCalculated,
        "DownPaymentPriceCalculated":DownPaymentPriceCalculated,
        "FinalPriceCalculatedAfterVouc":FinalPriceCalculatedAfterVouc,
    }

    // HIDE AND DISPLAY DOWNPAYMENT BASED ON DATA ==========================================================

    if(window.FormPaymentHotelData.summary != null && window.FormPaymentHotelData.summary.dp != null)
    {
        let ThisDPData = window.FormPaymentHotelData.summary.dp;
        let DPPercentage = ThisDPData.percentage;
        let DPTotal = ThisDPData.down_payment_price;

        let DownPaymentContentWrapper = document.querySelectorAll(".DownPaymentContentWrapper");
        DownPaymentContentWrapper.forEach(element =>
        {
            if(DPPercentage == 0 || DPTotal == 0) // If DP = 0 Hide DP
            {
                element.style.display = "none";
            }
            else // If DP != 0 Display DP
            {
                element.style.display = "flex";
            }
        });

        let WithoutDownPaymentContentWrapper = document.querySelectorAll(".WithoutDownPaymentContentWrapper");
        WithoutDownPaymentContentWrapper.forEach(element =>
        {
            if(DPPercentage == 0 || DPTotal == 0) // If DP = 0 Display This
            {
                element.style.display = "flex";
            }
            else // If DP != 0 Hide This
            {
                element.style.display = "none";
            }
        });
    }

    console.log("Calculated Price ----------------------------------");
    console.log(ArrayCalculated);

    UpdateAllTextAfterGet();
    CheckPaymentInfoInputted(false, MainSession, loggedin);
}

function UpdateAllTextAfterGet()
{
    PriceGreyLoading.forEach(ThisLoading =>
    {
        ThisLoading.style.display = "none";
    });

    TextToDisplayAfterCalc.forEach(ThisText =>
    {
        ThisText.style.display = "";
    });

    DownPaymentPercText.forEach(ThisText =>
    {
        ThisText.style.display = "";
    });

    // Original Price Text Update -----------------------
    let OriginalPriceText = document.querySelectorAll('.OriginalPriceText');
    OriginalPriceText.forEach(ThisText =>
    {
        ThisText.innerHTML = window.ConvertTextToRP(OriginalPriceCalculated, parseInt(ThisText.getAttribute("rp-type")), (ThisText.getAttribute("final-zero").toLowerCase() === "true"), false);
    });

    // Original Price Text Update -----------------------
    let FinalPriceText = document.querySelectorAll('.FinalPriceText');
    FinalPriceText.forEach(ThisText =>
    {
        ThisText.innerHTML = window.ConvertTextToRP(FinalPriceCalculatedAfterVouc, parseInt(ThisText.getAttribute("rp-type")), (ThisText.getAttribute("final-zero").toLowerCase() === "true"), false);
    });

    // Pay at Hotel Text Update -----------------------
    let PayAtHotelPriceText = document.querySelectorAll('.PayAtHotelPriceText');
    PayAtHotelPriceText.forEach(ThisText =>
    {
        ThisText.innerHTML = window.ConvertTextToRP(PayAtHotelPriceCalculated, parseInt(ThisText.getAttribute("rp-type")), (ThisText.getAttribute("final-zero").toLowerCase() === "true"), false);
    });

    // DP Text Update -----------------------
    let DownPaymentText = document.querySelectorAll('.DownPaymentText');
    DownPaymentText.forEach(ThisText =>
    {
        ThisText.innerHTML = window.ConvertTextToRP(DownPaymentPriceCalculated, parseInt(ThisText.getAttribute("rp-type")), (ThisText.getAttribute("final-zero").toLowerCase() === "true"), false);
    });
}

// ==================================== CHECK ALL INPUTTED ========================================

function CheckPaymentInfoInputted(allowchange, mainsession, loggedin)
{
    let IsInputtedValid = true;

    // Check Box -----------------------------------------------------------------------

    IsSmokingCheckBoxes.forEach(CheckBox =>
    {
        if(CheckBox.checked == true)
        {
            IsSmokingChecked = CheckBox.value;
        }
    })

    // Main Section --------------------------------------------------------------------

    if(FirstNameInput.value == ""  || FirstNameInput.value.replace(/ /g, "") == "") // First Name
    {
        IsInputtedValid = false;

        if(allowchange == true)
        {
            FirstNameContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";
            FirstNameWarningText.className = "RedWarningText InterMediumTextFont";
            FirstNameWarningText.innerHTML = window["FirstNameCannotEmpty" + window.CurrentCountryID];
        }
    }

    if(EmailInput.value == ""  || EmailInput.value.replace(/ /g, "") == "") // Email
    {
        IsInputtedValid = false;

        if(allowchange == true)
        {
            EmailContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";
            EmailWarningText.className = "RedWarningText InterMediumTextFont";
            EmailWarningText.innerHTML = window["EmailCannotEmpty" + window.CurrentCountryID];
        }
    }
    else if(window.CheckEmailValidity(EmailInput.value) == false)
    {
        IsInputtedValid = false;

        if(allowchange == true)
        {
            EmailContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";
            EmailWarningText.className = "RedWarningText InterMediumTextFont";
            EmailWarningText.innerHTML = window["InvalidEmailFormatMes" + window.CurrentCountryID];
        }
    }
    // else
    // {
    //     if(EmailInput.getAttribute("email-to-be-used") == "")
    //     {
    //         let formData = new FormData();
    //         formData.append('email', EmailInput.value);
    //         formData.append('lang', window.CurrentCountryID);

    //         let CheckEmailURL = "/v2/email/check";

    //         window.CallApiAxios({
    //             method: "POST",
    //             url: CheckEmailURL,
    //             data: formData,
    //         }).then(res =>
    //         {
    //             console.log(CheckEmailURL);

    //             window.IsPanelAnimating = false;

    //             if(res.status == 200)
    //             {
    //                 let CheckEmailData = res.data.data;
    //                 console.log(CheckEmailData);

    //                 if(CheckEmailData.new_register == false)
    //                 {
    //                     IsInputtedValid = false;

    //                     if(allowchange == true)
    //                     {
    //                         EmailContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";
    //                         EmailWarningText.className = "RedWarningText InterMediumTextFont";
    //                         EmailWarningText.innerHTML = window["EmailAlreadyUsed" + window.CurrentCountryID];
    //                     }
    //                     NextChoosePaymentButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop ButtonUnselectable";
    //                     NextChoosePaymentButton.onclick = function(){};
    //                 }
    //                 else
    //                 {
    //                     EmailInput.setAttribute("email-to-be-used", EmailInput.value);
    //                 }
    //             }
    //         })
    //         .catch(err =>
    //         {
    //             console.error(err);
    //         });
    //     }
    // }


    if(PhoneNumberInput.value == ""  || PhoneNumberInput.value.replace(/ /g, "") == "") // Email
    {
        IsInputtedValid = false;

        if(allowchange == true)
        {
            PhoneNumberContainer.className = "SmallPanelDropDownContainer InputFieldWarningOutline";
            PhoneNumberWarning.className = "RedWarningText InterMediumTextFont";
            PhoneNumberWarning.innerHTML = window["PhoneNumberCannotEmpty" + window.CurrentCountryID];
        }
    }
    // else
    // {
    //     let UserIDGet = null;
    //     let IsEdit = false;
    //     if(loggedin == true && mainsession != null)
    //     {
    //         UserIDGet = mainsession.usd_PING_id;
    //         IsEdit = true;
    //     }
        
    //     if(PhoneNumberInput.getAttribute("phone-to-be-used") == "")
    //     {
    //         window.CheckPhoneNumberAlreadyUsed(UserIDGet, CountryCodeContainer.getAttribute("country-code"), PhoneNumberInput.value, IsEdit, function(result, reasoninvalid)
    //         {
    //             if(result == false)
    //             {
    //                 IsInputtedValid = false;

    //                 if(allowchange == true)
    //                 {
    //                     PhoneNumberContainer.className = "SmallPanelDropDownContainer InputFieldWarningOutline";
    //                     PhoneNumberWarning.className = "RedWarningText InterMediumTextFont";
    //                     PhoneNumberWarning.innerHTML = window["PhoneNumberInvalidTxt" + window.CurrentCountryID];
    //                     if(reasoninvalid == "Already Used" || reasoninvalid == "Already used")
    //                     {
    //                         PhoneNumberWarning.innerHTML = window["PhoneNumberAlreadyUsedTxt" + window.CurrentCountryID];
    //                     }
    //                 }
    //                 NextChoosePaymentButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop ButtonUnselectable";
    //                 NextChoosePaymentButton.onclick = function(){};
    //             }
    //             else
    //             {
    //                 PhoneNumberInput.setAttribute("phone-to-be-used", PhoneNumberInput.value);
    //             }
    //         });
    //     }
    // }


    if(IDCardInput.value == ""  || IDCardInput.value.replace(/ /g, "") == "") // ID Card
    {
        IsInputtedValid = false;

        if(allowchange == true)
        {
            IDCardContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";
            IDCardWarning.className = "RedWarningText InterMediumTextFont";
            IDCardWarning.innerHTML = window["IDCardCannotEmpty" + window.CurrentCountryID];
        }
    }


    // Booking for Someone --------------------------------------------------------------------

    if(BookingForSomeoneCheckBox.checked == true)
    {
        if(FullNameBookingOthersInput.value == ""  || FullNameBookingOthersInput.value.replace(/ /g, "") == "") // Full Name for Others
        {
            IsInputtedValid = false;

            if(allowchange == true)
            {
                FullNameBookingOthersContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";
                FullNameBookingOthersWarning.className = "RedWarningText InterMediumTextFont";
                FullNameBookingOthersWarning.innerHTML = window["FullNameCannotEmptyTxt" + window.CurrentCountryID];
            }
        }

        if(IDCardBookingOthersInput.value == ""  || IDCardBookingOthersInput.value.replace(/ /g, "") == "") // ID Card for Others
        {
            IsInputtedValid = false;

            if(allowchange == true)
            {
                IDCardBookingOthersContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";
                IDCardBookingOthersWarning.className = "RedWarningText InterMediumTextFont";
                IDCardBookingOthersWarning.innerHTML = window["IDCardCannotEmpty" + window.CurrentCountryID];
            }
        }
    }

    // If All Valid -------------------------------------------

    console.log("CHECKINGGG!!!");
    console.log("IsInputtedValid", IsInputtedValid);
    console.log("window.RoomPingDataCheck", window.RoomPingDataCheck);
    if(IsInputtedValid == true && window.RoomPingDataCheck != null && window.RoomPingDataCheck.room_status == true)
    {
        ChangeNextChoosePaymentButton(true, mainsession, loggedin);
    }
    else
    {
        ChangeNextChoosePaymentButton(false, mainsession, loggedin);
    }

    // Change URL BASED ON CURRENT INPUT -----------------------------------
    UpdateUrlBasedOnSetting();
}

// ======================================== TRIGGER CHANGE BUTTON CHOOSE PAYMENT ========================================

function ChangeNextChoosePaymentButton(allowbutton, mainsession, loggedin)
{
    if(allowbutton == true)
    {
        NextChoosePaymentButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
        NextChoosePaymentButton.onclick = function()
        {
            CheckPaymentExistBeforeMoveToChoosePaymentSec(mainsession, loggedin);
            // CheckandPushUserData(mainsession, loggedin);
        }
    }
    else
    {
        NextChoosePaymentButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop ButtonUnselectable";
        NextChoosePaymentButton.onclick = function(){};
    }
}


// ================================================== UPDATE URL ==================================================

function UpdateUrlBasedOnSetting()
{
    if(typeof (window.history.replaceState) != "undefined")
    {
        let LocationSearch = window.SearchInfo;
        
        if(window.HotelDetails != null)
            LocationSearch = window.HotelDetails.province;

        let LatestURL = "/" + window.CurrentCountryID + "/payment.html?search=" + LocationSearch + "&checkin=" + window.CheckInDateNonTop + "&checkout=" + window.CheckOutDateNonTop + "&room=" + window.RoomQuotaNonTop + "&id_hotel=" + window.HotelID + "&id_hotel_room=" + window.CurrentSelectedRoomID + "&slug=" + window.HotelSlug  + "&type=" + window.CurrentSelectedAccFacilitiesType;
        if(window.CurrentSelectedAccFacilitiesType == "Experiences")
        {
            const jsonString = JSON.stringify(window.CurrentUserInputExperienceAddOns);
            const encodedJSON = encodeURIComponent(jsonString);

            LatestURL = LatestURL + "&expin=" + encodedJSON;
        }

        let obj =
        {
            Url: LatestURL
        };
        console.log("Update URL DISABLED");
        // window.history.replaceState(obj, obj.Title, obj.Url);
    }
}

// ==================================== CHECK REFERRAL & VOUCHER ===============================

function CheckReferralValidity(MainSession, loggedin)
{
    let ReferralInputtedValue = ReferralInput.value;
    let EmailForReferral = EmailInput.value;

    // Check Email Input Before Check Voucher Validity -----------------------------------------
    if(EmailForReferral == ""  || EmailForReferral.replace(/ /g, "") =="")
    {
        ReferralWarningIcon.style.display = "";
        ReferralContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon InputFieldWarningOutline Selectable3";
        ReferralWarningText.className = "RedWarningText InterMediumTextFont WarningTextMarginTop";
        ReferralWarningText.innerHTML = window["EmailCannotEmpty" + window.CurrentCountryID];
        return
    }
    else if(window.CheckEmailValidity(EmailForReferral) == false)
    {
        ReferralWarningIcon.style.display = "";
        ReferralContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon InputFieldWarningOutline Selectable3";
        ReferralWarningText.className = "RedWarningText InterMediumTextFont WarningTextMarginTop";
        ReferralWarningText.innerHTML = window["InvalidEmailFormatMes" + window.CurrentCountryID];
        return
    }

    ChangeNextChoosePaymentButton(false, MainSession, loggedin);

    let ThisURL = "/v2/bookings/referral-ping/check/" + ReferralInputtedValue + "?email=" + EmailForReferral + "&hotel_slug=" + window.HotelDetails.slug;

    window.CallApiAxios({
        method: "GET",
        url: ThisURL,
    }).then(res =>
    {
        console.log(ThisURL);
        console.log(res);

        if(res.status == 200)
        {
            CurrentRefferral = ReferralInputtedValue;

            ReferralContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon InputFieldContainerInvalid";
            ReferralInput.disabled = true;
            ReferralWarningText.className = "RedWarningText InterMediumTextFont WarningTextMarginTop RedWarningHidden";

            EmailContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldContainerInvalid";
            EmailInput.readOnly = true;

            ApplyReferralButton.className = "BasicTextButton BasicBoxShadow BlueButtonLight SignInButtonTop";
            ApplyReferralButton.innerHTML = window["ReferralAppliedTxt" + window.CurrentCountryID];

            window.GetPaymentInfoFromDatabase(null, MainSession, loggedin);

            ApplyReferralButton.onclick = function()
            {
                CurrentRefferral = "";
                window.GetPaymentInfoFromDatabase(null, MainSession, loggedin);

                ReferralContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
                ReferralInput.disabled = false;

                ApplyReferralButton.className = "BasicTextButton BasicBoxShadow BlueButtonLight SignInButtonTop Selectable";
                ApplyReferralButton.innerHTML = window["ApplyReferralBtnTxt" + window.CurrentCountryID];

                ApplyReferralButton.onclick = function()
                {
                    CheckReferralValidity(MainSession, loggedin);
                }
                // CheckRoomStatusAvailableOrNot(true);
            }
        }
        else
        {
            ReferralContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon InputFieldWarningOutline Selectable3";
            ReferralWarningIcon.style.display = "";
            ReferralWarningText.innerHTML = window["WarningReferralFailedTxt" + window.CurrentCountryID];
            ReferralWarningText.className = "RedWarningText InterMediumTextFont WarningTextMarginTop";

            ChangeNextChoosePaymentButton(true, MainSession, loggedin);
        }
    })
    .catch(err =>
    {
        console.error(err);

        ReferralContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon InputFieldWarningOutline Selectable3";
        ReferralWarningIcon.style.display = "";

        if(err.data.message == "Referral Invalid")
        {
            ReferralWarningText.innerHTML = window["YourReferralIsInvalidTxt" + window.CurrentCountryID];
        }
        else if(err.data.message == "Validation failed")
        {
            ReferralWarningText.innerHTML = window["YourReferralAlreadyUsedorInvalidTxt" + window.CurrentCountryID];
            // ReferralWarningText.innerHTML = window["YourReferralAlreadyUsedTxt" + window.CurrentCountryID];
        }
        else
        {
            ReferralWarningText.innerHTML = window["WarningReferralFailedTxt" + window.CurrentCountryID];
        }
        ReferralWarningText.className = "RedWarningText InterMediumTextFont WarningTextMarginTop";

        ChangeNextChoosePaymentButton(true, MainSession, loggedin);
    });
}

function CheckVoucherValidity(MainSession, loggedin)
{
    let VoucherInputValue = VoucherInput.value;
    let EmailForVoucher = EmailInput.value;

    console.log(EmailForVoucher);

    // Check Email Input Before Check Voucher Validity -----------------------------------------
    if(EmailForVoucher == ""  || EmailForVoucher.replace(/ /g, "") =="")
    {
        VoucherWarningIcon.style.display = "";
        VoucherContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon InputFieldWarningOutline Selectable3";
        VoucherWarningText.className = "RedWarningText InterMediumTextFont WarningTextMarginTop";
        VoucherWarningText.innerHTML = window["EmailCannotEmpty" + window.CurrentCountryID];
        return
    }
    else if(window.CheckEmailValidity(EmailForVoucher) == false)
    {
        VoucherWarningIcon.style.display = "";
        VoucherContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon InputFieldWarningOutline Selectable3";
        VoucherWarningText.className = "RedWarningText InterMediumTextFont WarningTextMarginTop";
        VoucherWarningText.innerHTML = window["InvalidEmailFormatMes" + window.CurrentCountryID];
        return
    }

    ChangeNextChoosePaymentButton(false, MainSession, loggedin);

    let ThisURL = "/v2/bookings/voucher/check/" + VoucherInputValue + "?email=" + EmailForVoucher + "&hotel_slug=" + window.HotelDetails.slug + "&amount=" + window.FormPaymentHotelData.summary.subtotal_hotel_payment ?? window.FormPaymentHotelData.summary.subtotal_experience_payment ?? window.FormPaymentHotelData.summary.experience_price_after_discount;

    window.CallApiAxios({
        method: "GET",
        url: ThisURL,
    }).then(res =>
    {
        console.log(ThisURL);
        console.log(res);

        if(res.status == 200)
        {
            CurrentIDVoucher = res.data.data.voucher_code;

            VoucherContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon InputFieldContainerInvalid";
            VoucherInput.disabled = true;
            VoucherWarningText.className = "RedWarningText InterMediumTextFont WarningTextMarginTop RedWarningHidden";

            EmailContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldContainerInvalid";
            EmailInput.readOnly = true;

            ApplyVoucherButton.className = "BasicTextButton BasicBoxShadow BlueButtonLight SignInButtonTop";
            ApplyVoucherButton.innerHTML = window["VoucherAppliedTxt" + window.CurrentCountryID];

            window.GetPaymentInfoFromDatabase(null, MainSession, loggedin);

            ApplyVoucherButton.onclick = function()
            {
                CurrentIDVoucher = "";
                window.GetPaymentInfoFromDatabase(null, MainSession, loggedin);

                VoucherContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3";
                VoucherInput.disabled = false;

                ApplyVoucherButton.className = "BasicTextButton BasicBoxShadow BlueButtonLight SignInButtonTop Selectable";
                ApplyVoucherButton.innerHTML = window["ApplyVoucherBtnTxt" + window.CurrentCountryID];

                ApplyVoucherButton.onclick = function()
                {
                    CheckVoucherValidity(MainSession, loggedin);
                }
            }
        }
        else
        {
            VoucherContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon InputFieldWarningOutline Selectable3";
            VoucherWarningIcon.style.display = "";
            VoucherWarningText.className = "RedWarningText InterMediumTextFont WarningTextMarginTop";
            VoucherWarningText.innerHTML = window["YourVoucherIsInvalidOrUsedTxt" + window.CurrentCountryID];

            ChangeNextChoosePaymentButton(true, MainSession, loggedin);
        }
    })
    .catch(err =>
    {
        console.error(err);
        
        VoucherContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon InputFieldWarningOutline Selectable3";
        VoucherWarningIcon.style.display = "";

        if(err.data.message == "Voucher not eligible")
        {
            VoucherWarningText.innerHTML = window["VoucherNotEligibleTxt" + window.CurrentCountryID];
        }
        else if(err.data.message == "Voucher invalid")
        {
            VoucherWarningText.innerHTML = window["YourVoucherIsInvalidTxt" + window.CurrentCountryID];
        }
        else if(err.data.message == "No more quota available for this voucher")
        {
            VoucherWarningText.innerHTML = window["QuotaVoucherAlreadyFinishTxt" + window.CurrentCountryID];
        }
        else
        {
            VoucherWarningText.innerHTML = window["YourVoucherIsInvalidOrUsedTxt" + window.CurrentCountryID];
        }
        VoucherWarningText.className = "RedWarningText InterMediumTextFont WarningTextMarginTop";

        ChangeNextChoosePaymentButton(true, MainSession, loggedin);
    });
}




















// ================================================ STEP 1 - CHECK IF PREVIOUS BOOKING EXIST ============================================

function CheckPaymentExistBeforeMoveToChoosePaymentSec(MainSession, loggedin)
{
    if(window.IsPanelAnimating == false)
    {
        window.IsPanelAnimating = true;

        let GoToSelectPaymentBlocker = window.InstantiateLoadingBlocker("GoToSelectPaymentBlocker");

        CheckAndUpdateMaintenancePaymentMethod(()=>
        {
            // Prepare Check Booking FormData ===============================================================
            
            // Others Info ------------------------------------------------------------------------

            let GuestName = FirstNameInput.value + " " + LastNameInput.value;

            BookForOthers = 'Self';
            OtherUserName = null;
            OtherCountryCode = null;
            OtherCountryName = null;
            OtherIDCard = null;

            if(BookingForSomeoneCheckBox.checked == true) // If Booking For Someone Checked ------------------------
            {
                let ThisOthersCountryName = CountryBookingOthersContainer.getAttribute("country-selected");
                let ThisOthersCountryID;
                for(let i = 0; i < window.CountryListCode.length; i++)
                {
                    if(window.CountryListCode[i].CountryName == ThisOthersCountryName)
                    {
                        ThisOthersCountryID = window.CountryListCode[i].CountryCode;
                    }
                }

                BookForOthers = 'Other';
                OtherUserName = FullNameBookingOthersInput.value;
                OtherCountryCode = ThisOthersCountryID;
                OtherCountryName = ThisOthersCountryName;
                OtherIDCard = IDCardBookingOthersInput.value;

                GuestName = OtherUserName;
            }

            // Set JSON Version of Form Data --------------------------------------------------------------------------------------------

            let AddOnJSONData = SetAddOnJSON();

            let CheckOutToSend = window.CheckOutDateNonTop;
            if(window.CurrentSelectedRoomExpBookType == "per day")
                CheckOutToSend = null;
            
            let CurrentBookingFormData = 
            {
                "id_hotel": window.HotelID,
                "lang": window.CurrentCountryID,

                "voucher_code": CurrentIDVoucher,
                "referral_code": CurrentRefferral,

                "smoking": IsSmokingChecked,

                "booking_for": BookForOthers,
                "other_name": OtherUserName || 'null',
                "other_nationality": OtherCountryName || 'null',
                "other_ktp": OtherIDCard || 'null',

                "email": EmailInput.value,
                "country_code": CountryCodeContainer.getAttribute("country-code"),
                "phone_number": PhoneNumberInput.value,
                "first_name": FirstNameInput.value,
                "last_name": LastNameInput.value,
                "country": CountryDropDownContainer.getAttribute("country-selected"),
                "ktp_passport": IDCardInput.value,
                "id_card": IDCardInput.value,
                "add_ons": AddOnJSONData,
            }

            if(window.CurrentSelectedAccFacilitiesType == "Rooms") // For Rooms ----------------
            {
                let RoomsJSONFormData = 
                {
                    "checkin": window.CheckInDateNonTop,
                    "checkout": CheckOutToSend,
                    "id_hotel_room": window.CurrentSelectedRoomID,
                    "rooms": window.RoomQuotaNonTop,
                }

                CurrentBookingFormData = { ...CurrentBookingFormData, ...RoomsJSONFormData };
            }
            else // For Experience ------------------------------------------------------------
            {
                let ExperienceInput = window.CurrentUserInputExperienceAddOns.data_input;

                let ExperienceJSONFormData = 
                {
                    "date_visit": window.CheckInDateNonTop,
                    "date_until": CheckOutToSend,
                    "id_hotel_experience": window.CurrentSelectedRoomID,
                }

                if(Array.isArray(ExperienceInput)) // If with Options -----------------------
                {
                    let FinalInputOptions = [];
                    for(let i = 0; i < ExperienceInput.length; i++)
                    {
                        if(ExperienceInput[i].quantity != 0 && ExperienceInput[i].quantity > 0)
                        {
                            FinalInputOptions.push
                            (
                                {
                                    "id_hotel_experience_option":ExperienceInput[i].id,
                                    "qty":ExperienceInput[i].quantity,
                                }
                            )
                        }
                    }
                    ExperienceJSONFormData.options = FinalInputOptions
                }
                else // If Without --------------------
                {
                    ExperienceJSONFormData.quantity = ExperienceInput;
                }

                CurrentBookingFormData = { ...CurrentBookingFormData, ...ExperienceJSONFormData };
            }

            // Display Guest Info & Set Transaction ID ----------------------------------------------------------------------------------

            GuestNameText.innerHTML = GuestName;
            GuestEmailText.innerHTML = EmailInput.value;
            GuestPhoneNumberText.innerHTML = "+" + CountryCodeContainer.getAttribute("country-code") + PhoneNumberInput.value;
            
            // -------------------------------------------------------------------------------------------------------------------------

            BluPaymentPhoneNumber.value = "0" + PhoneNumberInput.value;

            if(loggedin == true) // If User Logged In then Check Existing Booking ----------------------------------
            {
                // CurrentBookingFormData.append('id_user', MainSession.usd_PING_id);
                
                CurrentBookingFormData.id_user = MainSession.usd_PING_id;
                
                CheckUserBookingExistBasedOnInfo(CurrentBookingFormData, MainSession, loggedin, GoToSelectPaymentBlocker, ()=>
                {
                    PreparePaymentMethodSection(CurrentBookingFormData, MainSession, loggedin, GoToSelectPaymentBlocker);
                });
            }
            else // If User Not Logged In Check Email Once again whether it is User Or Not ------------------------------
            {
                let formData = new FormData();
                formData.append('email', EmailInput.value);
                formData.append('lang', window.CurrentCountryID);
                
                let CheckEmailURL = "/v2/email/check";

                window.CallApiAxios({
                    method: "POST",
                    url: CheckEmailURL,
                    data: formData,
                }).then(res =>
                {
                    console.log(CheckEmailURL);

                    let CheckEmailData = res.data.data;
                    console.log(CheckEmailData);

                    window.IsPanelAnimating = false;

                    if(res.status == 200)
                    {
                        console.log("TESTSTSTST");
                        
                        PreparePaymentMethodSection(CurrentBookingFormData, MainSession, loggedin, GoToSelectPaymentBlocker);
                        // if(CheckEmailData.new_register == true)
                        // {
                        //     // Set Button and Transition To Payment Choice --------------------------------------------
                        //     PreparePaymentMethodSection(CurrentBookingFormData, MainSession, loggedin, GoToSelectPaymentBlocker);
                        // }
                        // else
                        // {
                        //     EmailInput.setAttribute("email-to-be-used", '');
                        //     GoToSelectPaymentBlocker.remove();
                        //     CheckPaymentInfoInputted(true, MainSession, loggedin);
                        // }
                    }
                })
                .catch(err =>
                {
                    console.error(err);

                    window.IsPanelAnimating = false;

                    GoToSelectPaymentBlocker.remove();
                    window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["BasicErrorMes" + window.CurrentCountryID]);
                });
            }
        });
    }
}


function PreparePaymentMethodSection(CurrentBookingFormData, MainSession, loggedin, GoToSelectPaymentBlocker)
{
    // Set Button Confirm Payment --------------------------------------------
    document.getElementById("ConfirmNPayButton").onclick = function()
    {
        CheckandPushUserData(CurrentBookingFormData, MainSession, loggedin);
    }

    // Change to Select Payment ---------------------------------------------------------
    window.ChangeToSectionPaymentForm("Select Payment", true, ()=>
    {
        GoToSelectPaymentBlocker.remove();
    });
}


function CheckUserBookingExistBasedOnInfo(CurrentBookingFormData, MainSession, loggedin, GoToSelectPaymentBlocker, functiontocall)
{
    let CheckBookingURL = "/v2/bookings/check/hotel-room";
    if(window.CurrentSelectedAccFacilitiesType == "Experiences")
        CheckBookingURL = "/v2/bookings/check/hotel-exp";

    window.CallApiAxios({
        method: "POST",
        url: CheckBookingURL,
        data: CurrentBookingFormData,
    })
    .then((res) =>
    {
        console.log(CheckBookingURL);
        console.log(CurrentBookingFormData);

        window.IsPanelAnimating = false;

        window.PushbookingData = res.data.data;
        console.log("window.PushbookingData", window.PushbookingData);

        if(res.status == 200)
        {
            if(window.PushbookingData == null)
            {
                if(functiontocall != null)
                    functiontocall();
                // PreparePaymentMethodSection(CurrentBookingFormData, MainSession, loggedin, GoToSelectPaymentBlocker);
            }
            else
            {
                window.PushbookingData = window.PushbookingData.booking;
                PaymentBookingID = window.PushbookingData.booking_reference;

                if(window.PushbookingData.payment_method == null)
                {
                    // If No Payment Method Selected --------------------------
                    PreviousBookingFound(() =>
                    {
                        // Set Button and Transition To Payment Choice --------------------------------------------
                        if(functiontocall != null)
                            functiontocall();
                        // PreparePaymentMethodSection(CurrentBookingFormData, MainSession, loggedin,GoToSelectPaymentBlocker);
                    }, GoToSelectPaymentBlocker, window.PushbookingData.booking_reference, true);
                }
                else
                {
                    IfPrevBookingExistApplyFunction(GoToSelectPaymentBlocker, true, MainSession, loggedin);
                }
            }
        }
    })
    .catch((err) =>
    {
        console.log(CheckBookingURL);
        console.log(CurrentBookingFormData);
        console.error(err);

        window.IsPanelAnimating = false;

        if (err.data.message == "Previous booking still in Progress. Please check payment status first.")
        {
            let ThisExistingData = err.data.data;
            window.PushbookingData = ThisExistingData;

            // Display Guest Info & Set Transaction ID ----------------------------------------------------------------------------------

            GuestNameText.innerHTML = window.PushbookingData.name_customer;
            GuestEmailText.innerHTML = window.PushbookingData.user.email;
            GuestPhoneNumberText.innerHTML = "+" + window.PushbookingData.user.country_code + window.PushbookingData.user.phone_number;
            BluPaymentPhoneNumber.value = "0" + window.PushbookingData.user.phone_number;

            if (ThisExistingData.payment_method == null)
            {
                // If No Payment Method Selected --------------------------
                PreviousBookingFound(() =>
                {
                    // Set Button and Transition To Payment Choice --------------------------------------------
                    if(functiontocall != null)
                        functiontocall();
                    // PreparePaymentMethodSection(CurrentBookingFormData, MainSession, loggedin, GoToSelectPaymentBlocker);
                }, GoToSelectPaymentBlocker, window.PushbookingData.booking_reference, true);
            }
            else
            {
                IfPrevBookingExistApplyFunction(GoToSelectPaymentBlocker, true, MainSession, loggedin);
                // EarlyDetermineAfterGetOrPushBooking(GoToSelectPaymentBlocker, true);
                // DetermineSetUpAllPaymentInfoAndFunctionBefore(CurrentBookingFormData, GoToSelectPaymentBlocker, ThisExistingData);
            }
        }
        else if (err.data.message == "Booking not found")
        {
            // Set Button and Transition To Payment Choice --------------------------------------------
            if(functiontocall != null)
                functiontocall();
            // PreparePaymentMethodSection(CurrentBookingFormData, MainSession, loggedin, GoToSelectPaymentBlocker);
        }
        else
        {
            GoToSelectPaymentBlocker.remove();
            window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["BasicErrorMes" + window.CurrentCountryID]);
        }
    });
}


// ================================================ STEP 2 - PUSH USER DATA =============================================

function CheckandPushUserData(thisformdatatopush, MainSession, loggedin)
{
    // Refresh Check In and Out and Room Quota -------------------------------------------------------------------

    RefreshCheckInOut();

    // Which Type and Bank Selected ------------------------------------------------------------

    PaymentMethodButton.forEach(Button =>
    {
        let ThisRadioButton = Button.querySelector('input[type=radio]');
        if(ThisRadioButton.checked == true)
        {
            window.WhichPaymentBankSelected = ThisRadioButton.value;
            window.WhichPaymentTypeSelected = ThisRadioButton.getAttribute("which-type");
        }
    });


    // Start Calling ---------------------------------------------------------------------------------------

    if(window.IsPanelAnimating == false)
    {
        window.IsPanelAnimating = true;
        let GoToPaymentBlocker = window.InstantiateLoadingBlocker("GoToPaymentBlocker");
        

        if(window.WhichPaymentBankSelected != "blu" || (window.WhichPaymentBankSelected == "blu" && StepNameCurrent == "Blu Input"))
        {
            // Push Data User ---------------------------------------

            if(loggedin == true) // If User Already Logged In Then Immediately Push Booking -------------------------
            {
                PushBookingDataFunction(thisformdatatopush, GoToPaymentBlocker);
            }
            else // If not Logged In then create new account ------------------------------------------------------
            {
                let PushUserDataURL = "/v2/users";
                
                window.CallApiAxios({
                    method: "POST",
                    url: PushUserDataURL,
                    data: thisformdatatopush
                }).then(res =>
                {
                    console.log(PushUserDataURL);

                    let PushUserData = res.data.data;
                    console.log("PushUserData", PushUserData);

                    // thisformdatatopush.append('id_user', PushUserData.id_user);
                    
                    // Not that Really New User -----------------------------------------------------
                    if(PushUserData.id_user != null)
                    {
                        thisformdatatopush.id_user = PushUserData.id_user;
                        CheckUserBookingExistBasedOnInfo(thisformdatatopush, MainSession, loggedin, GoToPaymentBlocker, ()=>
                        {
                            PushBookingDataFunction(thisformdatatopush, GoToPaymentBlocker);
                        })
                    }
                    else
                    {
                        PushBookingDataFunction(thisformdatatopush, GoToPaymentBlocker);
                    }
                })
                .catch(err =>
                {
                    let PushUserError = err.data;
                    console.error(PushUserError);

                    window.IsPanelAnimating = false;
                    GoToPaymentBlocker.remove();

                    if(PushUserError.code == 403)
                    {
                        if(PushUserError.message == "Email already verified as Member. Please login to continue.")
                        {
                            window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["ErrorEmailAlreadyVerifiedPaymentTxt" + window.CurrentCountryID]);
                        }
                        else
                        {
                            window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["ErrorAccountAlreadyInactiveTxt" + window.CurrentCountryID]);
                        }

                        return
                    }
                    else if(PushUserError.message == "Validation failed")
                    {
                        if(PushUserError.errors.email != null)
                        {
                            EmailContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";
                            EmailWarningText.className = "RedWarningText InterMediumTextFont";
                            EmailWarningText.innerHTML = window["EmailCannotEmpty" + window.CurrentCountryID];
                        }
                        else
                        {
                            FirstNameContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";
                            FirstNameWarningText.className = "RedWarningText InterMediumTextFont";
                            FirstNameWarningText.innerHTML = window["FirstNameCannotEmpty" + window.CurrentCountryID];
                        }
                    }

                    window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["ErrorEmailAlreadyVerifiedPaymentTxt" + window.CurrentCountryID]);
                });
            }
        }
        else
        {
            window.ChangeToSectionPaymentForm("Blu Input", true, ()=>
            {
                GoToPaymentBlocker.remove();
                window.IsPanelAnimating = false;
                
                BluPaymentPhoneNumber.addEventListener("focusout", (event) =>
                {
                    CheckInputtedBlu(true, thisformdatatopush, MainSession, loggedin);
                });

                CheckInputtedBlu(false, thisformdatatopush, MainSession, loggedin);
            });
        }
    }
}

// ================================================ STEP 3 - PUSH BOOKING ALONG WITH PAYMENT METHOD =============================================

function PushBookingDataFunction(PushDataUserFormData, GoToPaymentBlocker)
{
    let PushBookingDataURL = "/v2/bookings/hotel-room";
    if(window.CurrentSelectedAccFacilitiesType == "Experiences")
        PushBookingDataURL = "/v2/bookings/hotel-exp";

    window.CallApiAxios({
        method: "POST",
        url: PushBookingDataURL,
        data: PushDataUserFormData
    }).then(res =>
    {
        console.log(PushBookingDataURL);
        console.log(PushDataUserFormData);
        
        window.PushbookingData = res.data.data.booking;
        PaymentBookingID = window.PushbookingData.booking_reference;
        console.log("window.PushbookingData", window.PushbookingData);

        // EarlyDetermineAfterGetOrPushBooking(GoToPaymentBlocker, true);
        PushThePaymentBasedOnSelectedMethod(window.PushbookingData, GoToPaymentBlocker);
    })
    .catch(err =>
    {
        console.log(PushBookingDataURL);
        console.log(PushDataUserFormData);
        console.error(err);
        
        window.IsPanelAnimating = false;

        if(err.status == 409) // Previous Booking Found --------------------------------
        {
            let ThisExistingData = err.data.data;
            window.PushbookingData = ThisExistingData;
            
            // Display Guest Info & Set Transaction ID ----------------------------------------------------------------------------------

            GuestNameText.innerHTML = window.PushbookingData.name_customer;
            GuestEmailText.innerHTML = window.PushbookingData.user.email;
            GuestPhoneNumberText.innerHTML = "+" + window.PushbookingData.user.country_code + window.PushbookingData.user.phone_number;
            
            if(ThisExistingData.payment_method == null)
            {
                PreviousBookingFound(()=>
                {
                    EarlyDetermineAfterGetOrPushBooking(GoToPaymentBlocker, true);
                }, GoToPaymentBlocker, window.PushbookingData.booking_reference, true);
            }
            else
            {
                EarlyDetermineAfterGetOrPushBooking(GoToPaymentBlocker, true);
            }
        }
        else if(err.status == 422 || err.status == 404 || err.status == 500)
        {

        }
        else
        {
            GoToPaymentBlocker.remove();
        }
    });
}

function PushThePaymentBasedOnSelectedMethod(thisbookingdata, LoadingBlocker)
{
    // Which Type and Bank Selected ------------------------------------------------------------

    PaymentMethodButton.forEach(Button =>
    {
        let ThisRadioButton = Button.querySelector('input[type=radio]');
        if(ThisRadioButton.checked == true)
        {
            window.WhichPaymentBankSelected = ThisRadioButton.value;
            window.WhichPaymentTypeSelected = ThisRadioButton.getAttribute("which-type");
        }
    });


    // Refresh Check In and Out and Room Quota -------------------------------------------------------------------

    RefreshCheckInOut();

    // Push Data Booking ----------------------------------------------------------------------------------------

    console.log(window.WhichPaymentTypeSelected + "  " + window.WhichPaymentBankSelected);
        
    let formData = new FormData();
    formData.append('id_user', thisbookingdata.id_user);
    formData.append('id_transaction', thisbookingdata.id_transaction);
    formData.append('down_payment', thisbookingdata.down_payment);
    formData.append('amount', thisbookingdata.down_payment);
    formData.append('lang', window.CurrentCountryID);
    formData.append('booking_reference', thisbookingdata.booking_reference);


    DeterminePushBookingBasedOnPaymentMethod(formData, ()=>
    {
        window.IsPanelAnimating = false;
        DetermineSetUpAllPaymentInfoAndFunctionBefore(formData, LoadingBlocker, thisbookingdata);
    },
    (errorget)=>
    {
        DetermineWhatToReturnBasedOnErrorGet(errorget, thisbookingdata.booking_reference, formData, LoadingBlocker, thisbookingdata);
    })
}


// ============================================== STEP 2B If Booking Exist ============================================

function IfPrevBookingExistApplyFunction(GoToPaymentBlocker, isnormalbooking, MainSession, loggedin)
{
    console.log(window.PushbookingData);

    // Prepare Form Data And Function After -------------------------------------------------------------------

    let formData = new FormData();
    formData.append('id_user', window.PushbookingData.id_user);
    formData.append('id_transaction', window.PushbookingData.id_transaction);
    formData.append('lang', window.CurrentCountryID);

    let StatusPayment = window.PushbookingData.transaction.status_payment;
    let StatusDownPayment = window.PushbookingData.status_dp;

    console.log("StatusPayment", StatusPayment);
    console.log("StatusDownPayment", StatusDownPayment);

    // On Progress ----------------------------------------------------------------------------------------------------
    if(StatusPayment == "Progress" || StatusDownPayment == "Waiting Payment")
    {
        window.WhichPaymentTypeSelected = window.PushbookingData.payment_method;
        window.WhichPaymentBankSelected = window.PushbookingData.method_bank

        let ThisTransactionData = window.PushbookingData.transaction;

        if(ThisTransactionData.payment_method == "QRIS") // QRIS =================================
        {
            window.WhichPaymentTypeSelected = "Instant Payment";
            window.WhichPaymentBankSelected = "QRIS";

            let FunctionToCallAfter = function()
            {
                PreviousBookingFound(()=>
                {
                    DetermineSetUpAllPaymentInfoAndFunctionBefore(formData, GoToPaymentBlocker, ThisTransactionData);
                }, GoToPaymentBlocker, window.PushbookingData.booking_reference, isnormalbooking);
            }

            CheckQRISStatus(formData, GoToPaymentBlocker, isnormalbooking, ()=>FunctionToCallAfter());
            // window.VARequestData =
            // {
            //     expired_at: null,
            //     qrData: "00020101021226640015ID.OTTOCASH.WWW01189360081110014113070212OP1D000791370303UME51400014ID.CO.QRIS.WWW0211991112292880303UME5204581253033605405960005802ID5913PinginGo QRIS6010Jalan AAAA61051153062700118BILL021519542677000521SP17751179942902186900703A019612OP1D000791376304C0E1"
            // };
        }
        else
        {
            if(ThisTransactionData.direct_transfers.length > 0) // Direct Transfers -------------------------
            {
                window.VARequestData = ThisTransactionData.direct_transfers[0];
                window.WhichPaymentBankSelected = "BCA";
            }
            else if(ThisTransactionData.card_transactions.length > 0)  // Card Transaction -------------------------
            {
                window.VARequestData = ThisTransactionData.card_transactions[0];
                window.WhichPaymentBankSelected = "Card";
                ContinuePaymentCreditCardButton.onclick = function()
                {
                    window.open(window.VARequestData.url, "_blank");
                }
            }
            else if(ThisTransactionData.va_transactions.length > 0) // Virtual Account --------------------------------
            {
                window.VARequestData = ThisTransactionData.va_transactions[0];
                window.WhichPaymentBankSelected = window.VARequestData.bank_user;
            }

            console.log(ThisTransactionData);
            window.EndTimeCountDown = window.ConvertThisToDate(window.VARequestData.expired_at, true);
            
            PreviousBookingFound(()=>
            {
                DetermineSetUpAllPaymentInfoAndFunctionBefore(formData, GoToPaymentBlocker, ThisTransactionData);
            }, GoToPaymentBlocker, window.PushbookingData.booking_reference, isnormalbooking);
        }
    }
    else if(StatusPayment == "Timeout" || StatusDownPayment == "Booking Timeout")
    {
        window.IsPanelAnimating = false;
        
        window.ChangeToSectionPaymentForm("Timeout", true, ()=>
        {
            window.IsPanelAnimating = false;
            GoToPaymentBlocker.remove();
        });
    }
    else if(StatusPayment == "Success" || StatusDownPayment == "Booking Completed" || StatusDownPayment == "Booking Fee Paid"
    || StatusDownPayment == "Booking Fee Paid" || StatusDownPayment == "Booking Payment Success")
    {
        window.IsPanelAnimating = false;

        window.ChangeToSectionPaymentForm("Success", true, ()=>
        {
            window.IsPanelAnimating = false;
            GoToPaymentBlocker.remove();
        });
    }
    else if(StatusPayment == "Cancel" || StatusDownPayment == "Booking Canceled")
    {
        window.IsPanelAnimating = false;

        window.ChangeToSectionPaymentForm("Error", true, ()=>
        {
            window.IsPanelAnimating = false;
            GoToPaymentBlocker.remove();
        });
    }
    else if(StatusPayment == "Failed" || StatusDownPayment == "Payment Failed")
    {
        window.IsPanelAnimating = false;

        window.ChangeToSectionPaymentForm("Failed", true, ()=>
        {
            window.IsPanelAnimating = false;
            GoToPaymentBlocker.remove();
        });
    }
    else
    {
        let WhatCheckInDateThis = window.PushbookingData.date_checkin;
        let WhatCheckOutDateThis = window.PushbookingData.date_checkout;

        window.SearchInfo = window.PushbookingData.hotel.province;

        window.CheckInInfo = WhatCheckInDateThis;
        window.CheckInDateNonTop = WhatCheckInDateThis;

        window.CheckOutInfo = WhatCheckOutDateThis;
        window.CheckOutDateNonTop = WhatCheckOutDateThis;

        window.RoomQuotaNonTop = window.PushbookingData.total_room;
        console.log(window.RoomQuotaNonTop);
        window.HotelID = window.PushbookingData.id_hotel;
        window.CurrentSelectedRoomID = window.PushbookingData.booking_details[0].room_ping.hotel_room.id_hotel_room;
        window.HotelSlug = window.PushbookingData.hotel.slug;

        GoToPaymentBlocker.remove();
        window.IsPanelAnimating = false;
        window.CurrentFinalAnimatedPanel = null;

        window.SetUpTopDateQuotaSearch(false);
        UpdateUrlBasedOnSetting();
        window.PreparePaymentForm();
        window.SetFunctionPayment(MainSession, loggedin);
    }
}


// function PushBookingDataFunction(PushDataUserFormData, GoToPaymentBlocker)
// {
//     let PushBookingDataURL = "/v2/bookings";

//     window.CallApiAxios({
//         method: "POST",
//         url: PushBookingDataURL,
//         data: PushDataUserFormData
//     }).then(res =>
//     {
//         console.log(PushBookingDataURL);
//         window.PushbookingData = res.data.data.booking;
//         console.log(window.PushbookingData);

//         // Display Guest Info & Set Transaction ID ----------------------------------------------------------------------------------

//         GuestNameText.innerHTML = window.PushbookingData.name_customer;
//         GuestEmailText.innerHTML = EmailInput.value;
//         GuestPhoneNumberText.innerHTML = "+" + CountryCodeContainer.getAttribute("country-code") + PhoneNumberInput.value;

//         EarlyDetermineAfterGetOrPushBooking(GoToPaymentBlocker, true);
//     })
//     .catch(err =>
//     {
//         console.error(err);
//         window.IsPanelAnimating = false;

//         if(err.data.message == "Previous booking still in Progress. Please check payment status first.")
//         {
//             let ThisExistingData = err.data.data;
//             window.PushbookingData = ThisExistingData;
            
//             // Display Guest Info & Set Transaction ID ----------------------------------------------------------------------------------

//             GuestNameText.innerHTML = window.PushbookingData.name_customer;
//             GuestEmailText.innerHTML = window.PushbookingData.user.email;
//             GuestPhoneNumberText.innerHTML = "+" + window.PushbookingData.user.country_code + window.PushbookingData.user.phone_number;
            
//             if(ThisExistingData.payment_method == null)
//             {
//                 PreviousBookingFound(()=>
//                 {
//                     EarlyDetermineAfterGetOrPushBooking(GoToPaymentBlocker, true);
//                 }, GoToPaymentBlocker, window.PushbookingData.booking_reference, true);
//             }
//             else
//             {
//                 EarlyDetermineAfterGetOrPushBooking(GoToPaymentBlocker, true);
//             }
//         }
//         else
//         {
//             GoToPaymentBlocker.remove();
//         }
//     });
// }

// function EarlyDetermineAfterGetOrPushBooking(GoToPaymentBlocker, isnormalbooking)
// {
//     console.log(window.PushbookingData);

//     // Transition to Select Payment ----------------------------------------------------------------------------------
        
//     // If New Booking ----------------------------------------------------------------------------------------------------
//     if(window.PushbookingData.payment_method == null)
//     {
//         window.IsPanelAnimating = false;

//         window.ChangeToSectionPaymentForm("Select Payment", true, ()=>
//         {
//             GoToPaymentBlocker.remove();
//         });
//     }
//     // If Old Booking ----------------------------------------------------------------------------------------------------
//     else if(window.PushbookingData.payment_method != null && (window.PushbookingData.status_payment == "Progress" || window.PushbookingData.status_dp == "Waiting Payment"))
//     {
//         window.WhichPaymentTypeSelected = window.PushbookingData.payment_method;
//         window.WhichPaymentBankSelected = window.PushbookingData.method_bank

//         let ThisTransactionData = window.PushbookingData.transaction;

//         if(ThisTransactionData.direct_transfers.length > 0) // Direct Transfers -------------------------
//         {
//             window.VARequestData = ThisTransactionData.direct_transfers[0];
//             window.WhichPaymentBankSelected = "BCA";
//         }
//         else if(ThisTransactionData.card_transactions.length > 0)  // Card Transaction -------------------------
//         {
//             window.VARequestData = ThisTransactionData.card_transactions[0];
//             window.WhichPaymentBankSelected = "Card";
//             ContinuePaymentCreditCardButton.onclick = function()
//             {
//                 window.open(window.VARequestData.url, "_blank");
//             }
//         }
//         else if(ThisTransactionData.va_transactions.length > 0) // Virtual Account
//         {
//             window.VARequestData = ThisTransactionData.va_transactions[0];
//             window.WhichPaymentBankSelected = window.VARequestData.bank_user;
//         }
//         console.log(ThisTransactionData);
//         window.EndTimeCountDown = window.ConvertThisToDate(window.VARequestData.expired_at, true);
//         console.log(window.WhichPaymentTypeSelected + " ||||||  " + window.WhichPaymentBankSelected);

//         PreviousBookingFound(()=>
//         {
//             let formData = new FormData();
//             formData.append('id_user', window.PushbookingData.id_user);
//             formData.append('id_transaction', window.PushbookingData.id_transaction);
//             formData.append('lang', window.CurrentCountryID);

//             DetermineSetUpAllPaymentInfoAndFunctionBefore(formData, GoToPaymentBlocker, ThisTransactionData);
//         }, GoToPaymentBlocker, window.PushbookingData.booking_reference, isnormalbooking);
//      }
// }

// ========================================== CHANGE TYPE =====================================


window.ConfirmPayButtonClicked = function(thisbookingdata)
{
    if(window.IsPanelAnimating == false)
    {
        window.IsPanelAnimating = true;
        let LoadingBlocker = window.InstantiateLoadingBlocker("ConfirmPayButtonBlocker");

        // Which Type and Bank Selected ------------------------------------------------------------

        PaymentMethodButton.forEach(Button =>
        {
            let ThisRadioButton = Button.querySelector('input[type=radio]');
            if(ThisRadioButton.checked == true)
            {
                window.WhichPaymentBankSelected = ThisRadioButton.value;
                window.WhichPaymentTypeSelected = ThisRadioButton.getAttribute("which-type");
            }
        });


        // Refresh Check In and Out and Room Quota -------------------------------------------------------------------

        RefreshCheckInOut();

        // Push Data Booking ----------------------------------------------------------------------------------------

        console.log(window.WhichPaymentTypeSelected + "  " + window.WhichPaymentBankSelected);
        
        let formData = new FormData();
        formData.append('id_user', thisbookingdata.id_user);
        formData.append('id_transaction', thisbookingdata.id_transaction);
        formData.append('down_payment', thisbookingdata.down_payment);
        formData.append('amount', thisbookingdata.down_payment);
        formData.append('lang', window.CurrentCountryID);
        formData.append('booking_reference', thisbookingdata.booking_reference);

        DeterminePushBookingBasedOnPaymentMethod(formData, ()=>
        {
            window.IsPanelAnimating = false;
            DetermineSetUpAllPaymentInfoAndFunctionBefore(formData, LoadingBlocker, thisbookingdata);
        },
        (errorget)=>
        {
            DetermineWhatToReturnBasedOnErrorGet(errorget, thisbookingdata.booking_reference, formData, LoadingBlocker, thisbookingdata);
        })
    }
}



function DeterminePushBookingBasedOnPaymentMethod(formData, callbackifsuccess, callbackiferror)
{
    // BCA Direct Transfer --------------------------------------------------------------------------------
    if(window.WhichPaymentTypeSelected == "Direct Transfer")
    {
        let URLCheckBluPayment = "/v2/payments/direct/bca/verify";
        // formData.append('transfer_date', thisbookingdata.down_payment);
        // formData.append('transfer_time', thisbookingdata.down_payment);
        // formData.append('bank_account', thisbookingdata.down_payment);
        // formData.append('account_number', thisbookingdata.down_payment);

        console.log(URLCheckBluPayment);
        console.log(window.ConvertFormDataToJSON(formData));
        window.IsPanelAnimating = false;

        window.VARequestData =
        {
            ottopayva: false
        };

        callbackifsuccess();
            // window.IsPanelAnimating = false;
            
            // window.CallApiAxios({
            //     method: "POST",
            //     url: URLCheckBluPayment,
            //     data: formData
            // }).then(res =>
            // {
            //     console.log(res);
            // })
            // .catch(err =>
            // {
            //     console.error(err);
            // });
    }
    // BLU --------------------------------------------------------------------------------
    else if(window.WhichPaymentTypeSelected == "Digital Payment" && window.WhichPaymentBankSelected == "blu")
    {
        // window.IsPanelAnimating = false;
        // CheckBluPaymentExist(formData);

        let URLCheckBluPayment = "/v2/payments/va/blu/request";
        formData.append('phone_number', BluPaymentPhoneNumber.value);

        console.log(URLCheckBluPayment);
        console.log(window.ConvertFormDataToJSON(formData));
            
        window.CallApiAxios({
            method: "POST",
            url: URLCheckBluPayment,
            data: formData
        }).then(res =>
        {
            console.log(res);
            if(res.data.success == true)
            {
                window.VARequestData = res.data;
                window.VARequestData.ottopayva = false;
                callbackifsuccess();
            }
            window.IsPanelAnimating = false;
        })
        .catch(err =>
        {
            console.error(err);
            callbackiferror(err);
            window.IsPanelAnimating = false;
        });
    }
    // CREDIT CARD --------------------------------------------------------------------------------
    else if(window.WhichPaymentTypeSelected == "Card")
    {
        let URLCreditCardPayment = "/v2/payments/card/ottopay/request";
        formData.append('card_type', window.WhichPaymentBankSelected);
        console.log(URLCreditCardPayment);
        console.log(window.ConvertFormDataToJSON(formData));

        window.CallApiAxios({
            method: "POST",
            url: URLCreditCardPayment,
            data: formData
        }).then(res =>
        {
            console.log(res);
            if(res.data.success == true)
            {
                window.VARequestData = res.data.data;
                window.VARequestData.ottopayva = false;

                ContinuePaymentCreditCardButton.onclick = function()
                {
                    window.open(window.VARequestData.redirect_url, "_blank");
                }

                callbackifsuccess();
            }
            window.IsPanelAnimating = false;
        })
        .catch(err =>
        {
            console.error(err);
            callbackiferror(err);
            window.IsPanelAnimating = false;
        });

    }
    else if(window.WhichPaymentTypeSelected == "Instant Payment" && window.WhichPaymentBankSelected == "QRIS")
    {
        (async () =>
        {
            let QRISPaymentURL = "/v2/payments/qris/ottopay/request";
            await window.getBrowserData(formData);

            console.log(QRISPaymentURL);
            console.log(window.ConvertFormDataToJSON(formData));

            window.CallApiAxios({
                method: "POST",
                url: QRISPaymentURL,
                data: formData
            }).then(res =>
            {
                console.log(res);
                if(res.data.success == true)
                {
                    window.VARequestData = res.data.data;
                    window.VARequestData.ottopayva = false;
                    callbackifsuccess();
                }
                window.IsPanelAnimating = false;
            })
            .catch(err =>
            {
                console.error(err);
                callbackiferror(err);
                window.IsPanelAnimating = false;
            });
        })();
    }
    // MIDTRANS VA --------------------------------------------------------------------------------
    else if(window.WhichPaymentTypeSelected == "Virtual Account" && window.WhichPaymentBankSelected == "BSI")
    {
        let MidtransVAURL = "/v2/payments/va/midtrans/request";
        formData.append('bank', window.WhichPaymentBankSelected);

        console.log(MidtransVAURL);
        console.log(window.ConvertFormDataToJSON(formData));
            
        window.CallApiAxios({
            method: "POST",
            url: MidtransVAURL,
            data: formData
        }).then(res =>
        {
            console.log(res);
            if(res.data.success == true)
            {
                window.VARequestData = res.data.data;
                window.VARequestData.ottopayva = false;
                callbackifsuccess();
            }
            window.IsPanelAnimating = false;
        })
        .catch(err =>
        {
            console.error(err);
            callbackiferror(err);
            window.IsPanelAnimating = false;
        });
    }
    // OTTOPAY VA --------------------------------------------------------------------------------
    else if(window.WhichPaymentTypeSelected == "Virtual Account")
    {
        let OttoPayVirtualAccountURL = "/v2/payments/va/ottopay/request";
        formData.append('bank', window.WhichPaymentBankSelected);

        console.log(OttoPayVirtualAccountURL);
        console.log(window.ConvertFormDataToJSON(formData));

        window.CallApiAxios({
            method: "POST",
            url: OttoPayVirtualAccountURL,
            data: formData
        }).then(res =>
        {
            console.log(res);
            if(res.data.success == true)
            {
                window.VARequestData = res.data.data;
                window.VARequestData.ottopayva = true;
                callbackifsuccess();
            }
            window.IsPanelAnimating = false;
        })
        .catch(err =>
        {
            console.error(err);
            callbackiferror(err);
            window.IsPanelAnimating = false;
        });  
    }
}

function DetermineSetUpAllPaymentInfoAndFunctionBefore(formData, LoadingBlocker, thisbookingdata)
{
    let ThisRefreshFunction = function()
    {
        RefreshCheckPaymentStatus(window.WhichPaymentTypeSelected, window.WhichPaymentBankSelected, formData);
    };
    let ThisTimeFunction = function()
    {
        RefreshCheckPaymentStatus(window.WhichPaymentTypeSelected, window.WhichPaymentBankSelected, formData);
    }

    if(window.WhichPaymentBankSelected == "QRIS" || window.WhichPaymentTypeSelected == "Card" || window.WhichPaymentBankSelected == "Card")
    {

    }
    else if(thisbookingdata.provider == "ottopay" || window.VARequestData.ottopayva == true)
    {
        ThisRefreshFunction = function()
        {
            window.open("/bookingdetails/" + window.CurrentCountryID + "/" + window.PushbookingData.booking_reference + ".html",'_blank');
        };

        ThisTimeFunction = null;
    }
    // else if(window.WhichPaymentTypeSelected == "Card" || window.WhichPaymentBankSelected == "Card")
    // {
    //     ThisRefreshFunction = null;
    //     ThisTimeFunction = null;
    // }
    else if(window.WhichPaymentTypeSelected == "Direct Transfer")
    {
        ThisRefreshFunction = function()
        {
            window.InstantiateVerifyDirectPayment(formData);
        };
        ThisTimeFunction = null;
    }

    SetUpAllPaymentInfoBasedOnInfoGet(LoadingBlocker, formData, ThisRefreshFunction, ThisTimeFunction);
}

function SetUpAllPaymentInfoBasedOnInfoGet(LoadingBlocker, formData, functiontocallonrefresh, functiontocallbasedontime)
{
    // Set Refresh Text and Button ---------------------------------------------------------------
    console.log("window.VARequestData", window.VARequestData);

    if (window.PushbookingData?.transaction?.provider === "ottopay" || window.VARequestData?.ottopayva === true)
    {
        document.getElementById("AlreadyPayHyperlinkText").innerHTML = window["AlreadyPayHyperlink2Txt" + window.CurrentCountryID];
    }
    else
    {
        document.getElementById("AlreadyPayHyperlinkText").innerHTML = window["AlreadyPayHyperlinkTxt" + window.CurrentCountryID];
    }

    RefreshHyperlinkButton = document.getElementById("RefreshHyperlinkButton");
    RefreshHyperlinkButton.onclick = function()
    {
        if(functiontocallonrefresh != null)
        functiontocallonrefresh();
    }

    // Transition to Payment Page ---------------------------------------------------------------------

    if(window.WhichPaymentTypeSelected == "Direct Transfer")
    {
        LoadingBlocker.remove();
        GetDirectTransfer();
    }
    else if(window.WhichPaymentTypeSelected == "Card")
    {
        window.EndTimeCountDown = window.ConvertThisToDate(window.VARequestData.expired_at, true);
        window.ChangeToSectionPaymentForm("Credit Card", true, ()=>
        {
            LoadingBlocker.remove();
            window.StartCountDown(CountDownPaymentText, 1, functiontocallbasedontime, functiontocallbasedontime);
        });
    }
    else if(window.WhichPaymentBankSelected == "blu")
    {
        // VA Text -----------------------------------------------------------------------

        if(window.VARequestData.va_transaction != null) // If New Booking -----------------------------------------------------------------------
        {
            BluAccountNumberText.innerHTML = window.VARequestData.va_transaction.no_va + " ";

            let CopyVANumberText = document.createElement("span");
            CopyVANumberText.className = "HyperlinkUnderlineText InterRegularTextFont";
            CopyVANumberText.innerHTML = window["CopyTxt" + window.CurrentCountryID];
            CopyVANumberText.onclick = function()
            {
                window.CopyToClipboardItem(window.VARequestData.va_transaction.no_va);
            }
            BluAccountNumberText.append(CopyVANumberText);
        }
        else // If Check Past Booking -----------------------------------------------------------------------
        {
            
            BluAccountNumberText.innerHTML = window.VARequestData.no_va + " ";

            let CopyVANumberText = document.createElement("span");
            CopyVANumberText.className = "HyperlinkUnderlineText InterRegularTextFont";
            CopyVANumberText.innerHTML = window["CopyTxt" + window.CurrentCountryID];
            CopyVANumberText.onclick = function()
            {
                window.CopyToClipboardItem(window.VARequestData.no_va);
            }
            BluAccountNumberText.append(CopyVANumberText);
        }


        // Start Count Down ----------------------------------------------------

        let CreatedDate = window.ConvertThisToDate(window.PushbookingData.create_update_at, true);

        let DateLimitDirectTransfer = new Date(CreatedDate.getTime() + 15 * 60 * 1000); // 10 Minutes After Created -----------------
        window.EndTimeCountDown = DateLimitDirectTransfer;

        window.ChangeToSectionPaymentForm("Waiting Payment", true, ()=>
        {
            LoadingBlocker.remove();
            window.StartCountDown(CountDownPaymentText, 1, functiontocallbasedontime, functiontocallbasedontime);
        });
    }
    else
    {
        if(window.WhichPaymentTypeSelected == "Digital Payment" || window.WhichPaymentTypeSelected == "Virtual Account")
        {
            // VA Text -----------------------------------------------------------------------
            VANumberPriceWaitingPayment.innerHTML = window.VARequestData.no_va + " ";

            let CopyVANumberText = document.createElement("span");
            CopyVANumberText.className = "HyperlinkUnderlineText InterRegularTextFont";
            CopyVANumberText.innerHTML = window["CopyTxt" + window.CurrentCountryID];
            CopyVANumberText.onclick = function()
            {
                window.CopyToClipboardItem(window.VARequestData.no_va);
            }
            VANumberPriceWaitingPayment.append(CopyVANumberText);


            // Start Count Down ----------------------------------------------------
            window.EndTimeCountDown = window.ConvertThisToDate(window.VARequestData.expired_at, true);
        }
        else if(window.WhichPaymentTypeSelected == "Instant Payment")
        {
            document.getElementById("ShowQRISButtonText").onclick = function()
            {
                ShowQRISButtonClicked(formData);
            }

            // Start Count Down ----------------------------------------------------

            let CreatedDate = window.ConvertThisToDate(window.PushbookingData.create_update_at, true);

            let DateLimitDirectTransfer = new Date(CreatedDate.getTime() + 10 * 60 * 1000); // 10 Minutes After Created -----------------
            window.EndTimeCountDown = DateLimitDirectTransfer;
        }

        window.ChangeToSectionPaymentForm("Waiting Payment", true, ()=>
        {
            LoadingBlocker.remove();
            window.StartCountDown(CountDownPaymentText, 1, functiontocallbasedontime, functiontocallbasedontime);
        });
    }
}





// ================================================ QRIS =============================================

function ShowQRISButtonClicked(formData)
{
    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker";
    BasicBlackBlocker.id = "BasicQRCodeBlocker";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let FlexFullDisplayPanel = document.createElement("div");
    FlexFullDisplayPanel.className = "FlexFullDisplayPanel";
    FlexFullDisplayPanel.id = "BasicQRCodeFlexDisplayPanel";
    BasicBlackBlocker.append(FlexFullDisplayPanel);
    
    let MainContainer = document.createElement("div");
    MainContainer.className = "FlexContainerBaseAnimate PingExprezyViewMoreContainer HideScrollBar";
    MainContainer.id = "SignInMainStepsWrapper";
    FlexFullDisplayPanel.append(MainContainer);

    let SignInHeadderCloseButton = document.createElement("img");
    SignInHeadderCloseButton.className = "CloseButtonInsidePanel Selectable2 AllContentMarginPayment";
    SignInHeadderCloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    SignInHeadderCloseButton.onclick = function()
    {
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, null);
    }
    MainContainer.append(SignInHeadderCloseButton);

    // Yellow Warning Top -------------------------------------------------------------------

    let YellowWarningTop = document.createElement("div");
    YellowWarningTop.className = "OrangeWarningContainer BasicRadius";
    YellowWarningTop.id = "SignInNotifPaymentForm";
    YellowWarningTop.style.display = "flex";
    YellowWarningTop.style.flexDirection = "row";
    MainContainer.append(YellowWarningTop);

    let YellowWarningIcon = document.createElement("img");
    YellowWarningIcon.src = "/Assets/images/ButtonIcon/warning-circle.svg";
    YellowWarningIcon.className = "WarningCircleIcon";
    YellowWarningTop.append(YellowWarningIcon);

    let YellowWarningText = document.createElement("p");
    YellowWarningText.className = "LabelGreyHeaderSmallerText InterRegularTextFont";
    YellowWarningText.id = "OrangeSignInMessageTop";
    YellowWarningText.style.margin = "auto 0px";
    YellowWarningText.innerHTML = window["YellowTopQRISShowTxt" + window.CurrentCountryID];
    YellowWarningTop.append(YellowWarningText);


    // QR AND LOADING CONTAINER =============================================================

    let QRISWrapperMargin = document.createElement("div");
    QRISWrapperMargin.className = "QRISWrapperMargin";
    MainContainer.append(QRISWrapperMargin);

    
    // QR CANVAS -------------------------------------------------------------------

    let QRCanvas = document.createElement("canvas");
    QRCanvas.className = "QRISCanvas";
    QRCanvas.style.display = "none";
    QRISWrapperMargin.append(QRCanvas);

    // Waiting Clock -------------------------------------------------------------------

    let WaitingContainer = document.createElement("div");
    WaitingContainer.className = "WaitingClockContainer";
    QRISWrapperMargin.append(WaitingContainer);

    let LottieContainer = document.createElement("div");
    LottieContainer.className = "BigIconInsidePanel5";
    LottieContainer.style = "margin: 0 auto;";
    WaitingContainer.append(LottieContainer);

    window.createLottie(LottieContainer, '/Assets/images/lottieanim/liquid hourglass.json', {});

    // let WaitingImg = document.createElement("img");
    // WaitingImg.className = "WaitingClockAnimated WaitingClockBigger";
    // WaitingImg.src = "/Assets/images/Icon/waiting-clock-icon.svg";
    // WaitingContainer.append(WaitingImg);

    let WaitingText = document.createElement("p");
    WaitingText.className = "LabelGreyHeaderText InterRegularTextFont";
    WaitingText.textContent = window["LoadingQRISButtonTxt" + window.CurrentCountryID];
    WaitingContainer.append(WaitingText);

    // Simpan QRIS Button -------------------------------------------------------------------

    let SimpanQRISButton = document.createElement("button");
    SimpanQRISButton.className = "BasicTextButton PaddingExtendedButton2 BasicBoxShadow OrangeButton SignInButtonTop Selectable";
    SimpanQRISButton.style.margin = "0 auto";
    SimpanQRISButton.innerHTML = window["SaveQRISButtonTxt" + window.CurrentCountryID];
    SimpanQRISButton.onclick = function()
    {
        window.DownloadCanvasasImage(QRCanvas, 'qr-payment-pingingo.jpg', 'image/jpeg');
    }
    QRISWrapperMargin.append(SimpanQRISButton);


    // BOTTOM INFO -------------------------------------------------------------------

    let BottomInfo = document.createElement("div");
    BottomInfo.className = "OrangeWarningContainer BasicRadius";
    BottomInfo.style.display = "flex";
    BottomInfo.style.flexDirection = "row";
    BottomInfo.style.backgroundColor = "#E9F4FB";
    MainContainer.append(BottomInfo);

    let BottomInner = document.createElement("div");
    BottomInner.style.display = "flex";
    BottomInner.style.flex = "1";
    BottomInfo.append(BottomInner);


    let LeftBox = document.createElement("div"); // Left Side -----------------------
    LeftBox.style.width = "auto";
    BottomInner.append(LeftBox);

    let NameLabel = document.createElement("p");
    NameLabel.className = "LabelGreyHeaderSmallerText2 InterRegularTextFont";
    NameLabel.id = "VirtualAccountNumberFinalHeaderText";
    NameLabel.textContent = window["NamaAkunTxt" + window.CurrentCountryID];
    LeftBox.append(NameLabel);

    let NameValue = document.createElement("p");
    NameValue.className = "LabelGreyHeaderText InterBoldTextFont";
    NameValue.id = "VANumberPriceWaitingPayment";
    NameValue.textContent = "PT PinginGo Bahagia Indonesia";
    LeftBox.append(NameValue);


    let RightBox = document.createElement("div"); // Right Side -----------------------
    RightBox.className = "TopPaymentInfoRight";
    BottomInner.append(RightBox);

    let TotalLabel = document.createElement("p");
    TotalLabel.className = "LabelGreyHeaderSmallerText2 InterRegularTextFont TotalDPToBePaidFinalText";
    TotalLabel.textContent = window["TotalBookingToBePaidTxt" + window.CurrentCountryID];
    RightBox.append(TotalLabel);

    let TotalValue = document.createElement("p");
    TotalValue.className = "PaymentPriceFinalToPay InterBoldTextFont DownPaymentText";
    TotalValue.textContent = window.ConvertTextToRP(DownPaymentPriceCalculated, 2, true, false);
    RightBox.append(TotalValue);


    let CheckQRISBlocker = window.InstantiateLoadingBlocker("LoadUserTopBlocker");
        

    CheckQRISStatus(formData, CheckQRISBlocker, true, ()=>
    {
        window.generateQR(window.CheckPaymentData.qrData, QRCanvas,
        ()=>
        {
            CheckQRISBlocker.remove();
            QRCanvas.style.display = "";
            WaitingContainer.style.display = "none";
        }, null);
    });

    // -------------------------- ANIMATE ----------------------------

    window.OpenPanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker);
}



function CheckQRISStatus(thisformdata, thisblocker, isnormalbooking, functiontocall)
{
    let URLCheckQRIS = "/v2/payments/qris/ottopay/status";
    console.log(URLCheckQRIS);

    window.CallApiAxios({
        method: "POST",
        url: URLCheckQRIS,
        data: thisformdata
    }).then(res =>
    {
        console.log(res);
        window.CheckPaymentData = res.data.data;

        if(res.data.code == 202)
        {
            functiontocall();
        }
        else if(res.data.code == 200)
        {
            CheckIfQRISBlockerExistRemoveIt();
            window.ChangeToSectionPaymentForm("Success", true, ()=>
            {
                window.IsPanelAnimating = false;
                thisblocker.remove();
            });
        }
    })
    .catch(err =>
    {
        console.error(err);
        if(err.data.message == "QRIS transaction timeout")
        {
            CheckIfQRISBlockerExistRemoveIt();
            window.ChangeToSectionPaymentForm("Timeout", true, ()=>
            {
                window.IsPanelAnimating = false;
                thisblocker.remove();
            });
        }
        else if(err.data.message == "Order ID Not Found at Payment Gateway" || err.data.message == "Transaction not found")
        {
            if(StepNameCurrent == "Select Payment")
            {
                CheckIfQRISBlockerExistRemoveIt();
                window.ChangeToSectionPaymentForm("Error", true, ()=>
                {
                    window.IsPanelAnimating = false;
                    thisblocker.remove();
                });
            }
        }
        else if(err.data.message == "QRIS transaction failed")
        {
            CheckIfQRISBlockerExistRemoveIt();
            window.ChangeToSectionPaymentForm("Failed", true, ()=>
            {
                window.IsPanelAnimating = false;
                thisblocker.remove();
            });
        }
        else if(err.data.message == "QRIS request failed")
        {
            window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["RequestQRISFailedTxt" + window.CurrentCountryID]);
            window.IsPanelAnimating = false;
            thisblocker.remove();
        }
        else // "QRIS check status failed"
        {
            window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["QRISCheckFailedErrorTxt" + window.CurrentCountryID]);
            window.IsPanelAnimating = false;
            thisblocker.remove();
        }
    });
}

function CheckIfQRISBlockerExistRemoveIt()
{
    if(document.getElementById("BasicQRCodeFlexDisplayPanel") != null || document.getElementById("BasicQRCodeBlocker") != null)
    window.ClosePanelAnimate(document.getElementById("BasicQRCodeFlexDisplayPanel"), document.getElementById("BasicQRCodeBlocker"), null);
}


// ================================================ GET DIRECT TRANSFER =============================================

function GetDirectTransfer()
{
    if(window.IsPanelAnimating == false)
    {
        window.IsPanelAnimating = true;
        let LoadingBlocker = window.InstantiateLoadingBlocker("DirectTransferBlocker");

        let TodayDate = window.GetAndConvertCurrentExactDate(false);
        console.log(TodayDate);
        let DateLimitDirectTransfer = new Date(TodayDate.getTime() + 24 * 60 * 60 * 1000);
        window.EndTimeCountDown = DateLimitDirectTransfer;
        console.log(window.EndTimeCountDown);

        PaymentAccountNumberText.innerHTML = "62899463174" + " ";

        let CopyVANumberText = document.createElement("span");
        CopyVANumberText.className = "HyperlinkUnderlineText InterRegularTextFont";
        CopyVANumberText.innerHTML = window["CopyTxt" + window.CurrentCountryID];
        CopyVANumberText.onclick = function()
        {
            window.CopyToClipboardItem("62899463174");
        }
        PaymentAccountNumberText.append(CopyVANumberText);

        // Verify Payment Button ------------------------------------------------

        RefreshHyperlinkButton.innerHTML = window["VerifyPaymentDirectHyperlinkTxt" + window.CurrentCountryID];

        // Animate ---------------------------------------------------------------

        window.ChangeToSectionPaymentForm("Waiting Payment", true, ()=>
        {
            window.IsPanelAnimating = false;
            LoadingBlocker.remove();
            window.StartCountDown(CountDownPaymentText, 1, null);
        });
    }
}

// ================================================ BLU PAYMENT SECTION =============================================

function CheckInputtedBlu(allowchange, thisformdatatopush, MainSession, loggedin)
{
    let IsInputtedValid = true;

    if(BluPaymentPhoneNumber.value == ""  || BluPaymentPhoneNumber.value.replace(/ /g, "") == "") // Email
    {
        IsInputtedValid = false;

        if(allowchange == true)
        {
            BluPaymentPhoneNumberContainer.className = "SmallPanelDropDownContainer InputFieldWarningOutline";
            BluPaymentPhoneNumberWarning.style.display = "";
            BluPaymentPhoneNumberWarningText.innerHTML = window["PhoneNumberCannotEmpty" + window.CurrentCountryID];
        }
    }

    if(IsInputtedValid == true)
    {
        RequestBluPaymentButton.className = "BasicTextButton BasicBoxShadow BluButton SignInButtonTop Selectable";
        RequestBluPaymentButton.onclick = function()
        {
            CheckandPushUserData(thisformdatatopush, MainSession, loggedin);
        }
    }
    else
    {
        RequestBluPaymentButton.className = "BasicTextButton BasicBoxShadow BluButton SignInButtonTop ButtonUnselectable";
        RequestBluPaymentButton.onclick = function(){};
    }
}

function CheckBluPaymentExist(thisformdata)
{
    if(window.IsPanelAnimating == false)
    {
        // window.IsPanelAnimating = true;
        // window.RemoveTimerAndVisibility(true);

        let URLCheckBluPayment = "/v2/payments/va/blu/status";

        window.CallApiAxios({
            method: "PATCH",
            url: URLCheckBluPayment,
            data: thisformdata
        }).then(res =>
        {
            console.log(res);
        })
        .catch(err =>
        {
            console.error(err);
        });

        return

        let CheckBluPaymentExistUrl = "/function/check_blu_in_app_transaction.php?id_booking=" + window.PushbookingData.id_booking;
        let LoadingBlocker = window.InstantiateLoadingBlocker("CheckBluBlocker");
        console.log(CheckBluPaymentExistUrl);

        window.$.ajax({
            type     : "GET",
            cache    : false,
            url      : CheckBluPaymentExistUrl,

            success  : function(data)
            {
                let CheckBluAppData = window.ConvertDataJSON(data);
                let CheckBluStatus = CheckBluAppData.blu_payment_data[0].status_blu;
                let CheckBluStatusPayment = CheckBluAppData.blu_payment_data[0].status_payment;

                console.log(CheckBluAppData);
                console.log(CheckBluStatus);
                console.log(CheckBluStatusPayment);


                if(CheckBluStatus == "Failed: No Data VA Transactions in Database" || CheckBluStatus == "Failed: No blu Request Transaction"
                || CheckBluStatus == "Failed: No Data Blu Payment Detail in Database" || CheckBluStatus == "Failed: Get Token Check Payment Failed. Try Again."
                || (CheckBluStatus == "Failed: Data Booking Tidak Ada" && CheckBluAppData.blu_payment_data[0].transaction_id == null)
                || CheckBluStatus == "Ulangi Request!" || ((CheckBluStatus == "Metode Pembayaran Tidak Dengan Blu VA" || CheckBluStatus == "Failed: Payment Method Without Virtual Account") && CheckBluStatusPayment == "Progress"))
                {
                    if(StepNameCurrent == "Select Payment" && CheckBluAppData.blu_payment_data[0].phone_number == null) // If Still Select Payment Move it To Input Phone Number
                    {
                        window.ChangeToSectionPaymentForm("Blu Input", true, ()=>
                        {
                            LoadingBlocker.remove();
                            window.IsPanelAnimating = false;
                            CheckInputtedBlu(false);
                        });
                    }
                    else // If This Already At Input Phone Number, Push Blu Database
                    {
                        // let PhoneNumberBlutoSend = "+" + BluPaymentCountryCode.getAttribute("country-code") + BluPaymentPhoneNumber.value;
                        let PhoneNumberBlutoSend = BluPaymentPhoneNumber.value;
                        let BluPromoCode = "";

                        let formData = new FormData();
                        formData.append('id_booking', window.PushbookingData.id_booking);
                        formData.append('phone_number', PhoneNumberBlutoSend);
                        formData.append('promo_code', BluPromoCode);

                        let PushBluURL = "/function/push_blu_in_app_payment.php";

                        console.log(PushBluURL);
                        console.log(window.ConvertFormDataToJSON(formData));

                        fetch(PushBluURL,
                        {
                            method: "POST",
                            body: formData,
                        })
                        .then(res => res.json())
                        .then(function(data)
                        {
                            let BluPaymentData = data;
                            let BluPaymentStatus = BluPaymentData.blu_payment_data[0].status_blu;

                            console.log(BluPaymentData);
                            console.log(BluPaymentStatus);

                            window.IsPanelAnimating = false;
                            LoadingBlocker.remove();

                            RespondBasedOnBluCheckStatus(BluPaymentData, BluPaymentStatus, window.PushbookingData.id_booking); // Response Based On Data and Status -------------------------
                        })
                        .catch(function(error)
                        {
                            console.log(error);
                            window.IsPanelAnimating = false;
                            LoadingBlocker.remove();
                        });
                    }
                }
                else
                {
                    if(CheckBluStatus == "Progress: Waiting For Payment" || CheckBluStatus == "Try Again: Check Payment Again" || CheckBluStatus == "Menunggu Pembayaran")
                    {
                        window.EndTimeCountDown = window.ConvertThisToDate(CheckBluAppData.booking_data[0].expired_at, true);
                        console.log(window.EndTimeCountDown);
                        
                        // --------------------------------------- CHANGE PAGE --------------------------------------------

                        if(StepNameCurrent != "Waiting Payment")
                        {
                            DownPaymentPriceCalculated = CheckBluAppData.booking_data[0].booking_fee;
                            UpdateAllTextAfterGet();

                            // --------------------------------- Blu Account Number ---------------------------------

                            document.getElementById("BluAccountNumberText").innerHTML = CheckBluAppData.blu_payment_data[0].phone_number + " ";

                            let BluAccountCopyHyperlink = document.createElement("span");
                            BluAccountCopyHyperlink.className = "HyperlinkUnderlineText InterRegularTextFont";
                            BluAccountCopyHyperlink.onclick = function()
                            {
                                navigator.clipboard.writeText(CheckBluAppData.blu_payment_data[0].phone_number);
                            }
                            document.getElementById("BluAccountNumberText").append(BluAccountCopyHyperlink);


                            document.getElementById("RefreshHyperlinkButton").onclick = function()
                            {
                                CheckBluPaymentExist();
                            }

                            // --------------------------------- Start Calculated ---------------------------------

                            window.ChangeToSectionPaymentForm("Waiting Payment", true, ()=>
                            {
                                window.IsPanelAnimating = false;
                                LoadingBlocker.remove();
                                window.StartCountDown(CountDownPaymentText, 1, ()=>CheckBluPaymentExist(), ()=>CheckBluPaymentExist());
                            });
                        }
                        else
                        {
                            window.IsPanelAnimating = false;
                            LoadingBlocker.remove();
                            // window.StartCountDown(CountDownPaymentText, 1, ()=>CheckBluPaymentExist(), ()=>CheckBluPaymentExist());
                        }
                    }
                    else
                    {
                        window.IsPanelAnimating = false;

                        if(CheckBluStatus == "Failed: Virtual Account Payment Without blu" || CheckBluStatus == "Failed: Payment Method Without Virtual Account")
                        {
                            CancelBookingPayment(window.PushbookingData.id_booking);
                            LoadingBlocker.remove();
                        }
                        else if(CheckBluStatus == "Payment Successfully" || CheckBluStatus == 'Failed: Payment Telah Dilakukan')
                        {
                            PaymentBookingID = window.PushbookingData.id_booking;
                            window.ChangeToSectionPaymentForm("Success", true, ()=>
                            {
                                window.IsPanelAnimating = false;
                                LoadingBlocker.remove();
                            });
                        }
                        else if(CheckBluStatus == "Failed: Payment Telah Dibatalkan" || CheckBluStatus == "Failed: Payment Failed")
                        {
                            PaymentBookingID = window.PushbookingData.id_booking;
                            window.ChangeToSectionPaymentForm("Error", true, ()=>
                            {
                                window.IsPanelAnimating = false;
                                LoadingBlocker.remove();
                            });
                        }
                        else if(CheckBluStatus == "Failed: Payment Timeout" || CheckBluStatus == "Pembayaran Timeout" || CheckBluStatusPayment == "Timeout")
                        {
                            PaymentBookingID = window.PushbookingData.id_booking;
                            window.ChangeToSectionPaymentForm("Timeout", true, ()=>
                            {
                                window.IsPanelAnimating = false;
                                LoadingBlocker.remove();
                            });
                        }
                    }
                }
            },
            error: function (error)
            {
                console.log(error);
                window.IsPanelAnimating = false;
                LoadingBlocker.remove();
            }
        });
    }
}

function RespondBasedOnBluCheckStatus(BluPaymentData, BluPaymentStatus, BookingID)
{
    if(BluPaymentData.blu_payment_data[0].error_code == "ESB-20-003" || BluPaymentData.blu_payment_data[0].error_message_en == "Account Not Found" || BluPaymentStatus == "Failed: Request Transaction Failed")
    {
        BluPaymentPhoneNumberWarning.style.display = "";


        BluPaymentPhoneNumberContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon InputFieldWarningOutline Selectable3";

        if(BluPaymentStatus == "Failed: Request Transaction Failed")
        {
            BluPaymentPhoneNumberWarningText.innerHTML = window["FailedToRequestBluPaymentTxt" + window.CurrentCountryID];
        }
        else
        {
            BluPaymentPhoneNumberWarningText.innerHTML = window["bluAccountNotFoundErrorTxt2" + window.CurrentCountryID];
            RequestBluPaymentButton.className = "BasicTextButton BasicBoxShadow BluButton SignInButtonTop ButtonUnselectable";
            RequestBluPaymentButton.onclick = function(){};
        }
    }
    else if(BluPaymentStatus == "Failed: Payment Timeout")
    {
        let LoadingBlocker = window.InstantiateLoadingBlocker("TimeOutBlocker");
        PaymentBookingID = BookingID;

        window.ChangeToSectionPaymentForm("Timeout", true, ()=>
        {
            window.IsPanelAnimating = false;
            LoadingBlocker.remove();
        });
    }
    else if(BluPaymentStatus == "Progress: Payment On Progress" || BluPaymentStatus == "Progress: Booking Fee Di Atas 0" || BluPaymentStatus == "Progress: Check Blu Payment Detail" || BluPaymentStatus == "Failed: Data Request Transaction Sudah Ada"
    || BluPaymentStatus == "Failed: Request Transaction Failed" || BluPaymentStatus == "Failed: Get Token Request Transaction Failed" || BluPaymentStatus == "Progress: Call API Blu In App Payment" || BluPaymentStatus == "Progress: Insert Blu Payment Detail"
    || BluPaymentStatus == "Progress: Insert Data VA Transaction Database" || BluPaymentStatus == "Progress: Success Insert Data VA Transaction Database" || BluPaymentStatus == "Progress: Insert Blu Payment Detail" || BluPaymentStatus == "Progress: Call API Blu In App Payment"
    || BluPaymentStatus == "Failed: Insert Blu Payment Detail"  || BluPaymentStatus == "Menunggu Pembayaran")
    {

    }
    else if(BluPaymentStatus == "Success Request Transaction")
    {
        //--------------------------------------- CHANGE PAGE --------------------------------------------

        let LoadingBlocker = window.InstantiateLoadingBlocker("BluChangeBlocker");
        window.EndTimeCountDown = window.ConvertThisToDate(BluPaymentData.blu_payment_data[0].expired_at, true);
        console.log(window.EndTimeCountDown);
        DownPaymentPriceCalculated = parseInt(BluPaymentData.booking_data[0].booking_fee);

        window.ChangeToSectionPaymentForm("Waiting Payment", true, ()=>
        {
            window.StartCountDown(CountDownPaymentText, 1, ()=>CheckBluPaymentExist(), ()=>CheckBluPaymentExist());
            LoadingBlocker.remove();
        });

        document.getElementById("BluAccountNumberText").innerHTML = BluPaymentData.blu_payment_data[0].phone_number + " <a class='HyperlinkUnderlineText InterRegularTextFont' id='BluAccountCopyHyperlink'>" + window["CopyTxt" + window.CurrentCountryID] +"</a>";

        let BluAccountCopyHyperlink = document.createElement("span");
        BluAccountCopyHyperlink.className = "HyperlinkUnderlineText InterRegularTextFont";
        BluAccountCopyHyperlink.onclick = function()
        {
            navigator.clipboard.writeText(BluPaymentData.blu_payment_data[0].phone_number);
        }
        document.getElementById("BluAccountNumberText").append(BluAccountCopyHyperlink);

        document.getElementById("RefreshHyperlinkButton").onclick = function()
        {
            CheckBluPaymentExist();
        }
    }
    else if(BluPaymentStatus == "Failed: Payment telah dilakukan!")
    {
        let LoadingBlocker = window.InstantiateLoadingBlocker("BluPaymentAlreadyBlocker");
        PaymentBookingID = BookingID;
        window.ChangeToSectionPaymentForm("Success", true, ()=>
        {
            window.IsPanelAnimating = false;
            LoadingBlocker.remove();
        });
    }
    else if(BluPaymentStatus == "Failed: Payment telah dibatalkan!" || (BluPaymentStatus == "Failed: Data Booking Tidak Ada" && BluPaymentData.blu_payment_data[0].transaction_id != null))
    {
        let LoadingBlocker = window.InstantiateLoadingBlocker("BluPaymentCancelledBlocker");
        PaymentBookingID = BookingID;
        window.ChangeToSectionPaymentForm("Failed", true, ()=>
        {
            window.IsPanelAnimating = false;
            LoadingBlocker.remove();
        });
    }
    else if(BluPaymentStatus == "Failed: Sudah melakukan request payment dengan bank lain!")
    {
        if(window.PushbookingData.bank_user == "blu")
        {
            PreviousBookingFound(()=>
            {
                CheckBluPaymentExist();
            }, BookingID);
        }
        else
        {
            // DirectOrVARequestSend(true);
        }
    }
    else if(BluPaymentStatus == "Failed: Booking Fee Rp 0")
    {
        ChangeToFinalResult("Failed", false, null);
    }
}

// ===================================== CANCEL BOOKING ======================================

function CancelBookingPayment(bookingid)
{
    if(window.IsPanelAnimating == false)
    {
        window.IsPanelAnimating = true;
        window.RemoveTimerAndVisibility(true);
        clearInterval(window.CountDownTimerInterval);

        let LoadingBlocker = window.InstantiateLoadingBlocker("CancelDataBookingBlocker");

        let CancelBookingURL = "/function/cancel_data_booking.php?id_booking=" + bookingid;

        window.$.ajax({
            type     : "GET",
            cache    : false,
            url      : CancelBookingURL,

            success  : function(data)
            {
                var CancelBookingData = window.ConvertDataJSON(data);

                console.log(CancelBookingURL);
                console.log(CancelBookingData);
                window.IsPanelAnimating = false;

                if(CancelBookingData.status_update == "Success")
                {
                    window.ChangeToSectionPaymentForm("Failed", true, ()=>
                    {
                        LoadingBlocker.remove();
                        window.IsPanelAnimating = false;
                    });
                }
                else
                {
                    LoadingBlocker.remove();
                }
            },
            error: function (error)
            {
                console.log(error);
                window.IsPanelAnimating = false;
            }
        });
    }

}

// ===================================== REFRESH PAGE =======================================


function RefreshCheckPaymentStatus(paymenttype, bankmethod, formData)
{
    console.log("paymenttype", paymenttype);
    console.log("bankmethod", bankmethod);
    
    let WhichURL = "/v2/payments/va/blu/status";
    let LoadingBlocker = window.InstantiateLoadingBlocker("QRISErrorBlocker");

    if(bankmethod == "QRIS") // QRIS ======================================================================================================
    {
        WhichURL = "/v2/payments/qris/ottopay/status";
        console.log(WhichURL);

        window.CallApiAxios({
            method: "POST",
            url: WhichURL,
            data: formData
        }).then(res =>
        {
            window.CheckPaymentData = res.data.data;
            console.log(window.CheckPaymentData);

            if(res.data.code == 202)
            {
                LoadingBlocker.remove();
            }
            else if(res.data.code == 200)
            {
                CheckIfQRISBlockerExistRemoveIt();
                window.ChangeToSectionPaymentForm("Success", true, ()=>
                {
                    window.IsPanelAnimating = false;
                    LoadingBlocker.remove();
                });
            }
        })
        .catch(err =>
        {
            console.error(err);
            console.log(err.data.message);

            if(err.data.message == "QRIS transaction timeout" || err.data.message == "Transaction Timeout" || err.data.code == 400)
            {
                CheckIfQRISBlockerExistRemoveIt();
                window.ChangeToSectionPaymentForm("Timeout", true, ()=>
                {
                    window.IsPanelAnimating = false;
                    LoadingBlocker.remove();
                });
            }
            else if(err.data.message == "Order ID Not Found at Payment Gateway" || err.data.message == "Transaction not found" || err.data.message == "QRIS request failed"
            || err.data.code == 402 || err.data.code == 404 || err.data.code == 422)
            {
                CheckIfQRISBlockerExistRemoveIt();
                window.ChangeToSectionPaymentForm("Error", true, ()=>
                {
                    window.IsPanelAnimating = false;
                    LoadingBlocker.remove();
                });
            }
            else if(err.data.message == "QRIS transaction failed" || err.data.code == 408)
            {
                CheckIfQRISBlockerExistRemoveIt();
                window.ChangeToSectionPaymentForm("Failed", true, ()=>
                {
                    window.IsPanelAnimating = false;
                    LoadingBlocker.remove();
                });
            }
            else // "QRIS check status failed"
            {
                LoadingBlocker.remove();
                window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["QRISCheckFailedErrorTxt" + window.CurrentCountryID]);
                window.IsPanelAnimating = false;
            }
        });
    }
    else
    {
        if(paymenttype == "Card")
        {
            WhichURL = "/v2/payments/card/ottopay/status";
        }
        else if(paymenttype == "Virtual Account" && bankmethod == "BSI")
        {
            WhichURL = "/v2/payments/va/midtrans/status";
        }
        else if(bankmethod == "blu")
        {
            CheckBluPaymentStatus(formData, LoadingBlocker);
            return
        }
        else if(paymenttype == "Virtual Account")
        {
            WhichURL = "/v2/payments/card/ottopay/status";
            LoadingBlocker.remove();
            return
        }

        console.log(WhichURL);
        console.log(window.ConvertFormDataToJSON(formData));

        window.CallApiAxios({
            method: "PATCH",
            url: WhichURL,
            data: formData
        }).then(res =>
        {
            window.CheckPaymentData = res.data;
            console.log(window.CheckPaymentData);

            if(res.data.code == 202)
            {
                LoadingBlocker.remove();
            }
            else if(res.data.code == 200)
            {
                window.ChangeToSectionPaymentForm("Success", true, ()=>
                {
                    window.IsPanelAnimating = false;
                    LoadingBlocker.remove();
                });
            }
            else if(res.data.code == 402 || res.data.code == 404 || res.data.code == 401)  // Error ------------------
            {
                window.ChangeToSectionPaymentForm("Error", true, ()=>
                {
                    window.IsPanelAnimating = false;
                    LoadingBlocker.remove();
                });
            }
            else if(res.data.code == 405) // Failed ------------------
            {
                window.ChangeToSectionPaymentForm("Failed", true, ()=>
                {
                    window.IsPanelAnimating = false;
                    LoadingBlocker.remove();
                });
            }
            else if(res.data.code == 408) // Timeout --------------------
            {
                window.ChangeToSectionPaymentForm("Timeout", true, ()=>
                {
                    window.IsPanelAnimating = false;
                    LoadingBlocker.remove();
                });
            }
            else
            {
                LoadingBlocker.remove();
                window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["CheckPaymentStatusFailedErrorTxt" + window.CurrentCountryID]);
                window.IsPanelAnimating = false;
            }
        })
        .catch(err =>
        {
            console.error(err);
            if(err.data.code == 402 || err.data.code == 404 || err.data.code == 401)  // Error ------------------
            {
                window.ChangeToSectionPaymentForm("Error", true, ()=>
                {
                    window.IsPanelAnimating = false;
                    LoadingBlocker.remove();
                });
            }
            else if(err.data.code == 405) // Failed ------------------
            {
                window.ChangeToSectionPaymentForm("Failed", true, ()=>
                {
                    window.IsPanelAnimating = false;
                    LoadingBlocker.remove();
                });
            }
            else if(err.data.code == 408) // Timeout --------------------
            {
                window.ChangeToSectionPaymentForm("Timeout", true, ()=>
                {
                    window.IsPanelAnimating = false;
                    LoadingBlocker.remove();
                });
            }
            else
            {
                LoadingBlocker.remove();
                window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["CheckPaymentStatusFailedErrorTxt" + window.CurrentCountryID]);
                window.IsPanelAnimating = false;
            }
        });
    }
}

function CheckBluPaymentStatus(formData, LoadingBlocker)
{
    let WhichURL = "/v2/payments/va/blu/status";

    window.CallApiAxios({
        method: "PATCH",
        url: WhichURL,
        data: formData
    }).then(res =>
    {
        window.CheckPaymentData = res.data;
        console.log(res);
        console.log(window.CheckPaymentData);

        if(window.CheckPaymentData.status_blu != null)
        {
            let CheckStatusBlu = window.CheckPaymentData.status_blu;

            if(CheckStatusBlu.status_payment == "Progress" || res.status == 202)
            {
                LoadingBlocker.remove();
            }
            else if(CheckStatusBlu.status_payment == "Success" || res.status == 200)
            {
                window.ChangeToSectionPaymentForm("Success", true, ()=>
                {
                    window.IsPanelAnimating = false;
                    LoadingBlocker.remove();
                });
            }
            else
            {
                window.ChangeToSectionPaymentForm("Failed", true, ()=>
                {
                    window.IsPanelAnimating = false;
                    LoadingBlocker.remove();
                });
            }
        }
        else
        {
            if(res.data.message == "Transaction is not eligible for payment status check")
            {
                window.ChangeToSectionPaymentForm("Failed", true, ()=>
                {
                    window.IsPanelAnimating = false;
                    LoadingBlocker.remove();
                });
            }
            else
            {
                LoadingBlocker.remove();
                window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["CheckPaymentStatusFailedErrorTxt" + window.CurrentCountryID]);
                window.IsPanelAnimating = false;
            }
        }
    })
    .catch(err =>
    {
        console.error(err);

        if(err.data.status_blu != null)
        {
            let StatusBluError = err.data.status_blu;
            if(StatusBluError.status_token_payment == "Failed")
            {
                window.ChangeToSectionPaymentForm("Failed", true, ()=>
                {
                    window.IsPanelAnimating = false;
                    LoadingBlocker.remove();
                });
            }
            else
            {
                LoadingBlocker.remove();
            }
        }
        else
        {
            if(err.data.code == 402 || err.data.code == 404 || err.data.code == 401)  // Error ------------------
            {
                window.ChangeToSectionPaymentForm("Error", true, ()=>
                {
                    window.IsPanelAnimating = false;
                    LoadingBlocker.remove();
                });
            }
            else if(err.data.code == 405 || err.data.code == 400) // Failed ------------------
            {
                window.ChangeToSectionPaymentForm("Failed", true, ()=>
                {
                    window.IsPanelAnimating = false;
                    LoadingBlocker.remove();
                });
            }
            else if(err.data.code == 408) // Timeout --------------------
            {
                window.ChangeToSectionPaymentForm("Timeout", true, ()=>
                {
                    window.IsPanelAnimating = false;
                    LoadingBlocker.remove();
                });
            }
            else
            {
                LoadingBlocker.remove();
                window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["CheckPaymentStatusFailedErrorTxt" + window.CurrentCountryID]);
                window.IsPanelAnimating = false;
            }
        }

    });
}


// !!!!!!!!!!!!!!!!!!!!!!!!!!!! OLD !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

function RefreshPagePayment(bankmethod, status, idva, nova, bookingid)
{
    if(window.IsPanelAnimating == false)
    {
        let LoadingBlocker = window.InstantiateLoadingBlocker("CheckVATransactionBlocker");
        window.IsPanelAnimating = true;

        let RefreshURL = "/function/check_va_transaction.php?method_bank=" + bankmethod + "&status=" + status + "&id_va=" + idva + "&no_va=" + nova;
        console.log(RefreshURL);
        

        window.$.ajax({
            type     : "GET",
            cache    : false,
            url      : RefreshURL,
            success  : function(data)
            {
                var CheckVAData = window.ConvertDataJSON(data);
                console.log(CheckVAData);

                window.IsPanelAnimating = false;
                LoadingBlocker.remove();

                if(CheckVAData.transaction_status == "settlement" && CheckVAData.status_code == 200 && CheckVAData.fraud_status == "accept")
                {
                    let LoadingBlocker = window.InstantiateLoadingBlocker("CheckVASuccessTransactionBlocker");
                    PaymentBookingID = bookingid;

                    window.ChangeToSectionPaymentForm("Success", true, ()=>
                    {
                        window.IsPanelAnimating = false;
                        LoadingBlocker.remove();
                    });
                }
                else
                {
                    if(CheckVAData.transaction_status == "expire")
                    {
                        let LoadingBlocker = window.InstantiateLoadingBlocker("CheckVAExpiredTransactionBlocker");
                        PaymentBookingID = bookingid;
                        window.ChangeToSectionPaymentForm("Timeout", true, ()=>
                        {
                            window.IsPanelAnimating = false;
                            LoadingBlocker.remove();
                        });
                    }
                    else
                    {
                        if(CheckVAData.transaction_status == "pending")
                        {
                            window.EndTimeCountDown = window.ConvertThisToDate(CheckVAData.expiry_time, true);
                            console.log(window.EndTimeCountDown);
                            window.StartCountDown(CountDownPaymentText, 1, ()=>RefreshPagePayment(window.WhichPaymentBankSelected, window.VARequestData.status, window.VARequestData.id_va, window.VARequestData.no_va, window.PushbookingData.id_booking), ()=>RefreshPagePayment(window.WhichPaymentBankSelected, window.VARequestData.status, window.VARequestData.id_va, window.VARequestData.no_va, window.PushbookingData.id_booking));
                        }
                        else if(CheckVAData.transaction_status == null)
                        {
                            if(CheckVAData.includes("Gagal") == true)
                            {
                                alert("Sorry. Our system is recovering from unexpected issues. Please retry.");
                            }
                        }
                        else if(CheckVAData.status_code == "500")
                        {
                            alert("Sorry. Our system is recovering from unexpected issues. Please retry.");
                        }
                        else
                        {
                            let LoadingBlocker = window.InstantiateLoadingBlocker("CheckVAErrorTransactionBlocker");
                            PaymentBookingID = bookingid;
                            window.ChangeToSectionPaymentForm("Error", true, ()=>
                            {
                                window.IsPanelAnimating = false;
                                LoadingBlocker.remove();
                            });
                        }
                    }
                }
            },
            error: function (error)
            {
                window.IsPanelAnimating = false;
                LoadingBlocker.remove();
                console.log(error);
            }
        });
    }
}


// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!




// ========================================== CHANGE TYPE =====================================

window.ChangeToSectionPaymentForm = function(newstepname, isallowchange, functiontocall)
{
    let WhichStepNumber = 1;
    let NextPanelToAnimate = InputInfoPaymentContainer;
    let IsThisFinal = false;

    // ------------------------------- REMOVE VISIBILITY -------------------------------

    window.RemoveTimerAndVisibility(true);
    clearInterval(window.CountDownTimerInterval);

    // ------------------------------- APPLY CHANGES BASED ON TYPE -------------------------------


    if(newstepname != null)
    {
        if(StepNameCurrent != "" && StepNameCurrent != null)
        {
            StepNamePrev.push(StepNameCurrent);
            RealBackArrowPayment.style.display = "";
            window.BackArrowNonPaymentA.style.display = "none";
        }
        else
        {
            RealBackArrowPayment.style.display = "none";
            window.BackArrowNonPaymentA.style.display = "flex";
        }
        StepNameCurrent = newstepname;
    }
    else
    {
        if(StepNamePrev.length > 0)
        {
            StepNameCurrent = StepNamePrev[StepNamePrev.length - 1];
            StepNamePrev.splice(-1)

            if(StepNamePrev.length == 0)
            {
                RealBackArrowPayment.style.display = "none";
                window.BackArrowNonPaymentA.style.display = "";
            }
        }
        else
        {
            // window.open(document.referrer, "_blank");
            return
        }
    }

    // -------------------------------- MOVE THE PANEL ------------------------------

    if(StepNameCurrent == "Input Form")
    {
        WhichStepNumber = 1;
        NextPanelToAnimate = InputInfoPaymentContainer;
        window.ScrollToWindow(InputInfoPaymentContainer);
        MainHeaderTextPayment.innerHTML = window["BookingDetailsTxt" + window.CurrentCountryID];
    }
    else if(StepNameCurrent == "Select Payment" || StepNameCurrent == "Waiting Payment" || StepNameCurrent == "Blu Input" || StepNameCurrent == "Credit Card")
    {
        WhichStepNumber = 2;

        if(StepNameCurrent == "Select Payment")
        {
            NextPanelToAnimate = SelectPaymentContainer;
            window.ScrollToWindow(SelectPaymentContainer);
            MainHeaderTextPayment.innerHTML = window["PaymentDetailsTxt" + window.CurrentCountryID];
        }
        else if(StepNameCurrent == "Waiting Payment")
        {
            NextPanelToAnimate = CountdownWaitPaymentContainer;
            window.ScrollToWindow(CountdownWaitPaymentContainer);
            MainHeaderTextPayment.innerHTML = window["WaitingPaymentTxt" + window.CurrentCountryID];

            // Change the Payment Rule Wrapper ------------------------------------------------------------
            UpdateWaitingPaymentInfo();
        }
        else if(StepNameCurrent == "Credit Card")
        {
            NextPanelToAnimate = CreditCardWaitingContainer;
            window.ScrollToWindow(CreditCardWaitingContainer);
            MainHeaderTextPayment.innerHTML = window["AddCardCreditTxt" + window.CurrentCountryID];
        }
        else if(StepNameCurrent == "Blu Input")
        {
            NextPanelToAnimate = BluInputPhoneContainer;
            window.ScrollToWindow(BluInputPhoneContainer);
            MainHeaderTextPayment.innerHTML = window["BlubyBCADigitalTxt" + window.CurrentCountryID];
        }
    }
    else if(StepNameCurrent == "Success" || StepNameCurrent == "Timeout" || StepNameCurrent == "Error" || StepNameCurrent == "Cancelled"  || StepNameCurrent == "Failed")
    {
        WhichStepNumber = 3;
        StepNamePrev = [];
        IsThisFinal = true;

        if(StepNameCurrent == "Success")
        {
            MainHeaderTextPayment.innerHTML = window["BookingConfirmedTxt" + window.CurrentCountryID];
        }
        else
        {
            MainHeaderTextPayment.innerHTML = window["BookingFailedTxt" + window.CurrentCountryID];
        }
    }
    else
    {
        // window.open(document.referrer, "_blank");
        return
    }

    // ----------------------------- CHANGE BACK BUTTON TO RETURN TO BEGINNING -----------------------------------

    if(StepNameCurrent == "Waiting Payment" || StepNameCurrent == "Credit Card" || StepNameCurrent == "Success" || StepNameCurrent == "Timeout" || StepNameCurrent == "Error" || StepNameCurrent == "Cancelled"  || StepNameCurrent == "Failed")
    {
        StepNamePrev = ["Input Form"];
    }

    // ------------------------------ TOP STEP ----------------------------

    ChangeTopStepSelected(WhichStepNumber);

    // ---------------------------- TOTAL DP TO PAID TOP --------------------------------

    ChangeRightContainer(WhichStepNumber, IsThisFinal);

    // ---------------------------- PAYMENT LEFT ANIMATE ----------------------------------
    if(IsThisFinal == false)
    {
        if(window.CurrentFinalAnimatedPanel == null || (NextPanelToAnimate.compareDocumentPosition(window.CurrentFinalAnimatedPanel) & Node.DOCUMENT_POSITION_PRECEDING))
        {
            window.AnimatePanelNextTransition(window.CurrentFinalAnimatedPanel, NextPanelToAnimate, isallowchange, functiontocall);
        }
        else
        {
            window.AnimatePanelPreviousTransition(window.CurrentFinalAnimatedPanel, NextPanelToAnimate, isallowchange, functiontocall);
        }
    }
    else
    {
        ChangeToFinalResult(StepNameCurrent, true, functiontocall);
    }
}

//  UPDATE WAITING PAYMENT BASED ON SELECTED PAYMENT TYPE ----------------------------------------------

function UpdateWaitingPaymentInfo()
{
    let WaitingPaymentLogoAndNameContainer = document.getElementById("WaitingPaymentLogoAndNameContainer");
    
    // Name and Icon ------------------------------------------------------------
    PaymentMethodButton.forEach(Button =>
    {
        let ThisRadioButton = Button.querySelector('input[type=radio]');
        if(window.WhichPaymentBankSelected == ThisRadioButton.value && window.WhichPaymentTypeSelected == ThisRadioButton.getAttribute("which-type"))
        {
            WaitingPaymentLogoAndNameContainer.innerHTML = "";

            let WhichIcon = Button.querySelector('.ThisPaymentMethodIcon');
            let ClonedIcon = WhichIcon.cloneNode(true);
            
            WaitingPaymentLogoAndNameContainer.append(ClonedIcon);

            let SelectedPaymentText = document.createElement("p");
            SelectedPaymentText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
            SelectedPaymentText.style.color = "white";
            SelectedPaymentText.style.margin = "auto 0";
            SelectedPaymentText.innerHTML = Button.querySelector('.LabelGreyHeaderSmallerText').innerHTML
            WaitingPaymentLogoAndNameContainer.append(SelectedPaymentText);
        }
    });

    // Change the Payment Rule Wrapper ------------------------------------------------------------
    let MainInformationPaymentWrapper = document.querySelectorAll('.MainInformationPaymentWrapper');

    let WhichIDWaitingPayment = "WaitingPayment" + window.WhichPaymentTypeSelected.replace(/ /g,'');
    if(window.WhichPaymentBankSelected == "blu")
    {
        WhichIDWaitingPayment = "WaitingPaymentblu";
    }
    else if(window.WhichPaymentBankSelected == "QRIS")
    {
        WhichIDWaitingPayment = "WaitingPaymentQRIS";
    }

    MainInformationPaymentWrapper.forEach(ThisWrapper =>
    {
        if(ThisWrapper.id == WhichIDWaitingPayment)
        {
            ThisWrapper.style.display = "";
        }
        else
        {
            ThisWrapper.style.display = "none";
        }
    });

    // Change Step and Rule (Virtual Account) ------------------------------------------------------

    if(window.WhichPaymentTypeSelected == "Virtual Account")
    {
        let StepForVA = document.getElementById("PaymentSteporRulesContainerVA");
        StepForVA.innerHTML = "";
        let WhichStepVAList = window.StepPayVABasedOnTypeTxt[window.WhichPaymentBankSelected];
        
        for(let i = 0; i < WhichStepVAList.length; i++)
        {
            let PaymentRulesAndStepsMainWrapper = document.createElement("div");
            PaymentRulesAndStepsMainWrapper.className = "PaymentRulesAndStepsMainWrapper";
            StepForVA.append(PaymentRulesAndStepsMainWrapper);

            let ThisStepP = document.createElement("p");
            ThisStepP.className = "LabelGreyHeaderSmallerText2 InterExBoldTextFont InputFieldMargin3";
            ThisStepP.innerHTML = WhichStepVAList[i].header[window.CurrentCountryID];
            PaymentRulesAndStepsMainWrapper.append(ThisStepP);

            let PaymentFinalListContainerUL = document.createElement("ul")
            PaymentFinalListContainerUL.className = "PaymentFinalListContainer BasicListContainer DottedCounterUL InterRegularTextFont InputFieldMargin6";
            PaymentRulesAndStepsMainWrapper.append(PaymentFinalListContainerUL);

            let WhichStepsTextList = WhichStepVAList[i].message[window.CurrentCountryID];
            WhichStepsTextList.forEach(ThisStep =>
            {
                let ThisStepLi = document.createElement("li");
                ThisStepLi.className = "DottedCounterLiBig";
                PaymentFinalListContainerUL.append(ThisStepLi);

                let ThisStepP = document.createElement("p");
                ThisStepP.className = "LabelGreyHeaderSmallerText2 InterRegularTextFont";
                ThisStepP.innerHTML = ThisStep;
                ThisStepLi.append(ThisStepP);
            });
        }
    }
}


function ChangeTopStepSelected(WhichStepNumber)
{
    let StepPaymentTopLines = document.querySelectorAll('.PaymentTopLineAndTextContainer');
    let IsPassed = false;

    if(StepNameCurrent == "Timeout" || StepNameCurrent == "Error"  || StepNameCurrent == "Failed")
    {
        WhichStepNumber = 2;
    }

    for(let i = 0; i < StepPaymentTopLines.length; i++)
    {
        StepPaymentTopLines[i].classList.add("CurrentProgressPayment");

        if(StepPaymentTopLines[i].id == "CurrentPaymentStep" + WhichStepNumber)
        {
            IsPassed = true;
        }
        else if(IsPassed == true)
        {
            StepPaymentTopLines[i].classList.remove("CurrentProgressPayment");
        }
    }

}

function ChangeRightContainer(WhichStepNumber, IsThisFinal)
{
    let TotalDPHeaderTopContainer = document.getElementById("TotalBookingPaymentBellowHeaderMain");
    if(WhichStepNumber <=1 || IsThisFinal == true) // If Early Section
    {
        if(TotalDPHeaderTopContainer.style.display != "none")
        {
            window.AnimateOnlyOpacityDisplay(TotalDPHeaderTopContainer, true, ()=> TotalDPHeaderTopContainer.style.display = "none");
        }

        if(PaymentRightSection.classList.contains("PaymentSectionVer1") == false)
        {
            window.AnimateOnlyOpacityDisplay(PaymentRightSection, true, () =>
            {
                PaymentRightSection.className = "PaymentInfoRightSection PaymentSectionVer1";
                window.AnimateOnlyOpacityDisplay(PaymentRightSection, false, () => null);
            });
        }
    }
    else  // If Choose Payment Section Until End
    {
        if(TotalDPHeaderTopContainer.style.display == "none")
        {
            window.AnimateOnlyOpacityDisplay(TotalDPHeaderTopContainer, false, ()=> TotalDPHeaderTopContainer.style.display = "");
        }

        if(PaymentRightSection.classList.contains("PaymentSectionVer2") == false)
        {
            window.AnimateOnlyOpacityDisplay(PaymentRightSection, true, () =>
            {
                PaymentRightSection.className = "PaymentInfoRightSection PaymentSectionVer2";
                window.AnimateOnlyOpacityDisplay(PaymentRightSection, false, () => null);
            });
        }
    }
}

function ChangeToFinalResult(whichtype, isthisnotzero, functiontocall)
{
    window.RemoveTimerAndVisibility(true);

    if(window.IsPanelAnimating == false && FinalResultMainContainer == null)
    {
        window.IsPanelAnimating = true;

        // --------------------------------- FINAL RESULT ---------------------------------

        FinalResultMainContainer = document.createElement("div");
        FinalResultMainContainer.className = "PaymentInfoLeftSection";
        FinalResultMainContainer.style.opacity = 0;
        FinalResultMainContainer.style.display = "none";
        PaymentSectionMainWrapper.append(FinalResultMainContainer);

        let ImageIconWrapper  = document.createElement("div"); // Image Icon Top ---------
        ImageIconWrapper.className = "AllContentMarginPayment";
        ImageIconWrapper.style.display = "flex";
        FinalResultMainContainer.append(ImageIconWrapper);

        if(whichtype == "Success" || isthisnotzero == false)
        {
            ImageIconWrapper.style.marginBottom = 0;
            
            let ImageIconIMG  = document.createElement("div");
            ImageIconIMG.className = "CheckSuccessGreenCircle";
            ImageIconIMG.style.margin = "0 auto";
            ImageIconWrapper.append(ImageIconIMG);

            window.createLottie(ImageIconIMG, '/Assets/images/lottieanim/success.json', {});
        }
        // else if(whichtype == "Timeout")
        // {
        //     ImageIconWrapper.style.marginBottom = 0;
            
        //     let ImageIconIMG  = document.createElement("div");
        //     ImageIconIMG.className = "CheckSuccessGreenCircle";
        //     ImageIconIMG.style.margin = "0 auto";
        //     ImageIconWrapper.append(ImageIconIMG);

        //     window.createLottie(ImageIconIMG, '/Assets/images/lottieanim/timeout.json', {});
        // }
        else
        {
            let ImageIconIMG  = document.createElement("img");
            ImageIconIMG.className = "CheckSuccessGreenCircle";
            ImageIconIMG.style.margin = "0 auto";
            // if(whichtype == "Success" || isthisnotzero == false)
            // {
            //     ImageIconIMG.src = "/Assets/images/Icon/ping-hotel-successfull.svg";
            // }
            if(whichtype == "Timeout")
            {
                ImageIconIMG.src = "/Assets/images/Icon/payment-timeout.svg";
            }
            else
            {
                ImageIconIMG.src = "/Assets/images/Icon/payment-failed.svg";
            }
            ImageIconWrapper.append(ImageIconIMG);
        }





        let MainTextHeader  = document.createElement("p"); // Text ---------
        MainTextHeader.className = "PaymentSectionHeaderText MarginTextUpDown InterBoldTextFont";
        MainTextHeader.style = "width: fit-content; margin: 0 auto;";
        if(whichtype == "Success" || isthisnotzero == false)
        {
            MainTextHeader.innerHTML = window["PingHotelSuccessfulTxt" + window.CurrentCountryID];
        }
        else if(whichtype == "Timeout")
        {
            MainTextHeader.innerHTML = window["PaymentTimeoutTxt" + window.CurrentCountryID];
        }
        else if(whichtype == "Cancelled")
        {
            MainTextHeader.innerHTML = window["BookingCancelledHeaderTxt" + window.CurrentCountryID];
        }
        else
        {
            MainTextHeader.innerHTML = window["BookingFailedTxt" + window.CurrentCountryID];
        }
        FinalResultMainContainer.append(MainTextHeader);

        let DescriptionTextP  = document.createElement("p");
        DescriptionTextP.className = "DescriptionTextNotDisableable DescriptionEmailConfirmationText MarginTextUpDown InterRegularTextFont";
        DescriptionTextP.style = "color: #1b1b1b; margin-left: auto; margin-right: auto; text-align: center;";
        if(whichtype == "Success" || isthisnotzero == false)
        {
            DescriptionTextP.innerHTML = window["BookingSuccessMessageTxt" + window.CurrentCountryID];
            // DescriptionTextP.innerHTML = window["BookingSuccessMessageTxt" + window.CurrentCountryID](window.FormPaymentHotelData.rooms.room_pings[0].total_booking_room);
        }
        else if(whichtype == "Timeout")
        {
            DescriptionTextP.innerHTML = window["PaymentTimeoutMessageTxt" + window.CurrentCountryID];
        }
        else if(whichtype == "Cancelled")
        {
            DescriptionTextP.innerHTML = window["BookingCancelledMessageTxt" + window.CurrentCountryID];
        }
        else
        {
            DescriptionTextP.innerHTML = window["BookingFailedMessageTxt" + window.CurrentCountryID];
        }
        FinalResultMainContainer.append(DescriptionTextP);

        let ButtonWrapper  = document.createElement("div"); // Button ---------
        ButtonWrapper.className = "MoreThanOneButtonFlexWrapper ResendChangeEmailButtonWrapper";
        FinalResultMainContainer.append(ButtonWrapper);

        // ------------------------------ Buttons Based On Status -------------------------------

        if(whichtype == "Success")
        {
            let ShareBookingButton  = document.createElement("button"); // Share Button -----------
            ShareBookingButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
            ShareBookingButton.onclick = function()
            {
                window.CheckNCreateShareBooking(PaymentBookingID, window.HotelDetails.photos[0], window.HotelDetails.province);
            }
            ButtonWrapper.append(ShareBookingButton);

            let ShareBookingButtonWrapper  = document.createElement("div");
            ShareBookingButtonWrapper.style = "width: fit-content; height: fit-content; display: flex; margin: auto 0;";
            ShareBookingButton.append(ShareBookingButtonWrapper);

            let ShareBookingButtonIMG  = document.createElement("img");
            ShareBookingButtonIMG.className = "BasicIconInsideButton2";
            ShareBookingButtonIMG.src="/Assets/images/ButtonIcon/share-white-icon.svg";
            ShareBookingButtonIMG.style = "margin-left: 0;";
            ShareBookingButtonWrapper.append(ShareBookingButtonIMG);

            let ShareBookingButtonP  = document.createElement("p");
            ShareBookingButtonP.innerHTML = window["ShareAccommodationTxt" + window.CurrentCountryID];
            ShareBookingButtonWrapper.append(ShareBookingButtonP);


            let OrTextP  = document.createElement("p"); // Or -----------
            OrTextP.className = "DescriptionTextNotDisableable MarginTextUpDown InterItalicTextFont";
            OrTextP.style = "color: #475467; margin-left: auto; margin-right: auto;";
            OrTextP.innerHTML = window["OrTxt" + window.CurrentCountryID];
            ButtonWrapper.append(OrTextP);


            let SeeBookingDetailsButton  = document.createElement("button"); // See Booking Details -----------
            SeeBookingDetailsButton.className = "BasicTextButton BasicBoxShadow GreyBorderBlackTextButton SignInButtonTop Selectable";
            SeeBookingDetailsButton.innerHTML = window["SeeBookingDetailsTxt" + window.CurrentCountryID];
            ButtonWrapper.append(SeeBookingDetailsButton);

            let BookingDetailsHREF = document.createElement("a");
            BookingDetailsHREF.className = "HREFInsideContainer";
            BookingDetailsHREF.href = "/bookingdetails/" + window.CurrentCountryID + "/" + PaymentBookingID + ".html";
            SeeBookingDetailsButton.append(BookingDetailsHREF);
        }
        else if(whichtype == "Timeout")
        {
            let RetryPaymentButton  = document.createElement("button"); // Retry Payment -----------
            RetryPaymentButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
            ButtonWrapper.append(RetryPaymentButton);

            let RetryPaymentButtonWrapper  = document.createElement("div");
            RetryPaymentButtonWrapper.style = "width: fit-content; height: fit-content; display: flex; margin: auto 0;";
            RetryPaymentButton.append(RetryPaymentButtonWrapper);

            let RetryPaymentButtonIMG  = document.createElement("img");
            RetryPaymentButtonIMG.className = "BasicIconInsideButton2";
            RetryPaymentButtonIMG.src = "/Assets/images/ButtonIcon/retry-restart-white.svg";
            RetryPaymentButtonIMG.style = "margin-left: 0;";
            RetryPaymentButtonWrapper.append(RetryPaymentButtonIMG);

            let RetryPaymentButtonP  = document.createElement("p");
            RetryPaymentButtonP.innerHTML = window["RetryPaymentBtnTxt" + window.CurrentCountryID];
            RetryPaymentButtonWrapper.append(RetryPaymentButtonP);


            let OrTextP  = document.createElement("p"); // Or -----------
            OrTextP.className = "DescriptionTextNotDisableable MarginTextUpDown InterItalicTextFont";
            OrTextP.style = "color: #475467; margin-left: auto; margin-right: auto;";
            OrTextP.innerHTML = window["OrTxt" + window.CurrentCountryID];
            ButtonWrapper.append(OrTextP);


            let SeeBookingDetailsButton  = document.createElement("button"); // Change Bank -----------
            SeeBookingDetailsButton.className = "BasicTextButton BasicBoxShadow GreyBorderBlackTextButton SignInButtonTop Selectable";
            SeeBookingDetailsButton.innerHTML = window["ChangeBankBtnTxt" + window.CurrentCountryID];
            ButtonWrapper.append(SeeBookingDetailsButton);

            if(isthisnotzero == false) // Change Button Based On Booking Price is 0 or not ----------------
            {
                RetryPaymentButton.onclick = function() // Left button -----
                {
                    window.location.reload();
                }

                SeeBookingDetailsButton.innerHTML = window["SeeBookingDetailsTxt" + window.CurrentCountryID]; // Right button -----

                let BookingDetailsHREF = document.createElement("a");
                BookingDetailsHREF.className = "HREFInsideContainer";
                BookingDetailsHREF.href = "/bookingdetails/" + window.CurrentCountryID + "/" + PaymentBookingID + ".html";
                SeeBookingDetailsButton.append(BookingDetailsHREF);
            }
            else
            {
                RetryPaymentButton.onclick = function()
                {
                    let LoadingBlocker = window.InstantiateLoadingBlocker("RetryPaymentBlocker");

                    // Payment Method --------------------------------------
                    PaymentMethodButton.forEach(Button =>
                    {
                        let ThisRadioButton = Button.querySelector('input[type=radio]');
                        if(ThisRadioButton.value == window.WhichPaymentBankSelected && ThisRadioButton.getAttribute("which-type") == window.WhichPaymentTypeSelected)
                        {
                            ThisRadioButton.checked = true;
                        }
                    });

                    window.ScrollToWindow(SelectPaymentContainer);
                    MainHeaderTextPayment.innerHTML = window["PaymentDetailsTxt" + window.CurrentCountryID];
                    ChangeTopStepSelected(2);
                    ChangeRightContainer(2, false);

                    SelectPaymentContainer.style.opacity = 1;
                    SelectPaymentContainer.style.left = "0%";
                    SelectPaymentContainer.style.position = "relative";
                    SelectPaymentContainer.style.display = "";

                    window.CurrentFinalAnimatedPanel.style.opacity = 0;
                    window.CurrentFinalAnimatedPanel.style.left = "-105%";
                    window.CurrentFinalAnimatedPanel.style.position = "absolute";
                    window.CurrentFinalAnimatedPanel.style.display = "hidden";

                    window.CurrentFinalAnimatedPanel = SelectPaymentContainer;

                    AnimateLeftAndRightPanel(false, true, ()=>
                    { 
                        // StepNamePrev = ["Input Form", "Select Payment", "Waiting Payment", "Blu Input"];
                        StepNamePrev = ["Input Form"];
                        StepNameCurrent = "Select Payment";
                        LoadingBlocker.remove();
                        window.ConfirmPayButtonClicked();
                    });
                }
                SeeBookingDetailsButton.onclick = function()
                {
                    let LoadingBlocker = window.InstantiateLoadingBlocker("SeeBookingDetailsBlocker");

                    window.ScrollToWindow(SelectPaymentContainer);
                    MainHeaderTextPayment.innerHTML = window["PaymentDetailsTxt" + window.CurrentCountryID];
                    ChangeTopStepSelected(2);
                    ChangeRightContainer(2, false);

                    SelectPaymentContainer.style.opacity = 1;
                    SelectPaymentContainer.style.left = "0%";
                    SelectPaymentContainer.style.position = "relative";
                    SelectPaymentContainer.style.display = "";

                    // window.CurrentFinalAnimatedPanel = InputInfoPaymentContainer;

                    window.CurrentFinalAnimatedPanel.style.opacity = 0;
                    window.CurrentFinalAnimatedPanel.style.left = "-105%";
                    window.CurrentFinalAnimatedPanel.style.position = "absolute";
                    window.CurrentFinalAnimatedPanel.style.display = "hidden";

                    window.CurrentFinalAnimatedPanel = SelectPaymentContainer;

                    StepNamePrev = ["Input Form"];
                    StepNameCurrent = null;
                    
                    AnimateLeftAndRightPanel(false, true, ()=>
                    {
                        LoadingBlocker.remove();
                    });
                }
            }
        }
        else if(whichtype == "Cancelled")
        {
            let ShareBookingButton  = document.createElement("button"); // Share Button -----------
            ShareBookingButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
            ShareBookingButton.onclick = function()
            {
                window.location.reload();
            }
            ButtonWrapper.append(ShareBookingButton);

            let ShareBookingButtonWrapper  = document.createElement("div");
            ShareBookingButtonWrapper.style = "width: fit-content; height: fit-content; display: flex; margin: auto 0;";
            ShareBookingButton.append(ShareBookingButtonWrapper);

            let ShareBookingButtonIMG = document.createElement("img");
            ShareBookingButtonIMG.className = "BasicIconInsideButton2";
            ShareBookingButtonIMG.src = "/Assets/images/ButtonIcon/retry-restart-white.svg";
            ShareBookingButtonIMG.style = "margin-left: 0;";
            ShareBookingButtonWrapper.append(ShareBookingButtonIMG);

            let ShareBookingButtonP  = document.createElement("p");
            ShareBookingButtonP.innerHTML = window["RetryPaymentBtnTxt" + window.CurrentCountryID];
            ShareBookingButtonWrapper.append(ShareBookingButtonP);


            let OrTextP  = document.createElement("p"); // Or -----------
            OrTextP.className = "DescriptionTextNotDisableable MarginTextUpDown InterItalicTextFont";
            OrTextP.style = "color: #475467; margin-left: auto; margin-right: auto;";
            OrTextP.innerHTML = window["OrTxt" + window.CurrentCountryID];
            ButtonWrapper.append(OrTextP);


            let SeeBookingDetailsButton  = document.createElement("button"); // See Booking Details -----------
            SeeBookingDetailsButton.className = "BasicTextButton BasicBoxShadow GreyBorderBlackTextButton SignInButtonTop Selectable";
            SeeBookingDetailsButton.innerHTML = window["SeeBookingDetailsTxt" + window.CurrentCountryID];
            ButtonWrapper.append(SeeBookingDetailsButton);

            let BookingDetailsHREF = document.createElement("a");
            BookingDetailsHREF.className = "HREFInsideContainer";
            BookingDetailsHREF.href = "/bookingdetails/" + window.CurrentCountryID + "/" + PaymentBookingID + ".html";
            SeeBookingDetailsButton.append(BookingDetailsHREF);
        }
        else
        {
            let AnotherPaymentButton  = document.createElement("button"); // Another Payment -----------
            AnotherPaymentButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
            ButtonWrapper.append(AnotherPaymentButton);

            let AnotherPaymentButtonWrapper  = document.createElement("div");
            AnotherPaymentButtonWrapper.style = "width: fit-content; height: fit-content; display: flex; margin: auto 0;";
            AnotherPaymentButton.append(AnotherPaymentButtonWrapper);

            let AnotherPaymentButtonIMG  = document.createElement("img");
            AnotherPaymentButtonIMG.className = "BasicIconInsideButton2";
            AnotherPaymentButtonIMG.src = "/Assets/images/ButtonIcon/retry-restart-white.svg";
            AnotherPaymentButtonIMG.style = "margin-left: 0;";
            AnotherPaymentButtonWrapper.append(AnotherPaymentButtonIMG);

            let AnotherPaymentButtonP  = document.createElement("p");
            AnotherPaymentButtonP.innerHTML = window["AnotherPaymentBtnTxt" + window.CurrentCountryID];
            AnotherPaymentButtonWrapper.append(AnotherPaymentButtonP);


            if(isthisnotzero == false) // Change Button Based On Booking Price is 0 or not ----------------
            {
                AnotherPaymentButtonP.innerHTML = window["RetryPaymentBtnTxt" + window.CurrentCountryID];
                AnotherPaymentButton.onclick = function()
                {
                    window.location.reload();
                }
            }
            else
            {
                AnotherPaymentButton.onclick = function()
                {
                    let LoadingBlocker = window.InstantiateLoadingBlocker("AnotherPaymentBlocker");

                    // Payment Method --------------------------------------
                    PaymentMethodButton.forEach(Button =>
                    {
                        let ThisRadioButton = Button.querySelector('input[type=radio]');
                        if(ThisRadioButton.value == window.WhichPaymentBankSelected && ThisRadioButton.getAttribute("which-type") == window.WhichPaymentTypeSelected)
                        {
                            ThisRadioButton.checked = true;
                        }
                    });

                    window.ScrollToWindow(SelectPaymentContainer);
                    MainHeaderTextPayment.innerHTML = window["PaymentDetailsTxt" + window.CurrentCountryID];
                    ChangeTopStepSelected(2);
                    ChangeRightContainer(2, false);

                    SelectPaymentContainer.style.opacity = 1;
                    SelectPaymentContainer.style.left = "0%";
                    SelectPaymentContainer.style.position = "relative";
                    SelectPaymentContainer.style.display = "";

                    window.CurrentFinalAnimatedPanel.style.opacity = 0;
                    window.CurrentFinalAnimatedPanel.style.left = "-105%";
                    window.CurrentFinalAnimatedPanel.style.position = "absolute";
                    window.CurrentFinalAnimatedPanel.style.display = "hidden";

                    window.CurrentFinalAnimatedPanel = SelectPaymentContainer;

                    AnimateLeftAndRightPanel(false, true, ()=>
                    { 
                        // StepNamePrev = ["Input Form", "Select Payment", "Waiting Payment", "Blu Input"];
                        StepNamePrev = ["Input Form"];
                        StepNameCurrent = "Select Payment";
                        LoadingBlocker.remove();
                        window.ConfirmPayButtonClicked();
                    });
                }
            }


            let OrTextP  = document.createElement("p"); // Or -----------
            OrTextP.className = "DescriptionTextNotDisableable MarginTextUpDown InterItalicTextFont";
            OrTextP.style = "color: #475467; margin-left: auto; margin-right: auto;";
            OrTextP.innerHTML = window["OrTxt" + window.CurrentCountryID];
            ButtonWrapper.append(OrTextP);


            let NeedHelpButton  = document.createElement("button"); // Need Help -----------
            NeedHelpButton.className = "BasicTextButton BasicBoxShadow GreyBorderBlackTextButton SignInButtonTop Selectable";
            NeedHelpButton.color = "#2494D9";
            NeedHelpButton.innerHTML = window["NeedHelpBtnTxt" + window.CurrentCountryID];
            ButtonWrapper.append(NeedHelpButton);

            let NeedHelpHREF = document.createElement("a");
            NeedHelpHREF.className = "HREFInsideContainer";
            NeedHelpHREF.href = "/contactus/" + window.CurrentCountryID;
            NeedHelpButton.append(NeedHelpHREF);
        }

        // ------------------------ ANIMATE LEFT AND RIGHT PANEL ---------------------------

        AnimateLeftAndRightPanel(true, true, functiontocall);
        window.ScrollToWindow(FinalResultMainContainer);
    }
}

function AnimateLeftAndRightPanel(isexit, isallowchange, functiontocall)
{
    if(isallowchange == true)
    {
        window.IsPanelAnimating = true;
    }

    if(window.IsPanelAnimating == true)
    {
        if(isexit == true) // Open to Final Page --------------------
        {
            PaymentLeftSection.style.opacity = 0;
            PaymentLeftSection.style.left = "-15%";
            PaymentLeftSection.animate([{opacity: 1, left: "0%"},{opacity: 0, left: "-15%"}], {duration: window.AnimateLeftPanelDuration});

            PaymentRightSection.style.opacity = 0;
            PaymentRightSection.style.left = "15%";
            PaymentRightSection.animate([{opacity: 1, left: "0%"},{opacity: 0, left: "15%"}], {duration: window.AnimateLeftPanelDuration});

            setTimeout(function()
            {
                PaymentLeftSection.style.display = "none";
                PaymentRightSection.style.display = "none";

                FinalResultMainContainer.style.opacity = 1;
                FinalResultMainContainer.style.display = "";
                FinalResultMainContainer.animate([{opacity: 0},{opacity: 1}], {duration: window.AnimateLeftPanelDuration});

                setTimeout(function()
                {
                    window.IsPanelAnimating = false;
                    if(functiontocall != null)
                    {
                        functiontocall();
                    }

                }, window.AnimateLeftPanelDuration);
            }, window.AnimateLeftPanelDuration);
        }
        else
        {
            FinalResultMainContainer.style.opacity = 0;
            FinalResultMainContainer.animate([{opacity: 1},{opacity: 0}], {duration: window.AnimateLeftPanelDuration});

            setTimeout(function()
            {
                FinalResultMainContainer.style.display = "none";

                PaymentLeftSection.style.opacity = 1;
                PaymentLeftSection.style.left = "0%";
                PaymentLeftSection.style.display = "";
                PaymentLeftSection.animate([{opacity: 0, left: "-15%"},{opacity: 1, left: "0%"}], {duration: window.AnimateLeftPanelDuration});


                PaymentRightSection.style.opacity = 1;
                PaymentRightSection.style.left = "0%";
                PaymentRightSection.style.display = "";
                PaymentRightSection.animate([{opacity: 0, left: "15%"},{opacity: 1, left: "0%"}], {duration: window.AnimateLeftPanelDuration});

                setTimeout(function()
                {
                    window.IsPanelAnimating = false;

                    FinalResultMainContainer.remove();
                    FinalResultMainContainer = null;

                    if(functiontocall != null)
                    {
                        functiontocall();
                    }

                }, window.AnimateLeftPanelDuration);
            }, window.AnimateLeftPanelDuration);
        }
    }
}


// =============================== DETERMINE WHAT TO RETURN BASED ON ERROR RESULT =================================

function DetermineWhatToReturnBasedOnErrorGet(errorget, thisbookingid, formData, LoadingBlocker, thisbookingdata)
{
    window.IsPanelAnimating = false;
    console.log("errorget", errorget);
    console.log("errormessage", errorget?.data?.message);
    
    if(errorget?.data?.message == "Transaction is not eligible for payment request")
    {
        PreviousBookingFound(null, LoadingBlocker, thisbookingdata.booking_reference, false);
    }
    // Ask User to Either Try Again or Change Payment ----------------------------------------------------------------------
    else if((window.WhichPaymentBankSelected == "blu" && errorget.data.code == 400) ||
    (window.WhichPaymentTypeSelected == "Card" && (errorget.data.code == 400 || errorget.data.code == 404)) ||
    (window.WhichPaymentTypeSelected == "Virtual Account" && errorget.data.code == 404) ||
    (window.WhichPaymentTypeSelected == "Instant Payment" && window.WhichPaymentBankSelected == "QRIS" && (errorget.data.code == 400 || errorget.data.code == 404)))
    {
        InstantiatePushBookingFailedError(LoadingBlocker, thisbookingid);
    }
    // Blu Phone Number is Not Registered ----------------------------------------------------------------------
    else if(window.WhichPaymentBankSelected == "blu" && errorget.data.code == 404)
    {
        BluPaymentPhoneNumberContainer.className = "SmallPanelDropDownContainer InputFieldWarningOutline";
        BluPaymentPhoneNumberWarning.style.display = "";
        BluPaymentPhoneNumberWarningText.innerHTML = window["bluAccountNotFoundErrorTxt2" + window.CurrentCountryID];
        LoadingBlocker.remove();
    }
    // Previous Booking Expired -------------------------------------------------------------------------------------
    else if(errorget?.data?.message == "Transaction has expired" || errorget?.data?.message?.toLowerCase()?.includes("expired") == true ||
    (window.WhichPaymentTypeSelected == "Virtual Account" && errorget.data.code == 400) ||
    (window.WhichPaymentTypeSelected == "Instant Payment" && window.WhichPaymentBankSelected == "QRIS" && errorget.data.code == 408))
    {
        PreviousBookingExpired(LoadingBlocker, thisbookingdata.booking_reference);
    }
    // Already Requested Card ---------------------------------------------------------------------------------------
    else if(window.WhichPaymentTypeSelected == "Card" && errorget.data.code == 409)
    {
        window.IsPanelAnimating = false;

        PreviousBookingFound(()=>
        {
            ContinuePaymentCreditCardButton.onclick = function()
            {
                window.open(errorget.data.data.redirect_url, "_blank");
            }
            DetermineSetUpAllPaymentInfoAndFunctionBefore(formData, LoadingBlocker, thisbookingdata);

        }, LoadingBlocker, thisbookingdata?.booking_reference, true);
    }
    else
    {
        window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["BasicErrorMes" + window.CurrentCountryID]);
        LoadingBlocker.remove();
    }
}


// ========================================= PUSH BOOKING FAILED ====================================


function InstantiatePushBookingFailedError(thisloadingblocker, thisbookingid)
{
    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let FlexFullDisplayPanel = document.createElement("div");
    FlexFullDisplayPanel.className = "FlexFullDisplayPanel";
    BasicBlackBlocker.append(FlexFullDisplayPanel);

    let PushBookingFailedContainer = document.createElement("div");
    PushBookingFailedContainer.className = "FlexContainerBaseAnimate PingExprezyViewMoreContainer";
    PushBookingFailedContainer.style.padding = 0;
    FlexFullDisplayPanel.append(PushBookingFailedContainer);

    let PushBookingFailedCancelWrapper = document.createElement("div"); // Top Header Close Text
    PushBookingFailedCancelWrapper.className = "HotelDetailsHotelInformationMarginWrapper";
    PushBookingFailedContainer.append(PushBookingFailedCancelWrapper);

    let PushBookingFailedCancelButton = document.createElement("img");
    PushBookingFailedCancelButton.className = "CloseButtonInsidePanel Selectable2";
    PushBookingFailedCancelButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    PushBookingFailedCancelButton.onclick = function()
    {
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, ()=>
        {
            window.IsPanelAnimating = false;
            thisloadingblocker.remove();
        });
    }
    PushBookingFailedCancelWrapper.append(PushBookingFailedCancelButton);

    // let PushBookingFailedAlertWrapper = document.createElement("div"); 
    // PushBookingFailedAlertWrapper.className = "AllContentMarginPayment";
    // PushBookingFailedAlertWrapper.style.display = "flex";
    // PushBookingFailedContainer.append(PushBookingFailedAlertWrapper);

    let LottieContainer = document.createElement("div"); // Cancel Icon ------------------------------------
    LottieContainer.className = "BigIconInsidePanel5";
    LottieContainer.style = "margin: 0 auto;";
    PushBookingFailedContainer.append(LottieContainer);

    window.createLottie(LottieContainer, '/Assets/images/lottieanim/cross.json', {});
    

    let PushBookingFailedHeaderText = document.createElement("p"); // Header and Message ------------------------------------
    PushBookingFailedHeaderText.className = "PaymentSectionHeaderText MarginTextUpDown InterBoldTextFont";
    PushBookingFailedHeaderText.style = "width: fit-content; margin: 0 auto;";
    PushBookingFailedHeaderText.innerHTML = window["BookingFailedTxt" + window.CurrentCountryID];
    PushBookingFailedContainer.append(PushBookingFailedHeaderText);

    let PushBookingFailedMessageText = document.createElement("p");
    PushBookingFailedMessageText.className = "DescriptionTextNotDisableable DescriptionEmailConfirmationText MarginTextUpDown InterRegularTextFont";
    PushBookingFailedMessageText.style = "color: #1b1b1b; margin-left: auto; margin-right: auto; text-align: center;";
    PushBookingFailedMessageText.innerHTML = window["FailedToPushBookingMessageTxt" + window.CurrentCountryID];
    PushBookingFailedContainer.append(PushBookingFailedMessageText);


    let ButtonWrapper  = document.createElement("div"); // Button ---------
    ButtonWrapper.className = "MoreThanOneButtonFlexWrapper ResendChangeEmailButtonWrapper";
    PushBookingFailedContainer.append(ButtonWrapper);
    
    let GoToPaymentSelectionButton  = document.createElement("button"); // Go to Payment Choice -----------
    GoToPaymentSelectionButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
    GoToPaymentSelectionButton.innerHTML = window["ChangePaymentMethodTxt" + window.CurrentCountryID];
    GoToPaymentSelectionButton.onclick = function()
    {
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, ()=>
        {
            window.ChangeToSectionPaymentForm("Select Payment", true, ()=>
            {
                window.IsPanelAnimating = false;
                thisloadingblocker.remove();
            });
        });
    }
    ButtonWrapper.append(GoToPaymentSelectionButton);

    if(thisbookingid != null)
    {
        let OrTextP = document.createElement("p"); // Or -----------
        OrTextP.className = "DescriptionTextNotDisableable MarginTextUpDown InterItalicTextFont";
        OrTextP.style = "color: #475467; margin-left: auto; margin-right: auto;";
        OrTextP.innerHTML = window["OrTxt" + window.CurrentCountryID];
        ButtonWrapper.append(OrTextP);


        let SeeBookingDetailsButton  = document.createElement("button"); // See Booking Details -----------
        SeeBookingDetailsButton.className = "BasicTextButton BasicBoxShadow GreyBorderBlackTextButton SignInButtonTop Selectable";
        SeeBookingDetailsButton.innerHTML = window["SeeBookingDetailsTxt" + window.CurrentCountryID];
        ButtonWrapper.append(SeeBookingDetailsButton);

        let BookingDetailsHREF = document.createElement("a");
        BookingDetailsHREF.className = "HREFInsideContainer";
        BookingDetailsHREF.href= "/bookingdetails/" + window.CurrentCountryID + "/" + thisbookingid + ".html";
        SeeBookingDetailsButton.append(BookingDetailsHREF);
    }

    window.OpenPanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker);
}

// ========================================= PREVIOUS BOOKING FOUND ======================================

function PreviousBookingFound(functiontocall, thisloadingblocker, bookingid, isnormalbooking)
{
    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let FlexFullDisplayPanel = document.createElement("div");
    FlexFullDisplayPanel.className = "FlexFullDisplayPanel";
    BasicBlackBlocker.append(FlexFullDisplayPanel);

    let PreviousBookingContainer = document.createElement("div");
    PreviousBookingContainer.className = "FlexContainerBaseAnimate PingExprezyViewMoreContainer";
    PreviousBookingContainer.style.padding = 0;
    FlexFullDisplayPanel.append(PreviousBookingContainer);

    let PreviousBookingCancelWrapper = document.createElement("div"); // Top Header Close Text
    PreviousBookingCancelWrapper.className = "HotelDetailsHotelInformationMarginWrapper";
    PreviousBookingContainer.append(PreviousBookingCancelWrapper);

    let PreviousBookingCancelButton = document.createElement("img");
    PreviousBookingCancelButton.className = "CloseButtonInsidePanel Selectable2";
    PreviousBookingCancelButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    PreviousBookingCancelButton.onclick = function()
    {
        if(isnormalbooking == true)
        {
            window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, ()=>
            {
                window.IsPanelAnimating = false;
                thisloadingblocker.remove();
            });
        }
        else
        {
            window.location.href = "/bookingdetails/" + window.CurrentCountryID + "/" + bookingid + ".html";
        }
    }
    PreviousBookingCancelWrapper.append(PreviousBookingCancelButton);


    let PreviousBookingAlertWrapper = document.createElement("div"); // Waiting Clock Icon ------------------------------------
    PreviousBookingAlertWrapper.className = "AllContentMarginPayment";
    PreviousBookingAlertWrapper.style.display = "flex";
    PreviousBookingContainer.append(PreviousBookingAlertWrapper);

    let PreviousBookingAlertIMG = document.createElement("img");
    PreviousBookingAlertIMG.className = "BigIconInsidePanel3";
    PreviousBookingAlertIMG.src = "/Assets/images/Icon/yellow-triangle-alert.svg";
    PreviousBookingAlertIMG.style = "margin: 0 auto;";
    PreviousBookingAlertWrapper.append(PreviousBookingAlertIMG);

    let PreviousBookingHeaderText = document.createElement("p"); // Header and Message ------------------------------------
    PreviousBookingHeaderText.className = "PaymentSectionHeaderText MarginTextUpDown InterBoldTextFont";
    PreviousBookingHeaderText.style = "width: fit-content; margin: 0 auto;";
    PreviousBookingHeaderText.innerHTML = window["PreviousOnGoingPaymentFoundTxt" + window.CurrentCountryID];
    PreviousBookingContainer.append(PreviousBookingHeaderText);

    let PreviousBookingMessageText = document.createElement("p");
    PreviousBookingMessageText.className = "DescriptionTextNotDisableable DescriptionEmailConfirmationText MarginTextUpDown InterRegularTextFont";
    PreviousBookingMessageText.style = "color: #1b1b1b; margin-left: auto; margin-right: auto; text-align: center;";
    PreviousBookingMessageText.innerHTML = window["PreviousOnGoingPaymentFoundMessageTxt" + window.CurrentCountryID];
    PreviousBookingContainer.append(PreviousBookingMessageText);


    let ButtonWrapper  = document.createElement("div"); // Button ---------
    ButtonWrapper.className = "MoreThanOneButtonFlexWrapper ResendChangeEmailButtonWrapper";
    PreviousBookingContainer.append(ButtonWrapper);
    

    if(functiontocall != null)
    {
        let ContinueButton  = document.createElement("button"); // Continue Payment -----------
        ContinueButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
        ContinueButton.innerHTML = window["ContinuePaymentBtnTxt" + window.CurrentCountryID];
        ContinueButton.onclick = function()
        {
            // Change To Previous Booking Name Info ------------------------------------------------------------------------------
            if(window.PushbookingData != null)
            {
                GuestNameText.innerHTML = window.PushbookingData.name_customer;
            }
            functiontocall();
            window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, null);
        }
        ButtonWrapper.append(ContinueButton);

        if(bookingid != null)
        {
            let OrTextP = document.createElement("p"); // Or -----------
            OrTextP.className = "DescriptionTextNotDisableable MarginTextUpDown InterItalicTextFont";
            OrTextP.style = "color: #475467; margin-left: auto; margin-right: auto;";
            OrTextP.innerHTML = window["OrTxt" + window.CurrentCountryID];
            ButtonWrapper.append(OrTextP);


            let SeeBookingDetailsButton  = document.createElement("button"); // See Booking Details -----------
            SeeBookingDetailsButton.className = "BasicTextButton BasicBoxShadow GreyBorderBlackTextButton SignInButtonTop Selectable";
            SeeBookingDetailsButton.innerHTML = window["SeeBookingDetailsTxt" + window.CurrentCountryID];
            ButtonWrapper.append(SeeBookingDetailsButton);

            let BookingDetailsHREF = document.createElement("a");
            BookingDetailsHREF.className = "HREFInsideContainer";
            BookingDetailsHREF.href= "/bookingdetails/" + window.CurrentCountryID + "/" + bookingid + ".html";
            SeeBookingDetailsButton.append(BookingDetailsHREF);
        }
    }
    else if(bookingid != null)
    {
        let SeeBookingDetailsButton  = document.createElement("button"); // See Booking Details -----------
        SeeBookingDetailsButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
        SeeBookingDetailsButton.innerHTML = window["SeeBookingDetailsTxt" + window.CurrentCountryID];
        ButtonWrapper.append(SeeBookingDetailsButton);

        let BookingDetailsHREF = document.createElement("a");
        BookingDetailsHREF.className = "HREFInsideContainer";
        BookingDetailsHREF.href= "/bookingdetails/" + window.CurrentCountryID + "/" + bookingid + ".html";
        SeeBookingDetailsButton.append(BookingDetailsHREF);
    }


    window.OpenPanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker);
}

// ========================================= BOOKING EXPIRED ======================================

function PreviousBookingExpired(thisloadingblocker, bookingid)
{
    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let FlexFullDisplayPanel = document.createElement("div");
    FlexFullDisplayPanel.className = "FlexFullDisplayPanel";
    BasicBlackBlocker.append(FlexFullDisplayPanel);

    let BookingExpiredContainer = document.createElement("div");
    BookingExpiredContainer.className = "FlexContainerBaseAnimate PingExprezyViewMoreContainer";
    BookingExpiredContainer.style.padding = 0;
    FlexFullDisplayPanel.append(BookingExpiredContainer);

    let BookingExpiredCancelWrapper = document.createElement("div"); // Top Header Close Text
    BookingExpiredCancelWrapper.className = "HotelDetailsHotelInformationMarginWrapper";
    BookingExpiredContainer.append(BookingExpiredCancelWrapper);

    let BookingExpiredCancelButton = document.createElement("img");
    BookingExpiredCancelButton.className = "CloseButtonInsidePanel Selectable2";
    BookingExpiredCancelButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    BookingExpiredCancelButton.onclick = function()
    {
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, ()=>
        {
            window.IsPanelAnimating = false;
            thisloadingblocker.remove();
        });
    }
    BookingExpiredCancelWrapper.append(BookingExpiredCancelButton);


    let BookingExpiredAlertWrapper = document.createElement("div"); // Booking Payment Timeout ------------------------------------
    BookingExpiredAlertWrapper.className = "AllContentMarginPayment";
    BookingExpiredAlertWrapper.style.display = "flex";
    BookingExpiredContainer.append(BookingExpiredAlertWrapper);

    let BookingExpiredAlertIMG = document.createElement("img");
    BookingExpiredAlertIMG.className = "BigIconInsidePanel3";
    BookingExpiredAlertIMG.src = "/Assets/images/Icon/payment-timeout.svg";
    BookingExpiredAlertIMG.style = "margin: 0 auto;";
    BookingExpiredAlertWrapper.append(BookingExpiredAlertIMG);

    let BookingExpiredHeaderText = document.createElement("p"); // Header and Message ------------------------------------
    BookingExpiredHeaderText.className = "PaymentSectionHeaderText MarginTextUpDown InterBoldTextFont";
    BookingExpiredHeaderText.style = "width: fit-content; margin: 0 auto;";
    BookingExpiredHeaderText.innerHTML = window["PreviousBookingExpiredHeaderTxt" + window.CurrentCountryID];
    BookingExpiredContainer.append(BookingExpiredHeaderText);

    let BookingExpiredMessageText = document.createElement("p");
    BookingExpiredMessageText.className = "DescriptionTextNotDisableable DescriptionEmailConfirmationText MarginTextUpDown InterRegularTextFont";
    BookingExpiredMessageText.style = "color: #1b1b1b; margin-left: auto; margin-right: auto; text-align: center;";
    BookingExpiredMessageText.innerHTML = window["PreviousBookingExpiredMessageTxt" + window.CurrentCountryID];
    BookingExpiredContainer.append(BookingExpiredMessageText);


    let ButtonWrapper  = document.createElement("div"); // Button ---------
    ButtonWrapper.className = "MoreThanOneButtonFlexWrapper ResendChangeEmailButtonWrapper";
    BookingExpiredContainer.append(ButtonWrapper);
    

    let RefreshPageButton  = document.createElement("button"); // Refresh Page -----------
    RefreshPageButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
    RefreshPageButton.innerHTML = window["RefreshPageBtnTxt" + window.CurrentCountryID];
    RefreshPageButton.onclick = function()
    {
        window.location.reload();
    }
    ButtonWrapper.append(RefreshPageButton);


    let OrTextP  = document.createElement("p"); // Or -----------
    OrTextP.className = "DescriptionTextNotDisableable MarginTextUpDown InterItalicTextFont";
    OrTextP.style = "color: #475467; margin-left: auto; margin-right: auto;";
    OrTextP.innerHTML = window["OrTxt" + window.CurrentCountryID];
    ButtonWrapper.append(OrTextP);


    let SeeBookingDetailsButton  = document.createElement("button"); // See Booking Details -----------
    SeeBookingDetailsButton.className = "BasicTextButton BasicBoxShadow GreyBorderBlackTextButton SignInButtonTop Selectable";
    SeeBookingDetailsButton.innerHTML = window["SeeBookingDetailsTxt" + window.CurrentCountryID];
    ButtonWrapper.append(SeeBookingDetailsButton);

    let BookingDetailsHREF = document.createElement("a");
    BookingDetailsHREF.className = "HREFInsideContainer";
    BookingDetailsHREF.href= "/bookingdetails/" + window.CurrentCountryID + "/" + bookingid + ".html";
    SeeBookingDetailsButton.append(BookingDetailsHREF);

    window.OpenPanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker);
}

// ========================================= VERIFY DIRECT PANEL =========================================

window.InstantiateVerifyDirectPayment = function(directransferformdata)
{
    let GetDayTimeArray = window.GetAndConvertCurrentDate(true).split(" ");
    let CurrentDayArray = GetDayTimeArray[0].split("-");

    let HourMinAMArray = window.ConvertTimeIntoAMPMValue(GetDayTimeArray[1]);

    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let FlexFullDisplayPanel = document.createElement("div");
    FlexFullDisplayPanel.className = "FlexFullDisplayPanel";
    FlexFullDisplayPanel.id = "FlexFullDisplayPanelVerifDT";
    BasicBlackBlocker.append(FlexFullDisplayPanel);

    // ----------------------------------- VERIFY DIRECT PAYMENT ---------------------------------------

    let VerifyDirecTransferPayment = document.createElement("div");
    VerifyDirecTransferPayment.className = "FlexContainerBaseAnimate PingExprezyViewMoreContainer";
    VerifyDirecTransferPayment.id = "VerifyDirecTransferPaymentContainer";
    VerifyDirecTransferPayment.style.padding = 0;
    FlexFullDisplayPanel.append(VerifyDirecTransferPayment);

    let TopHeaderAndCloseWrapper = document.createElement("div"); // Top Header Close Text
    TopHeaderAndCloseWrapper.className = "HotelDetailsHotelInformationMarginWrapper";
    VerifyDirecTransferPayment.append(TopHeaderAndCloseWrapper);

    let CompleteYourProfileHeaderText = document.createElement("p");
    CompleteYourProfileHeaderText.className = "PaymentSectionHeaderText MarginTextUpDown InterBoldTextFont";
    CompleteYourProfileHeaderText.style = "margin-top: 0; margin-bottom: 0;";
    CompleteYourProfileHeaderText.innerHTML = window["VerifyYourPaymentBtnTxt" + window.CurrentCountryID];
    TopHeaderAndCloseWrapper.append(CompleteYourProfileHeaderText);

    let CloseButton = document.createElement("img");
    CloseButton.className = "CloseButtonInsidePanel Selectable2";
    CloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    CloseButton.onclick = function()
    {
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, null);
    }
    TopHeaderAndCloseWrapper.append(CloseButton);

    let TransferDateTimeWrapper = document.createElement("div"); // Transfer Date Wrapper ------------------------------------
    TransferDateTimeWrapper.className = "TwoSeparatorWrapper InputFieldMargin";
    VerifyDirecTransferPayment.append(TransferDateTimeWrapper);

    let TransferDateWrapper = document.createElement("div"); // Transfer Date
    TransferDateWrapper.className = "TwoSeparatorContent";
    TransferDateTimeWrapper.append(TransferDateWrapper);

    let TransferDateHeaderText = document.createElement("p");
    TransferDateHeaderText.className = "InputFieldHeaderText InterMediumTextFont";
    TransferDateHeaderText.innerHTML = window["TransferDateTxt" + window.CurrentCountryID];
    TransferDateWrapper.append(TransferDateHeaderText);
    

    let TransferDateInputContainer = document.createElement("div");
    TransferDateInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer";
    TransferDateInputContainer.id = "TransferDateInputContainer";
    TransferDateInputContainer.style = "width: 100%; min-width: 100%;";
    TransferDateInputContainer.setAttribute("Date", CurrentDayArray[2]);
    TransferDateInputContainer.setAttribute("Month", CurrentDayArray[1]);
    TransferDateInputContainer.setAttribute("Year", CurrentDayArray[0]);
    TransferDateInputContainer.onclick = function()
    {
        window.OpenDateChoiceContainer('TransferDateInputContainer', '', '', '', '', 2, false, false, true, true, true, false, null);
    }
    TransferDateWrapper.append(TransferDateInputContainer);

    let TransferDateInputWrapper = document.createElement("div");
    TransferDateInputWrapper.className = "SmallPanelDropDownContainer Selectable3";
    TransferDateInputWrapper.style = "width: 100%; min-width: 100%;";
    TransferDateInputWrapper.style.marginBottom = 0;
    TransferDateInputContainer.append(TransferDateInputWrapper);

    let TransferDateInput = document.createElement("input");
    TransferDateInput.type = "text";
    TransferDateInput.name = "TransferDate";
    TransferDateInput.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    TransferDateInput.id = "TransferDateInputContainerDateText";
    TransferDateInput.placeholder = window["TransferDatePlaceHolderTxt" + window.CurrentCountryID];
    TransferDateInput.readOnly = true;
    TransferDateInput.style.pointerEvents = "none";
    TransferDateInput.value = window["monthNames" + window.CurrentCountryID][parseInt(CurrentDayArray[1]) - 1] + " " + parseInt(CurrentDayArray[2]) + ", " + CurrentDayArray[0];
    TransferDateInputWrapper.append(TransferDateInput);

    let TransferTimeWrapper = document.createElement("div"); // Transfer Time
    TransferTimeWrapper.className = "TwoSeparatorContent";
    TransferDateTimeWrapper.append(TransferTimeWrapper);

    let TransferTimeHeaderText = document.createElement("p");
    TransferTimeHeaderText.className = "InputFieldHeaderText InterMediumTextFont";
    TransferTimeHeaderText.innerHTML = window["TransferTimeTxt" + window.CurrentCountryID];
    TransferTimeWrapper.append(TransferTimeHeaderText);

    let TransferTimeInputInstantiateContainer = document.createElement("div");
    TransferTimeInputInstantiateContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer";
    TransferTimeInputInstantiateContainer.style = "width: 100%; min-width: 100%;";
    TransferTimeInputInstantiateContainer.id = "TransferTimeVerifyInputContainer";
    TransferTimeInputInstantiateContainer.setAttribute("hour-value", parseInt(HourMinAMArray.hour));
    TransferTimeInputInstantiateContainer.setAttribute("min-value", parseInt(HourMinAMArray.minute));
    TransferTimeInputInstantiateContainer.setAttribute("ampm-value", HourMinAMArray.ampm);
    TransferTimeInputInstantiateContainer.onclick = function()
    {
        function FunctionToCallAfter(event)
        {
            window.CheckInputVerifiyDirectTransfer(event, directransferformdata, false);
        }
        window.InstantiateTimeScrollDownMenu("TransferTimeVerifyInputContainer", "TransferTimeVerifyInputText", "", true, ()=>FunctionToCallAfter());
    }
    TransferTimeWrapper.append(TransferTimeInputInstantiateContainer);

    let TransferTimeInputContainer = document.createElement("div");
    TransferTimeInputContainer.className = "SmallPanelDropDownContainer Selectable3";
    TransferTimeInputContainer.style = "width: 100%; min-width: 100%;";
    TransferTimeInputContainer.style.marginBottom = 0;
    TransferTimeInputInstantiateContainer.append(TransferTimeInputContainer);

    let TransferTimeInput = document.createElement("input");
    TransferTimeInput.type = "text";
    TransferTimeInput.name = "TransferTime";
    TransferTimeInput.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    TransferTimeInput.id = "TransferTimeVerifyInputText";
    TransferTimeInput.placeholder = window["TransferTimePlaceHolderTxt" + window.CurrentCountryID];
    TransferTimeInput.readOnly = true;
    TransferTimeInput.style.pointerEvents = "none";
    TransferTimeInput.value = parseInt(HourMinAMArray.hour) + ":" + parseInt(HourMinAMArray.minute).toString().padStart(2, '0') + " " + HourMinAMArray.ampm;
    TransferTimeInputContainer.append(TransferTimeInput);


    let BankAccountWrapper = document.createElement("div"); // Bank Account  ------------------------------------
    BankAccountWrapper.className = "InputFieldMargin2";
    BankAccountWrapper.style.flexDirection = "column";
    VerifyDirecTransferPayment.append(BankAccountWrapper);

    let BankAccountHeaderText = document.createElement("p");
    BankAccountHeaderText.className = "InputFieldHeaderText InterMediumTextFont";
    BankAccountHeaderText.innerHTML = window["BankAccountTxt" + window.CurrentCountryID];
    BankAccountWrapper.append(BankAccountHeaderText);

    let BankAccountDropDown = document.createElement("div");
    BankAccountDropDown.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
    BankAccountDropDown.id = "BankAccountContainerVerify";
    BankAccountDropDown.style = "width: 100%; min-width: 100%;";
    BankAccountWrapper.append(BankAccountDropDown);

    let BankAccountInput = document.createElement("input");
    BankAccountInput.type = "text";
    BankAccountInput.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    BankAccountInput.id = "BankAccountInputVerify";
    BankAccountInput.placeholder = window["BankAccountPlaceHolderTxt" + window.CurrentCountryID];
    BankAccountInput.onfocus = function(event)
    {
        BankAccountDropDown.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        document.getElementById("RedWarningBankAccountText").style.display = "none";
    }
    BankAccountInput.oninput = function(event)
    {
        window.CheckInputVerifiyDirectTransfer(event, directransferformdata, false);
        document.getElementById("RedWarningBankAccountText").style.display = "none";
    }
    BankAccountInput.addEventListener("focusout", (event) =>
    {
        window.CheckInputVerifiyDirectTransfer(event, directransferformdata, true);
    });
    BankAccountDropDown.append(BankAccountInput);


    let RedWarningBankAccountText = document.createElement("p");
    RedWarningBankAccountText.className = "RedWarningText InterMediumTextFont";
    RedWarningBankAccountText.id = "RedWarningBankAccountText";
    RedWarningBankAccountText.style.display = "none";
    RedWarningBankAccountText.style.marginBottom = 0;
    RedWarningBankAccountText.innerHTML = window["BankAccountWarningEmptyTxt" + window.CurrentCountryID];
    BankAccountWrapper.append(RedWarningBankAccountText);

    
    let AccountNumberWrapper = document.createElement("div"); // Account Number  ------------------------------------
    AccountNumberWrapper.className = "InputFieldMargin2";
    AccountNumberWrapper.style.flexDirection = "column";
    VerifyDirecTransferPayment.append(AccountNumberWrapper);

    let AccountNumberHeaderText = document.createElement("p");
    AccountNumberHeaderText.className = "InputFieldHeaderText InterMediumTextFont";
    AccountNumberHeaderText.innerHTML = window["AccountNumberTxt" + window.CurrentCountryID];
    AccountNumberWrapper.append(AccountNumberHeaderText);

    let AccountNumberDropDown = document.createElement("div");
    AccountNumberDropDown.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
    AccountNumberDropDown.style = "width: 100%; min-width: 100%;";
    AccountNumberDropDown.id = "AccountNumberInputContainerVerify";
    AccountNumberWrapper.append(AccountNumberDropDown);

    let AccountNumberInput = document.createElement("input");
    AccountNumberInput.type = "number";
    AccountNumberInput.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    AccountNumberInput.id = "AccountNumberInputVerify";
    AccountNumberInput.placeholder = window["AccountNumberPlaceHolderTxt" + window.CurrentCountryID];
    AccountNumberInput.onfocus = function(event)
    {
        AccountNumberDropDown.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        document.getElementById("RedWarningAccountNumberText").style.display = "none";
    }
    AccountNumberInput.oninput = function(event)
    {
        window.CheckInputVerifiyDirectTransfer(event, directransferformdata, false);
        document.getElementById("RedWarningAccountNumberText").style.display = "none";
    }
    AccountNumberInput.addEventListener("focusout", (event) =>
    {
        window.CheckInputVerifiyDirectTransfer(event, directransferformdata, true);
    });
    AccountNumberDropDown.append(AccountNumberInput);

    let RedWarningAccountNumberText = document.createElement("p");
    RedWarningAccountNumberText.className = "RedWarningText InterMediumTextFont";
    RedWarningAccountNumberText.id = "RedWarningAccountNumberText";
    RedWarningAccountNumberText.style.display = "none";
    RedWarningAccountNumberText.style.marginBottom = 0;
    RedWarningAccountNumberText.innerHTML = window["AccountNumberWarningEmptyTxt" + window.CurrentCountryID];
    AccountNumberWrapper.append(RedWarningAccountNumberText);
    

    let AmountWrapper = document.createElement("div"); // Amount ------------------------------------
    AmountWrapper.className = "InputFieldMargin2";
    AmountWrapper.style.flexDirection = "column";
    VerifyDirecTransferPayment.append(AmountWrapper);

    let AmountHeaderText = document.createElement("p");
    AmountHeaderText.className = "InputFieldHeaderText InterMediumTextFont";
    AmountHeaderText.innerHTML = window["JumlahTransferTxt" + window.CurrentCountryID];
    AmountWrapper.append(AmountHeaderText);

    let AmountInputContainer = document.createElement("div");
    AmountInputContainer.className = "SmallPanelDropDownContainer";
    AmountInputContainer.id = "AmountInputContainerVerify"
    AmountWrapper.append(AmountInputContainer);

    let RpTextContainer = document.createElement("div");
    RpTextContainer.className = "FirstNumberPhoneNumberWrapper";
    AmountInputContainer.append(RpTextContainer);

    let RpTextWrapper = document.createElement("div");
    RpTextWrapper.className = "PhoneCodeNumberTextWrapper Selectable3";
    RpTextContainer.append(RpTextWrapper);

    let RpTextP = document.createElement("p");
    RpTextP.className = "InterMediumTextFont";
    RpTextP.innerHTML = "Rp";
    RpTextWrapper.append(RpTextP);
    
    let MoneyAmountInput = document.createElement("input");
    MoneyAmountInput.type = "text";
    MoneyAmountInput.className = "InputFieldInsideSmallPanel InputFieldWithButton Selectable3 InterMediumTextFont";
    MoneyAmountInput.placeholder = window["JumlahTransferPlaceHolderTxt" + window.CurrentCountryID];
    MoneyAmountInput.id = "MoneyAmountInputVerify";
    MoneyAmountInput.setAttribute("amount-input", directransferformdata.get("down_payment"));
    MoneyAmountInput.value = directransferformdata.get("down_payment").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    MoneyAmountInput.onfocus = function(event)
    {
        MoneyAmountInput.type = "number";
        MoneyAmountInput.value = MoneyAmountInput.getAttribute("amount-input");
        AmountInputContainer.className = "SmallPanelDropDownContainer";
        document.getElementById("RedWarningMoneyAmountText").style.display = "none";
    }
    // MoneyAmountInput.oninput = function(event)
    // {
    //     window.CheckInputVerifiyDirectTransfer(event, directransferdata, false);
    //     document.getElementById("RedWarningMoneyAmountContainer").style.display = "none";
    // }
    MoneyAmountInput.addEventListener("focusout", (event) =>
    {
        if(MoneyAmountInput.value == null)
        {
            MoneyAmountInput.value = 0;
        }
        MoneyAmountInput.value = parseInt(MoneyAmountInput.value);
        if(MoneyAmountInput.value < 0)
        {
            MoneyAmountInput.value = 0;
        }
        MoneyAmountInput.setAttribute("amount-input", MoneyAmountInput.value);

        MoneyAmountInput.type = "text";
        MoneyAmountInput.value = MoneyAmountInput.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        window.CheckInputVerifiyDirectTransfer(event, directransferformdata, true);
    });
    AmountInputContainer.append(MoneyAmountInput);

    let RedWarningMoneyAmountText = document.createElement("p");
    RedWarningMoneyAmountText.className = "RedWarningText InterMediumTextFont";
    RedWarningMoneyAmountText.id = "RedWarningMoneyAmountText";
    RedWarningMoneyAmountText.style.display = "none";
    RedWarningMoneyAmountText.style.marginBottom = 0;
    RedWarningMoneyAmountText.innerHTML = window["JumlahTransferWarningEmptyTxt" + window.CurrentCountryID];
    AmountWrapper.append(RedWarningMoneyAmountText);


    let SaveProfileButtonWrapper = document.createElement("div"); //Verify Button  ------------------------------------
    SaveProfileButtonWrapper.className = "MoreThanOneButtonFlexWrapper InputFieldMarginBoth";
    SaveProfileButtonWrapper.style = "margin-left: auto; margin-right: auto;";
    VerifyDirecTransferPayment.append(SaveProfileButtonWrapper);

    let VerifyButton = document.createElement("button");
    VerifyButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonInvalid";
    VerifyButton.id = "VerifyButtonDirectTransfer";
    VerifyButton.innerHTML = window["VerifyBtnTxt" + window.CurrentCountryID];
    SaveProfileButtonWrapper.append(VerifyButton);


    // ----------------------------------- VERIFICATION PAYMENT IN PROGRESS ---------------------------------------

    let VerificationOnProgressContainer = document.createElement("div");
    VerificationOnProgressContainer.className = "FlexContainerBaseAnimate CreatePasswordFlexWrapper";
    VerificationOnProgressContainer.id = "VerificationOnProgressContainerDirectTransfer"
    VerificationOnProgressContainer.style.padding = 0;
    VerificationOnProgressContainer.style.display = "none";
    FlexFullDisplayPanel.append(VerificationOnProgressContainer);

    let VerificationOnProgressWrapper = document.createElement("div"); // Top Header Close Text
    VerificationOnProgressWrapper.className = "HotelDetailsHotelInformationMarginWrapper";
    VerificationOnProgressContainer.append(VerificationOnProgressWrapper);

    let VerificationOnProgressCloseButton = document.createElement("img");
    VerificationOnProgressCloseButton.className = "CloseButtonInsidePanel Selectable2";
    VerificationOnProgressCloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    VerificationOnProgressCloseButton.onclick = function()
    {
        window.open("/bookingdetails/" + window.CurrentCountryID + "/" + directransferformdata.get("booking_reference"));
    }
    VerificationOnProgressWrapper.append(VerificationOnProgressCloseButton);


    let TransferWaitingClockWrapper = document.createElement("div"); // Waiting Clock Icon ------------------------------------
    TransferWaitingClockWrapper.className = "AllContentMarginPayment";
    TransferWaitingClockWrapper.style.display = "flex";
    TransferWaitingClockWrapper.style.marginBottom = 0;
    VerificationOnProgressContainer.append(TransferWaitingClockWrapper);

    let LottieContainer = document.createElement("div");
    LottieContainer.className = "BigIconInsidePanel5";
    LottieContainer.style = "margin: 0 auto;";
    TransferWaitingClockWrapper.append(LottieContainer);

    window.createLottie(LottieContainer, '/Assets/images/lottieanim/liquid hourglass.json', {});


    let VerificationOnProgressHeaderText = document.createElement("p"); // Header and Message ------------------------------------
    VerificationOnProgressHeaderText.className = "PaymentSectionHeaderText MarginTextUpDown InterBoldTextFont";
    VerificationOnProgressHeaderText.style = "width: fit-content; margin: 0 auto;";
    VerificationOnProgressHeaderText.innerHTML = window["VerificationPaymentInProgressTxt" + window.CurrentCountryID];
    VerificationOnProgressContainer.append(VerificationOnProgressHeaderText);

    let VerificationOnProgressMessageText = document.createElement("p");
    VerificationOnProgressMessageText.className = "DescriptionTextNotDisableable DescriptionEmailConfirmationText MarginTextUpDown InterRegularTextFont";
    VerificationOnProgressMessageText.style = "color: #1b1b1b; margin-left: auto; margin-right: auto; text-align: center;";
    VerificationOnProgressMessageText.innerHTML = window["OurTeamIsCheckingPaymentMesTxt" + window.CurrentCountryID];
    VerificationOnProgressContainer.append(VerificationOnProgressMessageText);

    window.OpenPanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker);
}


window.CheckInputVerifiyDirectTransfer = function(event, directransferformdata, isallowchange)
{
    event.preventDefault();
    event.stopPropagation();

    let SomethingWrong = false;

    let BankAccountInputContainer = document.getElementById("BankAccountContainerVerify");
    let BankAccountInput = document.getElementById("BankAccountInputVerify").value;
    let RedWarningBankAccountText = document.getElementById("RedWarningBankAccountText");

    let AccountNumberInputContainer = document.getElementById("AccountNumberInputContainerVerify");
    let AccountNumberInput = document.getElementById("AccountNumberInputVerify").value;
    let RedWarningAccountNumberText = document.getElementById("RedWarningAccountNumberText");

    let AmountInputContainer = document.getElementById("AmountInputContainerVerify");
    let AmountInput = document.getElementById("MoneyAmountInputVerify").getAttribute("amount-input");
    let RedWarningAmountText = document.getElementById("RedWarningMoneyAmountText");

    let SendVerificationButton = document.getElementById("VerifyButtonDirectTransfer");

    if(BankAccountInput == ""  || BankAccountInput.replace(/ /g, "") == "")
    {
        SomethingWrong = true;

        if(isallowchange == true)
        {
            RedWarningBankAccountText.style.display = "";
            RedWarningBankAccountText.innerHTML = window["BankAccountWarningEmptyTxt" + window.CurrentCountryID];
            BankAccountInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";
        }
    }

    if(AccountNumberInput == ""  || AccountNumberInput.replace(/ /g, "") == "")
    {
        SomethingWrong = true;

        if(isallowchange == true)
        {
            RedWarningAccountNumberText.style.display = "";
            RedWarningAccountNumberText.innerHTML = window["AccountNumberWarningEmptyTxt" + window.CurrentCountryID];
            AccountNumberInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";
        }
    }

    if(AmountInput == ""  || AmountInput.replace(/ /g, "") == "")
    {
        SomethingWrong = true;

        if(isallowchange == true)
        {
            RedWarningAmountText.style.display = "";
            RedWarningAmountText.innerHTML = window["JumlahTransferWarningEmptyTxt" + window.CurrentCountryID];
            AmountInputContainer.className = "SmallPanelDropDownContainer InputFieldWarningOutline";
        }
    }

    if(SomethingWrong == true)
    {
        SendVerificationButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonInvalid";
        SendVerificationButton.onclick = function(){};
    }
    else
    {
        SendVerificationButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable";
        SendVerificationButton.onclick = function()
        {
            let DirectTransferBlocker = window.InstantiateLoadingBlocker("DirectTransferBlocker");

            let TransferDateInput = document.getElementById("TransferDateInputContainer");
            let TransferDate = TransferDateInput.getAttribute("Date");
            let TransferMonth = TransferDateInput.getAttribute("Month");
            let TransferYear = TransferDateInput.getAttribute("Year");

            let TransferTimeInput = document.getElementById("TransferTimeVerifyInputContainer");
            let TransferHour = TransferTimeInput.getAttribute("hour-value");
            let TransferMinutes = TransferTimeInput.getAttribute("min-value");
            let TransferAMPM = TransferTimeInput.getAttribute("ampm-value");

            let VerifDate = TransferYear + "-" + TransferMonth.toString().padStart(2, '0') + "-" + TransferDate;
            let VerifTime = window.to24HourFormat(TransferHour, TransferMinutes, TransferAMPM);

            let FlexFullDisplayPanel = document.getElementById("FlexFullDisplayPanelVerifDT");
            let VerifyDTContainer = document.getElementById("VerifyDirecTransferPaymentContainer");
            let OnProgressDTContainer = document.getElementById("VerificationOnProgressContainerDirectTransfer");

            let URLPushVerPOST = "/v2/payments/direct/bca/verify";

            let DTformData = new FormData();
            DTformData.append('id_user', directransferformdata.get("id_user"));
            DTformData.append('id_transaction', directransferformdata.get("id_transaction"));
            DTformData.append('transfer_date', VerifDate);
            DTformData.append('transfer_time', VerifTime);
            DTformData.append('bank_account', BankAccountInput);
            DTformData.append('account_number', AccountNumberInput);
            DTformData.append('down_payment', AmountInput);
            DTformData.append('lang', window.CurrentCountryID);

            console.log(URLPushVerPOST);
            console.log(window.ConvertFormDataToJSON(DTformData));

            window.CallApiAxios({
                method: "POST",
                url: URLPushVerPOST,
                data: DTformData
            }).then(res =>
            {
                console.log(res);
                if(res.data.success == true)
                {
                    window.MovePanelInsideContainerNext(VerifyDTContainer, OnProgressDTContainer, FlexFullDisplayPanel, function(){DirectTransferBlocker.remove()});
                }
                else
                {
                    window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["ErrorWhenVerifyDirectTxt" + window.CurrentCountryID]);
                    DirectTransferBlocker.remove();
                }
            })
            .catch(err =>
            {
                console.log(err);
                window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["ErrorWhenVerifyDirectTxt" + window.CurrentCountryID]);
                DirectTransferBlocker.remove();
            });
        };
    }
}

// ===================================== COMPLETE YOUR PROFILE =====================================

function InstantiateCompleteYourProfile(UserData, useridget, usertoken)
{
    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let FlexFullDisplayPanel = document.createElement("div");
    FlexFullDisplayPanel.className = "FlexFullDisplayPanel";
    BasicBlackBlocker.append(FlexFullDisplayPanel);

    let CompleteYourProfileContainer = document.createElement("div");
    CompleteYourProfileContainer.className = "FlexContainerBaseAnimate PingExprezyViewMoreContainer";
    CompleteYourProfileContainer.style.padding = 0;
    FlexFullDisplayPanel.append(CompleteYourProfileContainer);


    let TopHeaderAndCloseWrapper = document.createElement("div"); // Top Header Close Text
    TopHeaderAndCloseWrapper.className = "HotelDetailsHotelInformationMarginWrapper";
    CompleteYourProfileContainer.append(TopHeaderAndCloseWrapper);

    let CompleteYourProfileHeaderText = document.createElement("p");
    CompleteYourProfileHeaderText.className = "PaymentSectionHeaderText MarginTextUpDown InterBoldTextFont";
    CompleteYourProfileHeaderText.style = "margin-top: 0; margin-bottom: 0;";
    CompleteYourProfileHeaderText.innerHTML = window["CompleteYourProfileHeaderTxt" + window.CurrentCountryID];
    TopHeaderAndCloseWrapper.append(CompleteYourProfileHeaderText);

    let CloseButton = document.createElement("img");
    CloseButton.className = "CloseButtonInsidePanel Selectable2";
    CloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    CloseButton.onclick = function()
    {
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, null);
    }
    TopHeaderAndCloseWrapper.append(CloseButton);

    let RedWarningMainCompleteUser = document.createElement("div"); // Red Warning Top -----------------------
    RedWarningMainCompleteUser.className = "BasicRadius MarginTextUpDown RedWarningContainer";
    RedWarningMainCompleteUser.id = "RedWarningMainCompleteUser";
    RedWarningMainCompleteUser.style.display = "none";
    RedWarningMainCompleteUser.style.marginTop = 0;
    CompleteYourProfileContainer.append(RedWarningMainCompleteUser);

    let RedWarningMainCompleteUserText = document.createElement("p");
    RedWarningMainCompleteUserText.className = "InterMediumTextFont";
    RedWarningMainCompleteUserText.id = "RedWarningMainCompleteUserText";
    RedWarningMainCompleteUserText.innerHTML = window["InvalidEmailFormatMes" + window.CurrentCountryID];
    RedWarningMainCompleteUser.append(RedWarningMainCompleteUserText);


    let CompleteYourProfileMessageWrapper = document.createElement("div"); // Complete Your Profile Message
    CompleteYourProfileMessageWrapper.className = "HotelDetailsHotelInformationMarginWrapper";
    CompleteYourProfileContainer.append(CompleteYourProfileMessageWrapper);

    let CompleteYourProfileMessageOrangeWrapper = document.createElement("div");
    CompleteYourProfileMessageOrangeWrapper.className = "OrangeWarningContainer BasicRadius";
    CompleteYourProfileMessageOrangeWrapper.style.display = "flex";
    CompleteYourProfileMessageOrangeWrapper.style.flexDirection = "row";
    CompleteYourProfileMessageWrapper.append(CompleteYourProfileMessageOrangeWrapper);

    let CompleteYourProfileWarningIcon = document.createElement("img");
    CompleteYourProfileWarningIcon.className = "WarningCircleIcon";
    CompleteYourProfileWarningIcon.src = "/Assets/images/ButtonIcon/warning-circle.svg";
    CompleteYourProfileMessageOrangeWrapper.append(CompleteYourProfileWarningIcon);

    let CompleteYourProfileWarningText = document.createElement("p");
    CompleteYourProfileWarningText.className = "LabelGreyHeaderSmallerText InterRegularTextFont";
    CompleteYourProfileWarningText.style.margin = "auto 0";
    CompleteYourProfileWarningText.innerHTML = window["CompleteYourProfileMessageTxt" + window.CurrentCountryID];
    CompleteYourProfileMessageOrangeWrapper.append(CompleteYourProfileWarningText);

    
    let FirstLastNameWrapper = document.createElement("div"); // First and Last Name Wrapper ------------------------------------
    FirstLastNameWrapper.className = "TwoSeparatorWrapper InputFieldMargin";
    CompleteYourProfileContainer.append(FirstLastNameWrapper);

    let FirstNameWrapper = document.createElement("div"); // First Name
    FirstNameWrapper.className = "TwoSeparatorContent";
    FirstLastNameWrapper.append(FirstNameWrapper);

    let FirstNameHeaderText = document.createElement("p");
    FirstNameHeaderText.className = "InputFieldHeaderText InterMediumTextFont";
    FirstNameHeaderText.innerHTML = window["FirstNameTxt" + window.CurrentCountryID];
    FirstNameWrapper.append(FirstNameHeaderText);

    let FirstNameInputContainer = document.createElement("div");
    FirstNameInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
    FirstNameInputContainer.style = "width: 100%; min-width: 100%;";
    FirstNameWrapper.append(FirstNameInputContainer);

    let FirstNameInputComplete = document.createElement("input");
    FirstNameInputComplete.type = "text";
    FirstNameInputComplete.name = "FirstName";
    FirstNameInputComplete.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    FirstNameInputComplete.placeholder = window["InputFirstNamePlaceholder" + window.CurrentCountryID];
    FirstNameInputContainer.append(FirstNameInputComplete);

    let FirstNameCompleteYouProfileWarning = document.createElement("p");
    FirstNameCompleteYouProfileWarning.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    FirstNameCompleteYouProfileWarning.id = "FirstNameCompleteYouProfileWarning";
    FirstNameWrapper.append(FirstNameCompleteYouProfileWarning);

    let LastNameWrapper = document.createElement("div"); // Last Name
    LastNameWrapper.className = "TwoSeparatorContent";
    FirstLastNameWrapper.append(LastNameWrapper);

    let LastNameHeaderText = document.createElement("p");
    LastNameHeaderText.className = "InputFieldHeaderText InterMediumTextFont";
    LastNameHeaderText.innerHTML = window["LastNameTxt" + window.CurrentCountryID];
    LastNameWrapper.append(LastNameHeaderText);

    let LastNameInputContainer = document.createElement("div");
    LastNameInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
    LastNameInputContainer.style = "width: 100%; min-width: 100%;";
    LastNameWrapper.append(LastNameInputContainer);

    let LastNameInputComplete = document.createElement("input");
    LastNameInputComplete.type = "text";
    LastNameInputComplete.name = "LastName";
    LastNameInputComplete.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    LastNameInputComplete.placeholder = window["InputLastNamePlaceholder" + window.CurrentCountryID];
    LastNameInputContainer.append(LastNameInputComplete);

    let LastNameCompleteYouProfileWarning = document.createElement("p");
    LastNameCompleteYouProfileWarning.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    LastNameCompleteYouProfileWarning.id = "LastNameCompleteYouProfileWarning";
    LastNameWrapper.append(LastNameCompleteYouProfileWarning);


    let GenderWrapperMargin = document.createElement("div"); // Gender --------------------------------------------------
    GenderWrapperMargin.className = "InputFieldMargin BasicHeaderAndInputWrapper";
    CompleteYourProfileContainer.append(GenderWrapperMargin);

    let GenderHeaderText = document.createElement("p"); // Gender
    GenderHeaderText.className = "InputFieldHeaderText InterMediumTextFont";
    GenderHeaderText.innerHTML = window["GenderHeaderTxt" + window.CurrentCountryID];
    GenderWrapperMargin.append(GenderHeaderText);

    let GenderFlexContainer = document.createElement("div");
    GenderFlexContainer.style = "display: flex; flex-direction: row;";
    GenderWrapperMargin.append(GenderFlexContainer);

    let MaleFlexWrapper = document.createElement("div"); // Male
    MaleFlexWrapper.className = "CheckBoxMarginBasic";
    GenderFlexContainer.append(MaleFlexWrapper);

    let MaleFlexCheckBoxWrapper = document.createElement("label");
    MaleFlexCheckBoxWrapper.className = "FilterCheckBoxContainer";
    MaleFlexWrapper.append(MaleFlexCheckBoxWrapper);

    let MaleFlexCheckBoxInput = document.createElement("input");
    MaleFlexCheckBoxInput.className = "FilterCheckBox";
    MaleFlexCheckBoxInput.type = "radio";
    MaleFlexCheckBoxInput.name = "GenderCompleteYourProfile";
    MaleFlexCheckBoxInput.value = "Male";
    MaleFlexCheckBoxInput.style.pointerEvents = "none";
    MaleFlexCheckBoxWrapper.append(MaleFlexCheckBoxInput);

    let MaleFlexCheckBoxSpan = document.createElement("span");
    MaleFlexCheckBoxSpan.className = "CheckBoxSpan";
    MaleFlexCheckBoxWrapper.append(MaleFlexCheckBoxSpan);

    let MaleCheckBoxText = document.createElement("p");
    MaleCheckBoxText.className = "CheckBoxText InterMediumTextFont";
    MaleCheckBoxText.innerHTML = window["GenderMaleTxt" + window.CurrentCountryID];
    MaleFlexWrapper.append(MaleCheckBoxText);



    let FemaleFlexWrapper = document.createElement("div"); // Female
    FemaleFlexWrapper.className = "CheckBoxMarginBasic";
    GenderFlexContainer.append(FemaleFlexWrapper);

    let FemaleFlexCheckBoxWrapper = document.createElement("label");
    FemaleFlexCheckBoxWrapper.className = "FilterCheckBoxContainer";
    FemaleFlexWrapper.append(FemaleFlexCheckBoxWrapper);

    let FemaleFlexCheckBoxInput = document.createElement("input");
    FemaleFlexCheckBoxInput.className = "FilterCheckBox";
    FemaleFlexCheckBoxInput.type = "radio";
    FemaleFlexCheckBoxInput.name = "GenderCompleteYourProfile";
    FemaleFlexCheckBoxInput.style.pointerEvents = "none";
    FemaleFlexCheckBoxInput.value = "Female";
    FemaleFlexCheckBoxWrapper.append(FemaleFlexCheckBoxInput);

    let FemaleFlexCheckBoxSpan = document.createElement("span");
    FemaleFlexCheckBoxSpan.className = "CheckBoxSpan";
    FemaleFlexCheckBoxWrapper.append(FemaleFlexCheckBoxSpan);

    let FemaleCheckBoxText = document.createElement("p");
    FemaleCheckBoxText.className = "CheckBoxText InterMediumTextFont";
    FemaleCheckBoxText.innerHTML = window["GenderFemaleTxt" + window.CurrentCountryID];
    FemaleFlexWrapper.append(FemaleCheckBoxText);


    let EmailPhoneNumberWrapper = document.createElement("div"); // Email and Phone Number ------------------------------------
    EmailPhoneNumberWrapper.className = "TwoSeparatorWrapper InputFieldMargin";
    CompleteYourProfileContainer.append(EmailPhoneNumberWrapper);

    let EmailWrapper = document.createElement("div"); // Email
    EmailWrapper.className = "TwoSeparatorContent";
    EmailPhoneNumberWrapper.append(EmailWrapper);

    let EmailHeaderText = document.createElement("p");
    EmailHeaderText.className = "InputFieldHeaderText InterMediumTextFont";
    EmailHeaderText.innerHTML = window["EmailTxt" + window.CurrentCountryID];
    EmailWrapper.append(EmailHeaderText);

    let EmailInputContainer = document.createElement("div");
    EmailInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
    EmailInputContainer.style = "width: 100%; min-width: 100%;";
    EmailWrapper.append(EmailInputContainer);

    let EmailInputComplete = document.createElement("input");
    EmailInputComplete.type = "email";
    EmailInputComplete.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    EmailInputComplete.placeholder = window["SampleEmailPlaceholder" + window.CurrentCountryID];
    EmailInputContainer.append(EmailInputComplete);

    let EmailCompleteYouProfileWarning = document.createElement("p");
    EmailCompleteYouProfileWarning.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    EmailCompleteYouProfileWarning.id = "EmailCompleteYouProfileWarning";
    EmailWrapper.append(EmailCompleteYouProfileWarning);

    let PhoneNumberWrapper = document.createElement("div"); // Phone Number
    PhoneNumberWrapper.className = "TwoSeparatorContent";
    EmailPhoneNumberWrapper.append(PhoneNumberWrapper);

    let PhoneNumberHeaderText = document.createElement("p");
    PhoneNumberHeaderText.className = "InputFieldHeaderText InterMediumTextFont";
    PhoneNumberHeaderText.innerHTML = window["PhoneNumberHeaderTxt" + window.CurrentCountryID];
    PhoneNumberWrapper.append(PhoneNumberHeaderText);

    let PhoneNumberInputContainer = document.createElement("div");
    PhoneNumberInputContainer.className = "SmallPanelDropDownContainer";
    PhoneNumberWrapper.append(PhoneNumberInputContainer);

    let CountryCodeMainWrapper = document.createElement("div");
    CountryCodeMainWrapper.className = "FirstNumberPhoneNumberWrapper";
    CountryCodeMainWrapper.setAttribute("country-code", 62);
    PhoneNumberInputContainer.append(CountryCodeMainWrapper);

    let CountryCodeWrapper = document.createElement("div");
    CountryCodeWrapper.className = "PhoneCodeNumberTextWrapper Selectable3";
    CountryCodeMainWrapper.append(CountryCodeWrapper);

    let CountryCodeText = document.createElement("p");
    CountryCodeText.className = "InterMediumTextFont";
    CountryCodeText.innerHTML = "+62";
    CountryCodeWrapper.append(CountryCodeText);

    let PhoneNumberInputComplete = document.createElement("input");
    PhoneNumberInputComplete.type = "number";
    PhoneNumberInputComplete.className = "InputFieldInsideSmallPanel InputFieldWithButton Selectable3 InterMediumTextFont";
    PhoneNumberInputComplete.placeholder = "81000000";
    PhoneNumberInputComplete.setAttribute("previous-input", '');
    PhoneNumberInputComplete.setAttribute("phone-to-be-used", '');
    PhoneNumberInputContainer.append(PhoneNumberInputComplete);

    let PhoneNumberWarningComplete = document.createElement("p");
    PhoneNumberWarningComplete.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    PhoneNumberWarningComplete.id = "PhoneNumberWarningComplete";
    PhoneNumberWrapper.append(PhoneNumberWarningComplete);


    let CountryWrapper = document.createElement("div"); // Country ------------------------------------
    CountryWrapper.className = "InputFieldMargin";
    CompleteYourProfileContainer.append(CountryWrapper);

    let CountryHeaderText = document.createElement("p");
    CountryHeaderText.className = "InputFieldHeaderText InterMediumTextFont";
    CountryHeaderText.innerHTML = window["CountryHeaderTxt" + window.CurrentCountryID];
    CountryWrapper.append(CountryHeaderText);

    let CountryDropDownContainer = document.createElement("div");
    CountryDropDownContainer.className = "SmallPanelDropDownContainer";
    CountryDropDownContainer.style = "width: 100%; min-width: 100%;";
    CountryWrapper.append(CountryDropDownContainer);

    let CountryDropDownWrapper = document.createElement("div");
    CountryDropDownWrapper.className = "SmallPanelDropDownInputWrapper Selectable3 InterMediumTextFont";
    CountryDropDownContainer.append(CountryDropDownWrapper);

    let CountryDropDownIMG = document.createElement("img");
    CountryDropDownIMG.className = "CircleInsideInputField";
    CountryDropDownIMG.id = "CompleteYourProfileCountryDropDownIcon";
    CountryDropDownIMG.src = "/Assets/images/CountryCode/Indonesia.svg";
    CountryDropDownWrapper.append(CountryDropDownIMG);

    let CountryInput = document.createElement("p");
    CountryInput.className = "MonthInputChangeCurrentSelectedText";
    CountryInput.id = "CompleteYourProfileCountryDropDownText";
    CountryInput.innerHTML = "Indonesia";
    CountryDropDownWrapper.append(CountryInput);

    let CountryInputChevron = document.createElement("img");
    CountryInputChevron.className = "ChevronInsideInput ToggleArrow";
    CountryInputChevron.id = "CompleteYourProfileCountryDropDownChevron";
    CountryInputChevron.src = "/Assets/images/ButtonIcon/chevron.svg";
    CountryInputChevron.style.rotate = "0deg";
    CountryDropDownWrapper.append(CountryInputChevron);


    let IDCardWrapper = document.createElement("div"); // ID Card  ------------------------------------
    IDCardWrapper.className = "InputFieldMargin";
    CompleteYourProfileContainer.append(IDCardWrapper);

    let IDCardHeaderText = document.createElement("p");
    IDCardHeaderText.className = "InputFieldHeaderText InterMediumTextFont";
    IDCardHeaderText.innerHTML = window["IDCardHeaderTxt" + window.CurrentCountryID];
    IDCardWrapper.append(IDCardHeaderText);

    let IDCardDropDown = document.createElement("div");
    IDCardDropDown.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
    IDCardDropDown.style = "width: 100%; min-width: 100%;";
    IDCardWrapper.append(IDCardDropDown);

    let IDCardInputComplete = document.createElement("input");
    IDCardInputComplete.type = "text";
    IDCardInputComplete.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    IDCardInputComplete.placeholder = window["IDCardInputPlaceholder" + window.CurrentCountryID];
    IDCardDropDown.append(IDCardInputComplete);

    let IDCardCompleteYouProfileWarning = document.createElement("p");
    IDCardCompleteYouProfileWarning.className = "RedWarningText InterMediumTextFont RedWarningHidden";
    IDCardCompleteYouProfileWarning.id = "IDCardCompleteYouProfileWarning";
    IDCardWrapper.append(IDCardCompleteYouProfileWarning);


    let SaveProfileButtonWrapper = document.createElement("div"); // Button  ------------------------------------
    SaveProfileButtonWrapper.className = "MoreThanOneButtonFlexWrapper InputFieldMarginBoth";
    SaveProfileButtonWrapper.style = "margin-left: auto; margin-right: auto;";
    CompleteYourProfileContainer.append(SaveProfileButtonWrapper);

    let SaveProfileButton = document.createElement("button");
    SaveProfileButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable";
    SaveProfileButton.innerHTML = window["SaveProfileBtnTxt" + window.CurrentCountryID];
    SaveProfileButtonWrapper.append(SaveProfileButton);

    window.OpenPanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker);

    // Set Function ------------------------------------------------

    let FunctionToCallAfter = function(isallowchange)
    {
        CheckCompleteProfileInfoInputted(isallowchange, UserData.email, useridget, usertoken, RedWarningMainCompleteUser, RedWarningMainCompleteUserText, FirstNameInputContainer, FirstNameInputComplete, FirstNameCompleteYouProfileWarning, LastNameInputContainer, LastNameInputComplete, LastNameCompleteYouProfileWarning,
            GenderFlexContainer, EmailInputContainer, EmailInputComplete, EmailCompleteYouProfileWarning, PhoneNumberInputContainer, CountryCodeMainWrapper, PhoneNumberInputComplete, PhoneNumberWarningComplete,
            CountryDropDownContainer, IDCardDropDown, IDCardInputComplete, IDCardCompleteYouProfileWarning, SaveProfileButton
        );
    }
    
    FirstNameInputComplete.onfocus = function(event) // First Name --------------
    {
        FirstNameInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        FirstNameCompleteYouProfileWarning.className = "RedWarningText InterMediumTextFont RedWarningHidden";
        SaveProfileButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonUnselectable";
    }
    FirstNameInputComplete.addEventListener("focusout", (event) =>
    {
        FunctionToCallAfter(true);
    });


    LastNameInputComplete.onfocus = function(event) // Last Name --------------
    {
        LastNameInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        LastNameCompleteYouProfileWarning.className = "RedWarningText InterMediumTextFont RedWarningHidden";
        SaveProfileButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonUnselectable";
    }
    LastNameInputComplete.addEventListener("focusout", (event) =>
    {
        FunctionToCallAfter(true);
    });


    MaleFlexCheckBoxInput.onchange = function() // Gender --------------
    {
        FunctionToCallAfter(true);
    }
    FemaleFlexCheckBoxInput.onchange = function()
    {
        FunctionToCallAfter(true);
    }


    EmailInputComplete.onfocus = function(event) // Email --------------
    {
        EmailInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        EmailCompleteYouProfileWarning.className = "RedWarningText InterMediumTextFont RedWarningHidden";
        SaveProfileButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonUnselectable";
    }
    EmailInputComplete.addEventListener("focusout", (event) =>
    {
        FunctionToCallAfter(true);
    });


    CountryCodeMainWrapper.onclick = function() // Country Code --------------
    {
        window.OpenCountryCode(CountryCodeMainWrapper, CountryCodeText, "CompleteProfile", ()=> FunctionToCallAfter(true));
    }


    PhoneNumberInputComplete.onfocus = function(event) // Phone Number --------------
    {
        PhoneNumberInputContainer.className = "SmallPanelDropDownContainer";
        PhoneNumberWarningComplete.className = "RedWarningText InterMediumTextFont RedWarningHidden";
        SaveProfileButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonUnselectable";
    }
    PhoneNumberInputComplete.addEventListener("focusout", (event) =>
    {
        if(PhoneNumberInputComplete.getAttribute("previous-input") != PhoneNumberInputComplete.value)
        {
            PhoneNumberInputComplete.setAttribute("previous-input", PhoneNumberInputComplete.value);
            PhoneNumberInputComplete.setAttribute("phone-to-be-used", '');
        }
        
        FunctionToCallAfter(true);
    });


    CountryDropDownContainer.onclick = function() // Country --------------
    {
        window.OpenCountryChoice(CountryDropDownContainer, CountryDropDownIMG, CountryInput, "CompleteYourProfileCountryDropDownChevron", "CompleteProfile", ()=> FunctionToCallAfter(true));
    }


    IDCardInputComplete.onfocus = function(event) // ID Card --------------
    {
        IDCardDropDown.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        IDCardCompleteYouProfileWarning.className = "RedWarningText InterMediumTextFont RedWarningHidden";
        SaveProfileButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonUnselectable";
    }
    IDCardInputComplete.addEventListener("focusout", (event) =>
    {
        FunctionToCallAfter(true);
    });

    // Set Early ---------------------------------------------------

    if(UserData.first_name)
    {
        FirstNameInputComplete.value = UserData.first_name;
        FirstNameInputComplete.readOnly = true;
        FirstNameInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldContainerInvalid";

        LastNameInputComplete.readOnly = true;
        LastNameInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldContainerInvalid";
    }

    if(UserData.last_name)
    {
        LastNameInputComplete.value = UserData.last_name;
    }

    if(UserData.gender == "Female" || UserData.gender == "Wanita")
    {
        FemaleFlexCheckBoxInput.checked = true;
    }
    else
    {
        MaleFlexCheckBoxInput.checked = true;
    }

    if(UserData.email)
    {
        EmailInputComplete.value = UserData.email;
        EmailInputComplete.readOnly = true;
        EmailInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldContainerInvalid";
    }

    if(UserData.ktp_passport)
    {
        IDCardInputComplete.value = UserData.ktp_passport;
        IDCardInputComplete.readOnly = true;
        IDCardDropDown.className = "SmallPanelDropDownContainer BasicInputFieldContainer InputFieldContainerInvalid";
    }


    console.log("UserData", UserData);

    let SelectedCountryCode = UserData.country_code;
    let SelectedOriginCountry = UserData.country;

    if(SelectedCountryCode == "" || SelectedCountryCode == null || SelectedCountryCode == "+")
    {
        SelectedCountryCode = 62;
        SelectedOriginCountry = "Indonesia";
    }

    if(SelectedCountryCode)
    {
        CountryCodeText.value = "+" + SelectedCountryCode; // Country Code Phone Number

        // CountryDropDownContainer.className = "SmallPanelDropDownContainer InputFieldContainerInvalid"; // Current Selected Country
        CountryCodeMainWrapper.onclick = function(){};

        for (let i = 0; i < window.CountryListCode.length; i++)
        {
            if (SelectedCountryCode == window.CountryListCode[i].CountryCode)
            {
                CountryCodeMainWrapper.setAttribute("country-code", window.CountryListCode[i].CountryCode);
                CountryCodeText.innerHTML = "+" + window.CountryListCode[i].CountryCode;
            }

            if(SelectedOriginCountry == window.CountryListCode[i].CountryName)
            {
                CountryDropDownIMG.src = window.CountryListCode[i].FlagIcon;
                CountryInput.innerHTML = window.CountryListCode[i].CountryName;
                CountryDropDownContainer.setAttribute("country-selected", window.CountryListCode[i].CountryName);
            }
        }
    }

    if(UserDataPaymentForm.phone_number)
    {
        PhoneNumberInputComplete.value = UserDataPaymentForm.phone_number;
        PhoneNumberInputComplete.readOnly = true;
        PhoneNumberInputComplete.setAttribute("previous-input", UserDataPaymentForm.phone_number);
        PhoneNumberInputComplete.setAttribute("phone-to-be-used", UserDataPaymentForm.phone_number);
        PhoneNumberInputContainer.className = "SmallPanelDropDownContainer InputFieldContainerInvalid";
        CountryCodeMainWrapper.onclick = function () {};
    }

    FunctionToCallAfter(false);
}


function CheckCompleteProfileInfoInputted(allowchange, useremail, useridget, usertoken, RedWarningMainCompleteUser, RedWarningMainCompleteUserText, FirstNameInputContainer, FirstNameInputComplete, FirstNameCompleteYouProfileWarning, LastNameInputContainer, LastNameInputComplete, LastNameCompleteYouProfileWarning, GenderFlexContainer, EmailInputContainer, EmailInputComplete, EmailCompleteYouProfileWarning, PhoneNumberInputContainer, CountryCodeMainWrapper, PhoneNumberInputComplete, PhoneNumberWarningComplete, CountryDropDownContainer, IDCardDropDown, IDCardInputComplete, IDCardCompleteYouProfileWarning, SaveProfileButton)
{
    let IsInputtedValid = true;

    let GenderheckBoxes = GenderFlexContainer.querySelectorAll('input[name="GenderCompleteYourProfile"]');
    let WhichGenderSelected = "Male";
    GenderheckBoxes.forEach(ThisCheckBox =>
    {
        if(ThisCheckBox.checked == true)
        {
            WhichGenderSelected = ThisCheckBox.value;
        }
    });


    // Main Section --------------------------------------------------------------------

    if(FirstNameInputComplete.value == ""  || FirstNameInputComplete.value.replace(/ /g, "") == "") // First Name
    {
        IsInputtedValid = false;

        if(allowchange == true)
        {
            FirstNameInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";
            FirstNameCompleteYouProfileWarning.className = "RedWarningText InterMediumTextFont";
            FirstNameCompleteYouProfileWarning.innerHTML = window["FirstNameCannotEmpty" + window.CurrentCountryID];
        }
    }

    // if(EmailInputComplete.value == ""  || EmailInputComplete.value.replace(/ /g, "") == "") // Email
    // {
    //     IsInputtedValid = false;

    //     if(allowchange == true)
    //     {
    //         EmailInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";
    //         EmailCompleteYouProfileWarning.className = "RedWarningText InterMediumTextFont";
    //         EmailCompleteYouProfileWarning.innerHTML = window["EmailCannotEmpty" + window.CurrentCountryID];
    //     }
    // }
    // else if(window.CheckEmailValidity(EmailInputComplete.value) == false)
    // {
    //     IsInputtedValid = false;

    //     if(allowchange == true)
    //     {
    //         EmailInputContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";
    //         EmailCompleteYouProfileWarning.className = "RedWarningText InterMediumTextFont";
    //         EmailCompleteYouProfileWarning.innerHTML = window["InvalidEmailFormatMes" + window.CurrentCountryID];
    //     }
    // }

    if(PhoneNumberInputComplete.value == ""  || PhoneNumberInputComplete.value.replace(/ /g, "") == "") // Email
    {
        IsInputtedValid = false;

        if(allowchange == true)
        {
            PhoneNumberInputContainer.className = "SmallPanelDropDownContainer InputFieldWarningOutline";
            PhoneNumberWarningComplete.className = "RedWarningText InterMediumTextFont";
            PhoneNumberWarningComplete.innerHTML = window["PhoneNumberCannotEmpty" + window.CurrentCountryID];
        }
    }
    else
    {
        if(PhoneNumberInputComplete.getAttribute("phone-to-be-used") == "")
        {
            window.CheckPhoneNumberAlreadyUsed(useridget, CountryCodeMainWrapper.getAttribute("country-code"), PhoneNumberInputComplete.value, true, function(result, reasoninvalid)
            {
                if(result == false)
                {
                    IsInputtedValid = false;
                    PhoneNumberInputContainer.className = "SmallPanelDropDownContainer InputFieldWarningOutline";
                    PhoneNumberWarningComplete.className = "RedWarningText InterMediumTextFont";
                    PhoneNumberWarningComplete.innerHTML = window["PhoneNumberInvalidTxt" + window.CurrentCountryID];
                    if(reasoninvalid == "Already Used" || reasoninvalid == "Already used")
                    {
                        PhoneNumberWarningComplete.innerHTML = window["PhoneNumberAlreadyUsedTxt" + window.CurrentCountryID];
                    }
                    SaveProfileButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonUnselectable";
                }
                else
                {
                    PhoneNumberInputComplete.setAttribute("phone-to-be-used", PhoneNumberInputComplete.value);
                }
            });
        }
    }

    if(IDCardInputComplete.value == ""  || IDCardInputComplete.value.replace(/ /g, "") == "") // ID Card
    {
        IsInputtedValid = false;

        if(allowchange == true)
        {
            IDCardDropDown.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";
            IDCardCompleteYouProfileWarning.className = "RedWarningText InterMediumTextFont";
            IDCardCompleteYouProfileWarning.innerHTML = window["IDCardCannotEmpty" + window.CurrentCountryID];
        }
    }
    else
    {
        window.CheckIDCardUsed(useridget, IDCardInputComplete.value, true, function(result, reasoninvalid)
        {
            if(result == false)
            {
                IsInputtedValid = false;
                IDCardCompleteYouProfileWarning.className = "RedWarningText InterMediumTextFont";
                IDCardCompleteYouProfileWarning.innerHTML = window["IDCardCannotEmpty" + window.CurrentCountryID];
                if(reasoninvalid == "Already Used" || reasoninvalid == "Already used")
                {
                    IDCardCompleteYouProfileWarning.innerHTML = window["IDCardCannotBeUsed" + window.CurrentCountryID];
                }
                SaveProfileButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonUnselectable";
            }
        });
    }

    // If All Valid -------------------------------------------
    SaveProfileButton.onclick = function(){};
    
    if(IsInputtedValid == true)
    {
        SaveProfileButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton Selectable";
        SaveProfileButton.onclick = function()
        {
            (async () =>
            {
                let PushUserInfoBlocker = window.InstantiateLoadingBlocker("PushUserInfoBlocker");

                // Country ------------------------------------------------------------------------------------------------------------
                let CountryInput = CountryDropDownContainer.getAttribute("country-selected");


                let formData = new FormData();
                formData.append('first_name', FirstNameInputComplete.value);
                formData.append('last_name', LastNameInputComplete.value);
                formData.append('gender', WhichGenderSelected);
                formData.append('email', useremail);
                formData.append('country_code', CountryCodeMainWrapper.getAttribute("country-code"));
                formData.append('phone_number', PhoneNumberInputComplete.value);
                formData.append("country", CountryInput);
                formData.append('id_card', IDCardInputComplete.value);
                formData.append('lang', window.CurrentCountryID);
                formData.append("token", usertoken);
                await window.getBrowserData(formData);
                

                let PushProfileURL = "/v2/profile/" + useridget;
                console.log(PushProfileURL);
                console.log(window.ConvertFormDataToJSON(formData));

                window.CallApiAxios({
                    method: "PUT",
                    url: PushProfileURL,
                    data: formData
                }).then(res =>
                {
                    console.log(PushProfileURL);
                    console.log(res);
                    
                    if(res.status == 200)
                    {
                        RedWarningMainCompleteUser.style.display = "";
                        RedWarningMainCompleteUserText.innerHTML = window["WarningUpdateUserDataSuccess" + window.CurrentCountryID];

                        if(sessionStorage.getItem("IM_Ping_INFO") != null)
                            sessionStorage.removeItem("IM_Ping_INFO");

                        if(sessionStorage.getItem("U_Ping_INFO") != null)
                            sessionStorage.removeItem("U_Ping_INFO");
                        
                        window.location.reload();
                    }
                })
                .catch(err =>
                {
                    console.error(err);
                    
                    RedWarningMainCompleteUser.style.display = "";
                    if(err.data.message != null)
                    {
                        if(err.data.message == "User not found")
                        {
                            RedWarningMainCompleteUserText.innerHTML = window["UserNotFoundTxt" + window.CurrentCountryID];
                        }
                        else
                        {
                            RedWarningMainCompleteUserText.innerHTML = window["ErrorWhenUpdatingUserInfo" + window.CurrentCountryID];
                        }
                    }
                    else
                    {
                        RedWarningMainCompleteUserText.innerHTML = window["BasicErrorMes" + window.CurrentCountryID];
                    }

                    PushUserInfoBlocker.remove();
                });
            })();
        }
    }
    else
    {
        SaveProfileButton.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton ButtonUnselectable";
    }
}


// ========================================== CONTINUE BOOKING ================================================

function ContinueBookingPrepare(MainSession, loggedin, IDUserToSend)
{
    let LoadingBlocker = window.InstantiateLoadingBlocker("ContinueBookingBlocker");

    if(loggedin == true && IDUserToSend != null && window.IsPanelAnimating == false)
    {
        window.IsPanelAnimating = true;

        // Animate To Select Payment --------------------------------------------------

        // StepNameCurrent = "Input Form";
        window.CurrentFinalAnimatedPanel = InputInfoPaymentContainer;

        // Early Loading Instanatiate -------------------------------------------------

        GuestNameText.className = "BasicInputTextTop InterBoldTextFont loading_grey";
        GuestNameText.style.color = "transparent";

        GuestEmailText.className = "SmallerRoomDescriptionText InterRegularTextFont loading_grey";
        GuestEmailText.style.color = "transparent";

        GuestPhoneNumberText.className = "SmallerRoomDescriptionText InterRegularTextFont loading_grey";
        GuestPhoneNumberText.style.color = "transparent";

        // Load Booking Details -------------------------------------------------

        let CheckMaintenanceStatusBlocker = window.InstantiateLoadingBlocker("CheckMaintenanceStatusBlocker");

        CheckAndUpdateMaintenancePaymentMethod(()=>
        {
            let BookingDetailsURL = "/v2/bookings/" + window.ContinueBookingRef;

            window.CallApiAxios({
                method: "GET",
                url: BookingDetailsURL,
            }).then(res =>
            {
                console.log(BookingDetailsURL);
                console.log(res);
                CheckMaintenanceStatusBlocker.remove();

                if(res.status == 200)
                {
                    window.PushbookingData = res.data.data;
                    window.BookingDetailsData = window.PushbookingData;
                    console.log("Booking Data-----------------------")
                    console.log(window.PushbookingData);

                    if(IDUserToSend == window.PushbookingData.user.id_user)
                    {
                        window.CheckInDateNonTop = window.PushbookingData.date_checkin;
                        window.CheckOutDateNonTop = window.PushbookingData.date_checkout;
                        window.RoomQuotaNonTop = window.PushbookingData.total_room;
                        window.HotelDetails = window.PushbookingData.hotel;
                        window.CurrentSelectedRoomID = window.PushbookingData.booking_details[0].room_ping.id_hotel_room;

                        // Basic Hotel Info --------------------------------------------------------------------

                        InstantiateBasicInformation(MainSession, loggedin);

                        // Guest Info --------------------------------------------------------------------------

                        GuestNameText.className = "BasicInputTextTop InterBoldTextFont";
                        GuestNameText.style.color = "";
                        GuestNameText.innerHTML = window.PushbookingData.name_customer;

                        GuestEmailText.className = "SmallerRoomDescriptionText InterRegularTextFont";
                        GuestEmailText.style.color = "rgb(37, 37, 37)";
                        GuestEmailText.innerHTML = window.PushbookingData.user.email;

                        GuestPhoneNumberText.className = "SmallerRoomDescriptionText InterRegularTextFont";
                        GuestPhoneNumberText.style.color = "rgb(37, 37, 37)";
                        GuestPhoneNumberText.innerHTML = "+" + window.PushbookingData.user.country_code + window.PushbookingData.user.phone_number;


                        // Check In ----------------------------------------------------------------------------

                        if(window.CheckInNonTopInput != null && window.CheckInNonTopInputText != null)
                        {
                            let CheckInInfoArray = window.CheckInDateNonTop.split("-");
                            let CheckInInfoYear = parseInt(CheckInInfoArray[0]);
                            let CheckInInfoMonth = parseInt(CheckInInfoArray[1]);
                            let CheckInInfoDate = parseInt(CheckInInfoArray[2]);

                            window.CheckInNonTopInput.setAttribute("Date", CheckInInfoDate);
                            window.CheckInNonTopInput.setAttribute("Month", CheckInInfoMonth);
                            window.CheckInNonTopInput.setAttribute("Year", CheckInInfoYear);

                            window.CheckInNonTopInputText.innerHTML = CheckInInfoDate + " " + window["monthNames" + window.CurrentCountryID][CheckInInfoMonth-1] + " " + CheckInInfoYear;
                        }

                        // Check Out ----------------------------------------------------------------------------

                        if(window.CheckOutNonTopInput != null && window.CheckOutNonTopInputText != null)
                        {
                            let CheckOutInfoArray = window.CheckOutDateNonTop.split("-");
                            let CheckOutInfoYear = parseInt(CheckOutInfoArray[0]);
                            let CheckOutInfoMonth = parseInt(CheckOutInfoArray[1]);
                            let CheckOutInfoDate = parseInt(CheckOutInfoArray[2]);

                            window.CheckOutNonTopInput.setAttribute("Date", CheckOutInfoDate);
                            window.CheckOutNonTopInput.setAttribute("Month", CheckOutInfoMonth);
                            window.CheckOutNonTopInput.setAttribute("Year", CheckOutInfoYear);

                            window.CheckOutNonTopInputText.innerHTML = CheckOutInfoDate + " " + window["monthNames" + window.CurrentCountryID][CheckOutInfoMonth-1] + " " + CheckOutInfoYear;
                        }

                        // Original Price And Saved ----------------------------------------

                        window.InstantiateBookingPaymentData();

                        // Remove Loading And Display Hidden -----------------------------------------

                        PriceGreyLoading.forEach(ThisLoading =>
                        {
                            ThisLoading.style.display = "none";
                        });

                        TextToDisplayAfterCalc.forEach(ThisText =>
                        {
                            ThisText.style.display = "";
                        });

                        DownPaymentPercText.forEach(ThisText =>
                        {
                            ThisText.style.display = "";
                        });

                        // Change Button Function -----------------------------------------------------------

                        DownPaymentPriceCalculated = window.BookingDetailsData.down_payment;

                        if(window.PushbookingData.payment_method == null) // If No Payment Method Selected --------------------------
                        {
                            let CurrentBookingFormData = new FormData();

                            // CurrentBookingFormData.append('id_hotel', window.PushbookingData.id_hotel);
                            // CurrentBookingFormData.append('id_hotel_room', window.PushbookingData.booking_details[0].room_ping.id_hotel_room);
                            // CurrentBookingFormData.append('checkin', window.PushbookingData.date_checkin);
                            // CurrentBookingFormData.append('checkout', window.PushbookingData.date_checkout);
                            // CurrentBookingFormData.append('rooms', window.PushbookingData.total_room);
                            // CurrentBookingFormData.append('voucher_code', window.PushbookingData.voucher_bookings);
                            // CurrentBookingFormData.append('referral_code', window.PushbookingData.id_hotel);
                            // let IsSmokingRoom = "Yes";
                            // if(window.PushbookingData.room_preference == "Non Smoking Room")
                            //     IsSmokingRoom = "No";

                            // CurrentBookingFormData.append('smoking', IsSmokingRoom);
                            // CurrentBookingFormData.append('lang', window.CurrentCountryID);

                            PreviousBookingFound(()=>
                            {
                                document.getElementById("ConfirmNPayButton").onclick = function()
                                {
                                    let ImmediatePushBlocker = window.InstantiateLoadingBlocker("ImmediatePushBlocker");
                                    PushThePaymentBasedOnSelectedMethod(window.PushbookingData, ImmediatePushBlocker)
                                }

                                // Change to Select Payment ---------------------------------------------------------
                                window.ChangeToSectionPaymentForm("Select Payment", true, ()=>
                                {
                                    LoadingBlocker.remove();
                                });
                                // Set Button and Transition To Payment Choice --------------------------------------------
                                // PreparePaymentMethodSection(CurrentBookingFormData, MainSession, loggedin, GoToSelectPaymentBlocker);
                                // 
                            }, LoadingBlocker, window.PushbookingData.booking_reference, true);
                        }
                        else
                        {
                            IfPrevBookingExistApplyFunction(LoadingBlocker, false, MainSession, loggedin)
                        }
                        
                        // EarlyDetermineAfterGetOrPushBooking(LoadingBlocker, false);

                    }
                    else
                    {
                        window.location.href = "/";
                    }
                }
            })
            .catch(err =>
            {
                console.error(err);
                window.IsPanelAnimating = false;
                CheckMaintenanceStatusBlocker.remove();
            });
        })
    }
    else
    {
        window.location.href = "/";
    }
}


// ===================================== MAINTENANCE =================================

var MaintenanceSchedule =
[
    {
        "name":"MaintenanceOttoPay",
        "start-date":"22-05-2026",
        "start-time":"23:00",
        "end-date":"23-05-2026",
        "end-time":"6:00",
        "which_payment":
        [
            {
                "defaultValue":"QRIS",
                "which-type":"Instant Payment"
            }
        ]

    }
]

// function CheckAndUpdateMaintenancePaymentMethod()
// {
//     let WhatDayIsToday = window.GetAndConvertCurrentDate(false);
//     console.log("WhatDayIsToday", WhatDayIsToday);

//     for(let i = 0; i < MaintenanceSchedule.length; i++)
//     {
//         let StartDateArray = []
//         let StartDateAndTime = [];
        
//         for(let j = 0; j < PaymentMethodButton.length; j++)
//         {
//             let ThisRadioButton = PaymentMethodButton[j].querySelector('input[type=radio]');
//             if(MaintenanceSchedule == ThisRadioButton.value && window.WhichPaymentTypeSelected == ThisRadioButton.getAttribute("which-type"))
//             {
//                 WaitingPaymentLogoAndNameContainer.innerHTML = "";

//                 let WhichIcon = Button.querySelector('.ThisPaymentMethodIcon');
//                 let ClonedIcon = WhichIcon.cloneNode(true);
                
//                 WaitingPaymentLogoAndNameContainer.append(ClonedIcon);

//                 let SelectedPaymentText = document.createElement("p");
//                 SelectedPaymentText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
//                 SelectedPaymentText.style.color = "white";
//                 SelectedPaymentText.style.margin = "auto 0";
//                 SelectedPaymentText.innerHTML = Button.querySelector('.LabelGreyHeaderSmallerText').innerHTML
//                 WaitingPaymentLogoAndNameContainer.append(SelectedPaymentText);
//             }
//         }
//     }
// }

function CheckAndUpdateMaintenancePaymentMethod(functiontocall)
{
    RestorePaymentMethodButton();

    let URLCheckMaintenance = "/v2/payments/maintenance";
    
    window.CallApiAxios({
        method: "GET",
        url: URLCheckMaintenance
    }).then(res =>
    {
        let CheckPaymentMaintenanceData = res.data;
        console.log(URLCheckMaintenance);
        console.log(res);
        console.log(CheckPaymentMaintenanceData);

        if(res.status == 200 && CheckPaymentMaintenanceData.is_maintenance == true) // If Maintenance True ------------------------------------
        {
            let MaintenancePaymentList = CheckPaymentMaintenanceData.data;
            console.log(MaintenancePaymentList);

            HideAllPaymentButtonThatMaintenance(MaintenancePaymentList);
        }

        if(functiontocall != null)
            functiontocall();
    })
    .catch(err =>
    {
        console.log(URLCheckMaintenance);
        console.error(err);
        
        if(functiontocall != null)
            functiontocall();
    });
}


function HideAllPaymentButtonThatMaintenance(thismaintenancedata)
{
    let PaymentChoiceWrapper = PaymentChooseForm.querySelectorAll('.PaymentChoiceWrapper');

    for(let i = 0; i < thismaintenancedata.length; i++) // This Maintenance -------------------------------------
    {
        for(let j = 0; j < PaymentChoiceWrapper.length; j++) // Payment Choice Wrapper -------------------------------------
        {
            let ThisWrapperPaymentButton = PaymentChoiceWrapper[j].querySelectorAll('.PaymentMethodButton');
            
            if(ThisWrapperPaymentButton.length > 0) // If At Least There's at Least Payment Button Available Inside The Container ----------------------------
            {
                let HowManyHide = 0;

                for(let x = 0; x < ThisWrapperPaymentButton.length; x++) // Payment Choice Button -------------------------------------
                {
                    let ThisRadioButton = ThisWrapperPaymentButton[x].querySelector('input[type=radio]');

                    if(thismaintenancedata[i].bank == ThisRadioButton.getAttribute("bank") && thismaintenancedata[i].payment_method == ThisRadioButton.getAttribute("payment_method"))
                    {
                        HowManyHide++;
                        ThisWrapperPaymentButton[x].style.display = "none";
                    }
                }

                // If All Payment Method Inside The Wrapper Hide, then Hid The Container --------------------------------------
                if(HowManyHide == ThisWrapperPaymentButton.length)
                {
                    PaymentChoiceWrapper[j].style.display = "none";
                }
            }
        }
    }
}

function RestorePaymentMethodButton()
{
    let PaymentChoiceWrapper = PaymentChooseForm.querySelectorAll('.PaymentChoiceWrapper');

    for(let i = 0; i < PaymentChoiceWrapper.length; i++) // This Maintenance -------------------------------------
    {
        let ThisWrapperPaymentButton = PaymentChoiceWrapper[i].querySelectorAll('.PaymentMethodButton');

        for(let j = 0; j < ThisWrapperPaymentButton.length; j++)
        {
            ThisWrapperPaymentButton[j].style.display = "";
        }
    }
}
